/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { useInfiniteQuery, useMutation, useQuery } from "@tanstack/react-query";

import { orvalClient } from "../index";
import type {
  AIDoctorDiagnosisProgressionRequest,
  AIDoctorIntakeStep,
  AIDoctorRxRenewalProgressionRequest,
  AccessEligibilityStatusResponse,
  AccessEnrollmentProgressionRequest,
  AdvanceProgressionRequest,
  AffiliateRequest,
  AffiliateResponse,
  AffiliationStatusResponse,
  AgeVerificationStatusResponse,
  AnonymousUserResponse,
  AudioMessageRequest,
  BackProgressionRequest,
  BillingPortalSessionResponse,
  BodyParsePrescriptionImageAiDoctorPrescriptionParsePost,
  BodyUploadAttachmentsChatAttachmentsPost,
  BridgePayerSearchResult,
  CarePlanContentWithSender,
  CarePlanListItem,
  CareTeamResponse,
  CheckPatientResponsibilityWorkflowStatus,
  CheckoutSuccessRequest,
  CheckoutSuccessResponse,
  ClinicRequestModel,
  ClinicRequirementsResponse,
  ClinicalElementsResponse,
  CloseClinicRequestRequest,
  CloseConversationRequest,
  CompleteOnboardingRequest,
  CompleteSigninRequest,
  ConsentRequest,
  ConversationGroupResponse,
  ConversationGroupsResponse,
  ConversationResponse,
  ConversationTraceMetadataResponse,
  ConversationsResponse,
  CreateConversationRequest,
  CreateConversationResponse,
  CreateCuraiVisitAsyncRequest,
  CreateCuraiVisitRequest,
  CreateCuraiVisitResponse,
  CreateEligibilityConversationRequest,
  CreateRxEligibilityConversationChatRxEligibilityPost200,
  CuraiPatientStatusResponse,
  DefaultVisitProgressionRequest,
  DeleteClinicalDataElementsRequest,
  EntitlementState,
  FetchRxHistoryWorkflowStatus,
  FrontendSideEffectEvent,
  GetACCESSEligibilityStatusAccessEligibilityGetParams,
  GetAIDoctorStepAiDoctorStepGetParams,
  GetAllConversationsChatGetParams,
  GetAvailabilityZocdocAvailabilityGetParams,
  GetBraintrustTraceMetadataForAClinicRequestClinicRequestClinicRequestIdTraceMetadataGetParams,
  GetClinicVisitRequirementsClinicRequirementsGetParams,
  GetConversationCareplanChatConversationIdCareplanGetParams,
  GetConversationChatConversationIdGetParams,
  GetConversationGroupConversationGroupsConversationGroupIdGetParams,
  GetConversationGroupsConversationGroupsGetParams,
  GetInsuranceCarriersZocdocInsuranceCarriersGetParams,
  GetInsurancePlansZocdocInsurancePlansGetParams,
  GetLandingSuggestionsSuggestionsLandingGetParams,
  GetPatientOrderHistoryClinicOrdersGetParams,
  GetPatientResponsibilityStatusInsurancePatientResponsibilityGetParams,
  GetPreClinicStepsClinicPreClinicStepsGetParams,
  GetProvidersZocdocProvidersGetParams,
  GetStatusOfEncounterAssociatedWithCuraiVisitClinicVisitConversationIdStatusGetParams,
  GetVideoVisitRecordingConsentClinicVideoVisitConsentGetParams,
  GetVisitOptionsForAFlowUserProgressionFlowsFlowNameVisitOptionsGetParams,
  HTTPValidationError,
  IncomingEventModel,
  IncomingOutreachModel,
  InsuranceCardExtractionRequest,
  InsuranceCardReaderOutput,
  LandingSuggestionResponse,
  LinkClassicAccountRequest,
  LinkClassicAccountResponse,
  MedicareCardReaderOutput,
  MemoryResponse,
  MergeStatusResponse,
  NotificationPreferencesRequest,
  OutboundDocumentResponse,
  PartnerPostRegistrationProgressionRequest,
  PatientOrderHistoryResponse,
  PaymentDestinationRequest,
  PaymentDestinationResponse,
  PaywallAsyncVisitProgressionRequest,
  PaywallVisitProgressionRequest,
  PharmacyLocation,
  PharmacySearchRequest,
  PreAsyncProgressionRequest,
  PreClinicStepsResponse,
  PrescriptionImageParseResponse,
  ProfileBuilderProgressionRequest,
  ProgramID,
  ProviderEligibilityResponse,
  QuestionnaireDefinition,
  QuestionnaireResponseSubmissionRequest,
  QuestionnaireResponseSubmissionResponse,
  ResolveAUniversalClinicExternalSessionIdToItsCanonicalClinicRequestIdClinicRequestResolveGetParams,
  ResolveExternalSessionResponse,
  ResumeInquiryResponse,
  RxAgentProgressionRequest,
  SaveNotificationToConversationRequest,
  ScheduledNotificationsResponse,
  SearchBridgePayersInsuranceBridgePayersGetParams,
  SendCuraiMessageRequest,
  SendCuraiMessageResponse,
  SendMessageRequest,
  SetActiveMedicationsRequest,
  SinchFaxCompletedWebhook,
  SmsTimelineResponse,
  SmsTimelineSendRequest,
  StagePaywallAsyncVisitUserProgressionFlowManualTestPaywallAsyncVisitNoriConversationIdPostParams,
  StartVerificationResponse,
  SubjectiveSharebackResponse,
  SubjectiveSharebackUpdateRequest,
  TimeTravelFastForwardRequest,
  TimeTravelFastForwardResponse,
  TimeTravelResponse,
  TrackEventRequest,
  UniversalClinicVisitStatusResponse,
  UpdateConversationTraceMetadataRequest,
  UpdateCuraiVisitRequest,
  UpdateEventRequest,
  UpdateUserProgramStatusRequest,
  UploadAttachmentsResponse,
  UserProfileMissingResponse,
  UserProfileRequest,
  UserProfileResponse,
  UserProgramResponse,
  UserProgressionStateModel,
  VideoVisitConsentRequest,
  VideoVisitConsentResponse,
  VideoVisitTokenRequest,
  VideoVisitTokenResponse,
  VisitOptionsResponse,
  VitalsRequest,
  VoiceTranscriptionRequest,
  VoiceTranscriptionResponse,
  WaitTimeResponse,
  ZipcodeValidationRequest,
  ZipcodeValidationResponse,
  ZocdocAvailabilityResult,
  ZocdocInsuranceCarrier,
  ZocdocInsurancePlansPage,
  ZocdocProviderResult,
  ZocdocProviderReviews,
} from "./models";

const withQueryKey = <T extends object, K>(
  query: T,
  queryKey: K,
): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === "queryKey") continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * Whether CMS considers the user eligible to be aligned to us for an ACCESS Model track.
 *
 * Serves this attempt's recorded check, starting one when it has none; a corrected identity
 * detail rechecks.
 * @summary Get Access Eligibility Status
 */
export const getAccessEligibilityStatus = (
  params: GetACCESSEligibilityStatusAccessEligibilityGetParams,
  signal?: AbortSignal,
) => {
  return orvalClient<AccessEligibilityStatusResponse>({
    url: `/access/eligibility`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetAccessEligibilityStatusQueryKey = (
  params?: GetACCESSEligibilityStatusAccessEligibilityGetParams,
) => {
  return [`/access/eligibility`, ...(params ? [params] : [])] as const;
};

export const getGetAccessEligibilityStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof getAccessEligibilityStatus>>,
  TError = HTTPValidationError,
>(
  params: GetACCESSEligibilityStatusAccessEligibilityGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAccessEligibilityStatus>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAccessEligibilityStatusQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAccessEligibilityStatus>>
  > = ({ signal }) => getAccessEligibilityStatus(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAccessEligibilityStatus>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetACCESSEligibilityStatusAccessEligibilityGetQueryResult =
  NonNullable<Awaited<ReturnType<typeof getAccessEligibilityStatus>>>;
export type GetACCESSEligibilityStatusAccessEligibilityGetQueryError =
  HTTPValidationError;

export function useGetAccessEligibilityStatus<
  TData = Awaited<ReturnType<typeof getAccessEligibilityStatus>>,
  TError = HTTPValidationError,
>(
  params: GetACCESSEligibilityStatusAccessEligibilityGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAccessEligibilityStatus>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAccessEligibilityStatus>>,
          TError,
          Awaited<ReturnType<typeof getAccessEligibilityStatus>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAccessEligibilityStatus<
  TData = Awaited<ReturnType<typeof getAccessEligibilityStatus>>,
  TError = HTTPValidationError,
>(
  params: GetACCESSEligibilityStatusAccessEligibilityGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAccessEligibilityStatus>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAccessEligibilityStatus>>,
          TError,
          Awaited<ReturnType<typeof getAccessEligibilityStatus>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAccessEligibilityStatus<
  TData = Awaited<ReturnType<typeof getAccessEligibilityStatus>>,
  TError = HTTPValidationError,
>(
  params: GetACCESSEligibilityStatusAccessEligibilityGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAccessEligibilityStatus>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Access Eligibility Status
 */

export function useGetAccessEligibilityStatus<
  TData = Awaited<ReturnType<typeof getAccessEligibilityStatus>>,
  TError = HTTPValidationError,
>(
  params: GetACCESSEligibilityStatusAccessEligibilityGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAccessEligibilityStatus>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetAccessEligibilityStatusQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Refreshes the user's partner affiliation and reports a structured outcome
 * alongside the user's current affiliation state. Clients drive UI directly
 * off the outcome — no follow-up status fetch needed.
 *
 * Branches on whether the request carries a partner_intent:
 * - With membership intent: targets the partner service's /affiliate endpoint
 *   for that partner; failure to claim emits ``remediation_needed``.
 * - With marketplace intent: targets the partner service's /affiliate endpoint
 *   but emits ``nothing_found`` on failure (marketplace affiliations don't
 *   surface a remediation UI — they're affiliated in the sign-in/onboarding
 *   flows instead).
 * - Without partner_intent: broad-matches via /affiliation/match and claims
 *   newly-discovered membership affiliations.
 *
 * Pre-checks the current affiliation state to short-circuit when the user is
 * already affiliated, avoiding unnecessary partner-service calls.
 * @summary Affiliate
 */
export const affiliate = (
  affiliateRequest?: AffiliateRequest,
  signal?: AbortSignal,
) => {
  return orvalClient<AffiliateResponse>({
    url: `/affiliate`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: affiliateRequest,
    signal,
  });
};

export const getAffiliateMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof affiliate>>,
    TError,
    { data?: AffiliateRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof affiliate>>,
  TError,
  { data?: AffiliateRequest },
  TContext
> => {
  const mutationKey = ["affiliate"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof affiliate>>,
    { data?: AffiliateRequest }
  > = (props) => {
    const { data } = props ?? {};

    return affiliate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AffiliateAffiliatePostMutationResult = NonNullable<
  Awaited<ReturnType<typeof affiliate>>
>;
export type AffiliateAffiliatePostMutationBody = AffiliateRequest | undefined;
export type AffiliateAffiliatePostMutationError = HTTPValidationError;

/**
 * @summary Affiliate
 */
export const useAffiliate = <TError = HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof affiliate>>,
      TError,
      { data?: AffiliateRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof affiliate>>,
  TError,
  { data?: AffiliateRequest },
  TContext
> => {
  return useMutation(getAffiliateMutationOptions(options), queryClient);
};

/**
 * @summary Get Ai Doctor Step
 */
export const getAiDoctorStep = (
  params: GetAIDoctorStepAiDoctorStepGetParams,
  signal?: AbortSignal,
) => {
  return orvalClient<AIDoctorIntakeStep | null>({
    url: `/ai-doctor/step`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetAiDoctorStepQueryKey = (
  params?: GetAIDoctorStepAiDoctorStepGetParams,
) => {
  return [`/ai-doctor/step`, ...(params ? [params] : [])] as const;
};

export const getGetAiDoctorStepQueryOptions = <
  TData = Awaited<ReturnType<typeof getAiDoctorStep>>,
  TError = HTTPValidationError,
>(
  params: GetAIDoctorStepAiDoctorStepGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAiDoctorStep>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAiDoctorStepQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAiDoctorStep>>> = ({
    signal,
  }) => getAiDoctorStep(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAiDoctorStep>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAIDoctorStepAiDoctorStepGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAiDoctorStep>>
>;
export type GetAIDoctorStepAiDoctorStepGetQueryError = HTTPValidationError;

export function useGetAiDoctorStep<
  TData = Awaited<ReturnType<typeof getAiDoctorStep>>,
  TError = HTTPValidationError,
>(
  params: GetAIDoctorStepAiDoctorStepGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAiDoctorStep>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAiDoctorStep>>,
          TError,
          Awaited<ReturnType<typeof getAiDoctorStep>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAiDoctorStep<
  TData = Awaited<ReturnType<typeof getAiDoctorStep>>,
  TError = HTTPValidationError,
>(
  params: GetAIDoctorStepAiDoctorStepGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAiDoctorStep>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAiDoctorStep>>,
          TError,
          Awaited<ReturnType<typeof getAiDoctorStep>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAiDoctorStep<
  TData = Awaited<ReturnType<typeof getAiDoctorStep>>,
  TError = HTTPValidationError,
>(
  params: GetAIDoctorStepAiDoctorStepGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAiDoctorStep>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Ai Doctor Step
 */

export function useGetAiDoctorStep<
  TData = Awaited<ReturnType<typeof getAiDoctorStep>>,
  TError = HTTPValidationError,
>(
  params: GetAIDoctorStepAiDoctorStepGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAiDoctorStep>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetAiDoctorStepQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Kick off a Temporal workflow to fetch and filter the user's medication history
 * from Dosespot. Returns immediately with an in-progress status.
 *
 * The workflow will:
 * 1. Build UniversalClinicPatient from UserProfile and create/update the patient
 *    in the clinic system, receiving back a patient_id
 * 2. Request consent from Dosespot using the patient_id
 * 3. Fetch the medication history (polling until results are ready)
 * 4. Filter medications to remove ineligible entries
 *
 * Poll GET /ai-doctor/rx-history to retrieve the final results.
 * @summary Fetch Medication History
 */
export const fetchMedicationHistory = (signal?: AbortSignal) => {
  return orvalClient<FetchRxHistoryWorkflowStatus>({
    url: `/ai-doctor/rx-history/fetch`,
    method: "POST",
    signal,
  });
};

export const getFetchMedicationHistoryMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof fetchMedicationHistory>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof fetchMedicationHistory>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["fetchMedicationHistory"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof fetchMedicationHistory>>,
    void
  > = () => {
    return fetchMedicationHistory();
  };

  return { mutationFn, ...mutationOptions };
};

export type FetchMedicationHistoryAiDoctorRxHistoryFetchPostMutationResult =
  NonNullable<Awaited<ReturnType<typeof fetchMedicationHistory>>>;

export type FetchMedicationHistoryAiDoctorRxHistoryFetchPostMutationError =
  HTTPValidationError;

/**
 * @summary Fetch Medication History
 */
export const useFetchMedicationHistory = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof fetchMedicationHistory>>,
      TError,
      void,
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof fetchMedicationHistory>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getFetchMedicationHistoryMutationOptions(options),
    queryClient,
  );
};

/**
 * Return the current status of the medication history fetch workflow.
 *
 * - While the workflow is running, returns `{"status": "in_progress"}`.
 * - On completion, returns `{"status": "completed", "medications": [...]}`.
 * - On failure, returns `{"status": "failed", "error": "..."}`.
 * - If the workflow history is nondeterministic, restarts it and returns in progress.
 * - If no workflow has been started for this user, returns 404.
 * @summary Get Medication History Status
 */
export const getMedicationHistoryStatus = (signal?: AbortSignal) => {
  return orvalClient<FetchRxHistoryWorkflowStatus>({
    url: `/ai-doctor/rx-history`,
    method: "GET",
    signal,
  });
};

export const getGetMedicationHistoryStatusQueryKey = () => {
  return [`/ai-doctor/rx-history`] as const;
};

export const getGetMedicationHistoryStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof getMedicationHistoryStatus>>,
  TError = HTTPValidationError,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getMedicationHistoryStatus>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMedicationHistoryStatusQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMedicationHistoryStatus>>
  > = ({ signal }) => getMedicationHistoryStatus(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMedicationHistoryStatus>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMedicationHistoryStatusAiDoctorRxHistoryGetQueryResult =
  NonNullable<Awaited<ReturnType<typeof getMedicationHistoryStatus>>>;
export type GetMedicationHistoryStatusAiDoctorRxHistoryGetQueryError =
  HTTPValidationError;

export function useGetMedicationHistoryStatus<
  TData = Awaited<ReturnType<typeof getMedicationHistoryStatus>>,
  TError = HTTPValidationError,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMedicationHistoryStatus>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMedicationHistoryStatus>>,
          TError,
          Awaited<ReturnType<typeof getMedicationHistoryStatus>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetMedicationHistoryStatus<
  TData = Awaited<ReturnType<typeof getMedicationHistoryStatus>>,
  TError = HTTPValidationError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMedicationHistoryStatus>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMedicationHistoryStatus>>,
          TError,
          Awaited<ReturnType<typeof getMedicationHistoryStatus>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetMedicationHistoryStatus<
  TData = Awaited<ReturnType<typeof getMedicationHistoryStatus>>,
  TError = HTTPValidationError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMedicationHistoryStatus>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Medication History Status
 */

export function useGetMedicationHistoryStatus<
  TData = Awaited<ReturnType<typeof getMedicationHistoryStatus>>,
  TError = HTTPValidationError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMedicationHistoryStatus>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetMedicationHistoryStatusQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Start a Temporal workflow to parse a prescription image asynchronously.
 *
 * This endpoint:
 * 1. Validates file size
 * 2. Uploads image to S3
 * 3. Starts a Temporal workflow to parse the prescription
 * 4. Returns immediately with in_progress status
 *
 * Poll GET /ai-doctor/prescription/parse to retrieve results.
 *
 * Returns:
 *     - 202 Accepted with {"status": "in_progress"}
 *     - 200 OK with error for validation failures
 * @summary Parse Prescription Image
 */
export const parsePrescriptionImage = (
  bodyParsePrescriptionImageAiDoctorPrescriptionParsePost: BodyParsePrescriptionImageAiDoctorPrescriptionParsePost,
  signal?: AbortSignal,
) => {
  const formData = new FormData();
  formData.append(
    `image`,
    bodyParsePrescriptionImageAiDoctorPrescriptionParsePost.image,
  );

  return orvalClient<PrescriptionImageParseResponse>({
    url: `/ai-doctor/prescription/parse`,
    method: "POST",
    headers: { "Content-Type": "multipart/form-data" },
    data: formData,
    signal,
  });
};

export const getParsePrescriptionImageMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof parsePrescriptionImage>>,
    TError,
    { data: BodyParsePrescriptionImageAiDoctorPrescriptionParsePost },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof parsePrescriptionImage>>,
  TError,
  { data: BodyParsePrescriptionImageAiDoctorPrescriptionParsePost },
  TContext
> => {
  const mutationKey = ["parsePrescriptionImage"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof parsePrescriptionImage>>,
    { data: BodyParsePrescriptionImageAiDoctorPrescriptionParsePost }
  > = (props) => {
    const { data } = props ?? {};

    return parsePrescriptionImage(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ParsePrescriptionImageAiDoctorPrescriptionParsePostMutationResult =
  NonNullable<Awaited<ReturnType<typeof parsePrescriptionImage>>>;
export type ParsePrescriptionImageAiDoctorPrescriptionParsePostMutationBody =
  BodyParsePrescriptionImageAiDoctorPrescriptionParsePost;
export type ParsePrescriptionImageAiDoctorPrescriptionParsePostMutationError =
  HTTPValidationError;

/**
 * @summary Parse Prescription Image
 */
export const useParsePrescriptionImage = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof parsePrescriptionImage>>,
      TError,
      { data: BodyParsePrescriptionImageAiDoctorPrescriptionParsePost },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof parsePrescriptionImage>>,
  TError,
  { data: BodyParsePrescriptionImageAiDoctorPrescriptionParsePost },
  TContext
> => {
  return useMutation(
    getParsePrescriptionImageMutationOptions(options),
    queryClient,
  );
};

/**
 * Get the current status of the prescription parsing workflow.
 *
 * - While the workflow is running, returns `{"status": "in_progress"}`
 * - On completion, returns `{"status": "completed", "medications": [...]}`
 * - On failure, returns 400 with error message
 * - If no workflow has been started for this user, returns 404
 *
 * Returns:
 *     ParsePrescriptionWorkflowStatus with current workflow state
 * @summary Get Prescription Parse Status
 */
export const getPrescriptionParseStatus = (signal?: AbortSignal) => {
  return orvalClient<PrescriptionImageParseResponse>({
    url: `/ai-doctor/prescription/parse`,
    method: "GET",
    signal,
  });
};

export const getGetPrescriptionParseStatusQueryKey = () => {
  return [`/ai-doctor/prescription/parse`] as const;
};

export const getGetPrescriptionParseStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof getPrescriptionParseStatus>>,
  TError = HTTPValidationError,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getPrescriptionParseStatus>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetPrescriptionParseStatusQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPrescriptionParseStatus>>
  > = ({ signal }) => getPrescriptionParseStatus(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPrescriptionParseStatus>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPrescriptionParseStatusAiDoctorPrescriptionParseGetQueryResult =
  NonNullable<Awaited<ReturnType<typeof getPrescriptionParseStatus>>>;
export type GetPrescriptionParseStatusAiDoctorPrescriptionParseGetQueryError =
  HTTPValidationError;

export function useGetPrescriptionParseStatus<
  TData = Awaited<ReturnType<typeof getPrescriptionParseStatus>>,
  TError = HTTPValidationError,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPrescriptionParseStatus>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPrescriptionParseStatus>>,
          TError,
          Awaited<ReturnType<typeof getPrescriptionParseStatus>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPrescriptionParseStatus<
  TData = Awaited<ReturnType<typeof getPrescriptionParseStatus>>,
  TError = HTTPValidationError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPrescriptionParseStatus>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPrescriptionParseStatus>>,
          TError,
          Awaited<ReturnType<typeof getPrescriptionParseStatus>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPrescriptionParseStatus<
  TData = Awaited<ReturnType<typeof getPrescriptionParseStatus>>,
  TError = HTTPValidationError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPrescriptionParseStatus>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Prescription Parse Status
 */

export function useGetPrescriptionParseStatus<
  TData = Awaited<ReturnType<typeof getPrescriptionParseStatus>>,
  TError = HTTPValidationError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPrescriptionParseStatus>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetPrescriptionParseStatusQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Persist the user's current set of active medications. IDs are resolved
 * against the cached rx_history; manual entries are constructed server-side
 * with negative IDs so they never collide with real Dosespot IDs.
 * @summary Set Active Medications
 */
export const setActiveMedications = (
  setActiveMedicationsRequest: SetActiveMedicationsRequest,
  signal?: AbortSignal,
) => {
  return orvalClient<void>({
    url: `/ai-doctor/active-medications`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: setActiveMedicationsRequest,
    signal,
  });
};

export const getSetActiveMedicationsMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setActiveMedications>>,
    TError,
    { data: SetActiveMedicationsRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof setActiveMedications>>,
  TError,
  { data: SetActiveMedicationsRequest },
  TContext
> => {
  const mutationKey = ["setActiveMedications"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setActiveMedications>>,
    { data: SetActiveMedicationsRequest }
  > = (props) => {
    const { data } = props ?? {};

    return setActiveMedications(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type SetActiveMedicationsAiDoctorActiveMedicationsPostMutationResult =
  NonNullable<Awaited<ReturnType<typeof setActiveMedications>>>;
export type SetActiveMedicationsAiDoctorActiveMedicationsPostMutationBody =
  SetActiveMedicationsRequest;
export type SetActiveMedicationsAiDoctorActiveMedicationsPostMutationError =
  HTTPValidationError;

/**
 * @summary Set Active Medications
 */
export const useSetActiveMedications = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof setActiveMedications>>,
      TError,
      { data: SetActiveMedicationsRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof setActiveMedications>>,
  TError,
  { data: SetActiveMedicationsRequest },
  TContext
> => {
  return useMutation(
    getSetActiveMedicationsMutationOptions(options),
    queryClient,
  );
};

/**
 * @summary Track Event
 */
export const trackEvent = (
  trackEventRequest: TrackEventRequest,
  signal?: AbortSignal,
) => {
  return orvalClient<void>({
    url: `/analytics/track`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: trackEventRequest,
    signal,
  });
};

export const getTrackEventMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof trackEvent>>,
    TError,
    { data: TrackEventRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof trackEvent>>,
  TError,
  { data: TrackEventRequest },
  TContext
> => {
  const mutationKey = ["trackEvent"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof trackEvent>>,
    { data: TrackEventRequest }
  > = (props) => {
    const { data } = props ?? {};

    return trackEvent(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type TrackEventAnalyticsTrackPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof trackEvent>>
>;
export type TrackEventAnalyticsTrackPostMutationBody = TrackEventRequest;
export type TrackEventAnalyticsTrackPostMutationError = HTTPValidationError;

/**
 * @summary Track Event
 */
export const useTrackEvent = <TError = HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof trackEvent>>,
      TError,
      { data: TrackEventRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof trackEvent>>,
  TError,
  { data: TrackEventRequest },
  TContext
> => {
  return useMutation(getTrackEventMutationOptions(options), queryClient);
};

/**
 * Mint a single-use Stripe Customer Portal URL; 404 if the user has no billing account.
 * @summary Create Billing Portal Session
 */
export const createBillingPortalSession = (signal?: AbortSignal) => {
  return orvalClient<BillingPortalSessionResponse>({
    url: `/billing/portal-session`,
    method: "POST",
    signal,
  });
};

export const getCreateBillingPortalSessionMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createBillingPortalSession>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createBillingPortalSession>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["createBillingPortalSession"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createBillingPortalSession>>,
    void
  > = () => {
    return createBillingPortalSession();
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateBillingPortalSessionBillingPortalSessionPostMutationResult =
  NonNullable<Awaited<ReturnType<typeof createBillingPortalSession>>>;

export type CreateBillingPortalSessionBillingPortalSessionPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Billing Portal Session
 */
export const useCreateBillingPortalSession = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createBillingPortalSession>>,
      TError,
      void,
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createBillingPortalSession>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getCreateBillingPortalSessionMutationOptions(options),
    queryClient,
  );
};

/**
 * Upload attachments to S3 and get attachment IDs.
 *
 * Clinic conversations get a larger per-batch size limit.
 * @summary Upload Attachments
 */
export const uploadAttachments = (
  bodyUploadAttachmentsChatAttachmentsPost: BodyUploadAttachmentsChatAttachmentsPost,
  signal?: AbortSignal,
) => {
  const formData = new FormData();
  bodyUploadAttachmentsChatAttachmentsPost.files.forEach((value) =>
    formData.append(`files`, value),
  );
  if (
    bodyUploadAttachmentsChatAttachmentsPost.conversation_id !== undefined &&
    bodyUploadAttachmentsChatAttachmentsPost.conversation_id !== null
  ) {
    formData.append(
      `conversation_id`,
      bodyUploadAttachmentsChatAttachmentsPost.conversation_id,
    );
  }

  return orvalClient<UploadAttachmentsResponse>({
    url: `/chat/attachments`,
    method: "POST",
    headers: { "Content-Type": "multipart/form-data" },
    data: formData,
    signal,
  });
};

export const getUploadAttachmentsMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof uploadAttachments>>,
    TError,
    { data: BodyUploadAttachmentsChatAttachmentsPost },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof uploadAttachments>>,
  TError,
  { data: BodyUploadAttachmentsChatAttachmentsPost },
  TContext
> => {
  const mutationKey = ["uploadAttachments"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof uploadAttachments>>,
    { data: BodyUploadAttachmentsChatAttachmentsPost }
  > = (props) => {
    const { data } = props ?? {};

    return uploadAttachments(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UploadAttachmentsChatAttachmentsPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof uploadAttachments>>
>;
export type UploadAttachmentsChatAttachmentsPostMutationBody =
  BodyUploadAttachmentsChatAttachmentsPost;
export type UploadAttachmentsChatAttachmentsPostMutationError =
  HTTPValidationError;

/**
 * @summary Upload Attachments
 */
export const useUploadAttachments = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof uploadAttachments>>,
      TError,
      { data: BodyUploadAttachmentsChatAttachmentsPost },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof uploadAttachments>>,
  TError,
  { data: BodyUploadAttachmentsChatAttachmentsPost },
  TContext
> => {
  return useMutation(getUploadAttachmentsMutationOptions(options), queryClient);
};

/**
 * Transcribe an audio message and return the transcription
 *
 * Accepts audio file upload, transcribes it using OpenAI Whisper API,
 * and returns the transcribed text.
 * @summary Transcribe Voice Message
 */
export const transcribeVoiceMessage = (
  voiceTranscriptionRequest: VoiceTranscriptionRequest,
  signal?: AbortSignal,
) => {
  const formData = new FormData();
  formData.append(`conversation_id`, voiceTranscriptionRequest.conversation_id);
  formData.append(`audio_file`, voiceTranscriptionRequest.audio_file);

  return orvalClient<VoiceTranscriptionResponse>({
    url: `/chat/transcribe`,
    method: "POST",
    headers: { "Content-Type": "multipart/form-data" },
    data: formData,
    signal,
  });
};

export const getTranscribeVoiceMessageMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof transcribeVoiceMessage>>,
    TError,
    { data: VoiceTranscriptionRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof transcribeVoiceMessage>>,
  TError,
  { data: VoiceTranscriptionRequest },
  TContext
> => {
  const mutationKey = ["transcribeVoiceMessage"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof transcribeVoiceMessage>>,
    { data: VoiceTranscriptionRequest }
  > = (props) => {
    const { data } = props ?? {};

    return transcribeVoiceMessage(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type TranscribeVoiceMessageChatTranscribePostMutationResult =
  NonNullable<Awaited<ReturnType<typeof transcribeVoiceMessage>>>;
export type TranscribeVoiceMessageChatTranscribePostMutationBody =
  VoiceTranscriptionRequest;
export type TranscribeVoiceMessageChatTranscribePostMutationError =
  HTTPValidationError;

/**
 * @summary Transcribe Voice Message
 */
export const useTranscribeVoiceMessage = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof transcribeVoiceMessage>>,
      TError,
      { data: VoiceTranscriptionRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof transcribeVoiceMessage>>,
  TError,
  { data: VoiceTranscriptionRequest },
  TContext
> => {
  return useMutation(
    getTranscribeVoiceMessageMutationOptions(options),
    queryClient,
  );
};

/**
 * @summary Save Notification To Conversation
 */
export const saveNotificationToConversation = (
  saveNotificationToConversationRequest: SaveNotificationToConversationRequest,
  signal?: AbortSignal,
) => {
  return orvalClient<void>({
    url: `/chat/notification`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: saveNotificationToConversationRequest,
    signal,
  });
};

export const getSaveNotificationToConversationMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof saveNotificationToConversation>>,
    TError,
    { data: SaveNotificationToConversationRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof saveNotificationToConversation>>,
  TError,
  { data: SaveNotificationToConversationRequest },
  TContext
> => {
  const mutationKey = ["saveNotificationToConversation"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof saveNotificationToConversation>>,
    { data: SaveNotificationToConversationRequest }
  > = (props) => {
    const { data } = props ?? {};

    return saveNotificationToConversation(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type SaveNotificationToConversationChatNotificationPostMutationResult =
  NonNullable<Awaited<ReturnType<typeof saveNotificationToConversation>>>;
export type SaveNotificationToConversationChatNotificationPostMutationBody =
  SaveNotificationToConversationRequest;
export type SaveNotificationToConversationChatNotificationPostMutationError =
  HTTPValidationError;

/**
 * @summary Save Notification To Conversation
 */
export const useSaveNotificationToConversation = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof saveNotificationToConversation>>,
      TError,
      { data: SaveNotificationToConversationRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof saveNotificationToConversation>>,
  TError,
  { data: SaveNotificationToConversationRequest },
  TContext
> => {
  return useMutation(
    getSaveNotificationToConversationMutationOptions(options),
    queryClient,
  );
};

/**
 * Create a new conversation for the user.
 *
 * When the request names an existing open group, the conversation joins it. This is how a chat
 * resumes after its newest conversation closed. Otherwise a fresh group is opened.
 *
 * A program on the payload stamps an early VISIT clinic request, which enrollment later reuses.
 * Re-entering the same program returns the conversation that already holds its live request,
 * so a second device (or a second click) resumes rather than restarting enrollment.
 * @summary Create Conversation
 */
export const createConversation = (
  createConversationRequestNull?: CreateConversationRequest | null,
  signal?: AbortSignal,
) => {
  return orvalClient<CreateConversationResponse>({
    url: `/chat/`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createConversationRequestNull,
    signal,
  });
};

export const getCreateConversationMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createConversation>>,
    TError,
    { data?: CreateConversationRequest | null },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createConversation>>,
  TError,
  { data?: CreateConversationRequest | null },
  TContext
> => {
  const mutationKey = ["createConversation"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createConversation>>,
    { data?: CreateConversationRequest | null }
  > = (props) => {
    const { data } = props ?? {};

    return createConversation(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateConversationChatPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof createConversation>>
>;
export type CreateConversationChatPostMutationBody =
  | CreateConversationRequest
  | null
  | undefined;
export type CreateConversationChatPostMutationError = HTTPValidationError;

/**
 * @summary Create Conversation
 */
export const useCreateConversation = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createConversation>>,
      TError,
      { data?: CreateConversationRequest | null },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createConversation>>,
  TError,
  { data?: CreateConversationRequest | null },
  TContext
> => {
  return useMutation(
    getCreateConversationMutationOptions(options),
    queryClient,
  );
};

/**
 * Get all conversations for the user.
 * @summary Get All Conversations
 */
export const getAllConversations = (
  params?: GetAllConversationsChatGetParams,
  signal?: AbortSignal,
) => {
  return orvalClient<ConversationsResponse>({
    url: `/chat/`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetAllConversationsInfiniteQueryKey = (
  params?: GetAllConversationsChatGetParams,
) => {
  return ["infinite", `/chat/`, ...(params ? [params] : [])] as const;
};

export const getGetAllConversationsQueryKey = (
  params?: GetAllConversationsChatGetParams,
) => {
  return [`/chat/`, ...(params ? [params] : [])] as const;
};

export const getGetAllConversationsInfiniteQueryOptions = <
  TData = InfiniteData<
    Awaited<ReturnType<typeof getAllConversations>>,
    GetAllConversationsChatGetParams["cursor"]
  >,
  TError = HTTPValidationError,
>(
  params?: GetAllConversationsChatGetParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getAllConversations>>,
        TError,
        TData,
        QueryKey,
        GetAllConversationsChatGetParams["cursor"]
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAllConversationsInfiniteQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAllConversations>>,
    QueryKey,
    GetAllConversationsChatGetParams["cursor"]
  > = ({ signal, pageParam }) =>
    getAllConversations(
      { ...params, cursor: pageParam ?? params?.["cursor"] },
      signal,
    );

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getAllConversations>>,
    TError,
    TData,
    QueryKey,
    GetAllConversationsChatGetParams["cursor"]
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAllConversationsChatGetInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAllConversations>>
>;
export type GetAllConversationsChatGetInfiniteQueryError = HTTPValidationError;

export function useGetAllConversationsInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getAllConversations>>,
    GetAllConversationsChatGetParams["cursor"]
  >,
  TError = HTTPValidationError,
>(
  params: undefined | GetAllConversationsChatGetParams,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getAllConversations>>,
        TError,
        TData,
        QueryKey,
        GetAllConversationsChatGetParams["cursor"]
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllConversations>>,
          TError,
          Awaited<ReturnType<typeof getAllConversations>>,
          QueryKey
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAllConversationsInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getAllConversations>>,
    GetAllConversationsChatGetParams["cursor"]
  >,
  TError = HTTPValidationError,
>(
  params?: GetAllConversationsChatGetParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getAllConversations>>,
        TError,
        TData,
        QueryKey,
        GetAllConversationsChatGetParams["cursor"]
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllConversations>>,
          TError,
          Awaited<ReturnType<typeof getAllConversations>>,
          QueryKey
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAllConversationsInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getAllConversations>>,
    GetAllConversationsChatGetParams["cursor"]
  >,
  TError = HTTPValidationError,
>(
  params?: GetAllConversationsChatGetParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getAllConversations>>,
        TError,
        TData,
        QueryKey,
        GetAllConversationsChatGetParams["cursor"]
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get All Conversations
 */

export function useGetAllConversationsInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getAllConversations>>,
    GetAllConversationsChatGetParams["cursor"]
  >,
  TError = HTTPValidationError,
>(
  params?: GetAllConversationsChatGetParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getAllConversations>>,
        TError,
        TData,
        QueryKey,
        GetAllConversationsChatGetParams["cursor"]
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetAllConversationsInfiniteQueryOptions(
    params,
    options,
  );

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetAllConversationsQueryOptions = <
  TData = Awaited<ReturnType<typeof getAllConversations>>,
  TError = HTTPValidationError,
>(
  params?: GetAllConversationsChatGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAllConversations>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAllConversationsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAllConversations>>
  > = ({ signal }) => getAllConversations(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAllConversations>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAllConversationsChatGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAllConversations>>
>;
export type GetAllConversationsChatGetQueryError = HTTPValidationError;

export function useGetAllConversations<
  TData = Awaited<ReturnType<typeof getAllConversations>>,
  TError = HTTPValidationError,
>(
  params: undefined | GetAllConversationsChatGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAllConversations>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllConversations>>,
          TError,
          Awaited<ReturnType<typeof getAllConversations>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAllConversations<
  TData = Awaited<ReturnType<typeof getAllConversations>>,
  TError = HTTPValidationError,
>(
  params?: GetAllConversationsChatGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAllConversations>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllConversations>>,
          TError,
          Awaited<ReturnType<typeof getAllConversations>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAllConversations<
  TData = Awaited<ReturnType<typeof getAllConversations>>,
  TError = HTTPValidationError,
>(
  params?: GetAllConversationsChatGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAllConversations>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get All Conversations
 */

export function useGetAllConversations<
  TData = Awaited<ReturnType<typeof getAllConversations>>,
  TError = HTTPValidationError,
>(
  params?: GetAllConversationsChatGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAllConversations>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetAllConversationsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Get the most recent care plan associated with a nori conversation
 * @summary Get Conversation Careplan
 */
export const getConversationCareplan = (
  conversationId: string,
  params?: GetConversationCareplanChatConversationIdCareplanGetParams,
  signal?: AbortSignal,
) => {
  return orvalClient<CarePlanContentWithSender | null>({
    url: `/chat/${conversationId}/careplan`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetConversationCareplanQueryKey = (
  conversationId: string,
  params?: GetConversationCareplanChatConversationIdCareplanGetParams,
) => {
  return [
    `/chat/${conversationId}/careplan`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetConversationCareplanQueryOptions = <
  TData = Awaited<ReturnType<typeof getConversationCareplan>>,
  TError = HTTPValidationError,
>(
  conversationId: string,
  params?: GetConversationCareplanChatConversationIdCareplanGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getConversationCareplan>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetConversationCareplanQueryKey(conversationId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getConversationCareplan>>
  > = ({ signal }) => getConversationCareplan(conversationId, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: conversationId !== null && conversationId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getConversationCareplan>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetConversationCareplanChatConversationIdCareplanGetQueryResult =
  NonNullable<Awaited<ReturnType<typeof getConversationCareplan>>>;
export type GetConversationCareplanChatConversationIdCareplanGetQueryError =
  HTTPValidationError;

export function useGetConversationCareplan<
  TData = Awaited<ReturnType<typeof getConversationCareplan>>,
  TError = HTTPValidationError,
>(
  conversationId: string,
  params:
    | undefined
    | GetConversationCareplanChatConversationIdCareplanGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getConversationCareplan>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConversationCareplan>>,
          TError,
          Awaited<ReturnType<typeof getConversationCareplan>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetConversationCareplan<
  TData = Awaited<ReturnType<typeof getConversationCareplan>>,
  TError = HTTPValidationError,
>(
  conversationId: string,
  params?: GetConversationCareplanChatConversationIdCareplanGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getConversationCareplan>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConversationCareplan>>,
          TError,
          Awaited<ReturnType<typeof getConversationCareplan>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetConversationCareplan<
  TData = Awaited<ReturnType<typeof getConversationCareplan>>,
  TError = HTTPValidationError,
>(
  conversationId: string,
  params?: GetConversationCareplanChatConversationIdCareplanGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getConversationCareplan>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Conversation Careplan
 */

export function useGetConversationCareplan<
  TData = Awaited<ReturnType<typeof getConversationCareplan>>,
  TError = HTTPValidationError,
>(
  conversationId: string,
  params?: GetConversationCareplanChatConversationIdCareplanGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getConversationCareplan>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetConversationCareplanQueryOptions(
    conversationId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Create a new conversation for the user and automatically trigger the RX eligibility flow.
 * initial_message should be human- and machine-readable and provide context on which eligibility flow to begin.
 * @summary Create Rx Eligibility Conversation
 */
export const createRxEligibilityConversation = (
  createEligibilityConversationRequest: CreateEligibilityConversationRequest,
  signal?: AbortSignal,
) => {
  return orvalClient<CreateRxEligibilityConversationChatRxEligibilityPost200>({
    url: `/chat/rx-eligibility`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createEligibilityConversationRequest,
    signal,
  });
};

export const getCreateRxEligibilityConversationMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createRxEligibilityConversation>>,
    TError,
    { data: CreateEligibilityConversationRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createRxEligibilityConversation>>,
  TError,
  { data: CreateEligibilityConversationRequest },
  TContext
> => {
  const mutationKey = ["createRxEligibilityConversation"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createRxEligibilityConversation>>,
    { data: CreateEligibilityConversationRequest }
  > = (props) => {
    const { data } = props ?? {};

    return createRxEligibilityConversation(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateRxEligibilityConversationChatRxEligibilityPostMutationResult =
  NonNullable<Awaited<ReturnType<typeof createRxEligibilityConversation>>>;
export type CreateRxEligibilityConversationChatRxEligibilityPostMutationBody =
  CreateEligibilityConversationRequest;
export type CreateRxEligibilityConversationChatRxEligibilityPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Rx Eligibility Conversation
 */
export const useCreateRxEligibilityConversation = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createRxEligibilityConversation>>,
      TError,
      { data: CreateEligibilityConversationRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createRxEligibilityConversation>>,
  TError,
  { data: CreateEligibilityConversationRequest },
  TContext
> => {
  return useMutation(
    getCreateRxEligibilityConversationMutationOptions(options),
    queryClient,
  );
};

/**
 * @summary Send Message
 */
export const sendMessage = (
  conversationId: string,
  sendMessageRequest: SendMessageRequest,
  signal?: AbortSignal,
) => {
  return orvalClient<unknown>({
    url: `/chat/${conversationId}`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: sendMessageRequest,
    signal,
  });
};

export const getSendMessageMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendMessage>>,
    TError,
    { conversationId: string; data: SendMessageRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sendMessage>>,
  TError,
  { conversationId: string; data: SendMessageRequest },
  TContext
> => {
  const mutationKey = ["sendMessage"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sendMessage>>,
    { conversationId: string; data: SendMessageRequest }
  > = (props) => {
    const { conversationId, data } = props ?? {};

    return sendMessage(conversationId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type SendMessageChatConversationIdPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof sendMessage>>
>;
export type SendMessageChatConversationIdPostMutationBody = SendMessageRequest;
export type SendMessageChatConversationIdPostMutationError =
  HTTPValidationError;

/**
 * @summary Send Message
 */
export const useSendMessage = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof sendMessage>>,
      TError,
      { conversationId: string; data: SendMessageRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof sendMessage>>,
  TError,
  { conversationId: string; data: SendMessageRequest },
  TContext
> => {
  return useMutation(getSendMessageMutationOptions(options), queryClient);
};

/**
 * Get paginated messages for the conversation
 *
 * Only allowed to access conversations that belong to the user
 * @summary Get Conversation
 */
export const getConversation = (
  conversationId: string,
  params?: GetConversationChatConversationIdGetParams,
  signal?: AbortSignal,
) => {
  return orvalClient<ConversationResponse>({
    url: `/chat/${conversationId}`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetConversationInfiniteQueryKey = (
  conversationId: string,
  params?: GetConversationChatConversationIdGetParams,
) => {
  return [
    "infinite",
    `/chat/${conversationId}`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetConversationQueryKey = (
  conversationId: string,
  params?: GetConversationChatConversationIdGetParams,
) => {
  return [`/chat/${conversationId}`, ...(params ? [params] : [])] as const;
};

export const getGetConversationInfiniteQueryOptions = <
  TData = InfiniteData<
    Awaited<ReturnType<typeof getConversation>>,
    GetConversationChatConversationIdGetParams["cursor"]
  >,
  TError = HTTPValidationError,
>(
  conversationId: string,
  params?: GetConversationChatConversationIdGetParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getConversation>>,
        TError,
        TData,
        QueryKey,
        GetConversationChatConversationIdGetParams["cursor"]
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetConversationInfiniteQueryKey(conversationId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getConversation>>,
    QueryKey,
    GetConversationChatConversationIdGetParams["cursor"]
  > = ({ signal, pageParam }) =>
    getConversation(
      conversationId,
      { ...params, cursor: pageParam ?? params?.["cursor"] },
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: conversationId !== null && conversationId !== undefined,
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getConversation>>,
    TError,
    TData,
    QueryKey,
    GetConversationChatConversationIdGetParams["cursor"]
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetConversationChatConversationIdGetInfiniteQueryResult =
  NonNullable<Awaited<ReturnType<typeof getConversation>>>;
export type GetConversationChatConversationIdGetInfiniteQueryError =
  HTTPValidationError;

export function useGetConversationInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getConversation>>,
    GetConversationChatConversationIdGetParams["cursor"]
  >,
  TError = HTTPValidationError,
>(
  conversationId: string,
  params: undefined | GetConversationChatConversationIdGetParams,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getConversation>>,
        TError,
        TData,
        QueryKey,
        GetConversationChatConversationIdGetParams["cursor"]
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConversation>>,
          TError,
          Awaited<ReturnType<typeof getConversation>>,
          QueryKey
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetConversationInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getConversation>>,
    GetConversationChatConversationIdGetParams["cursor"]
  >,
  TError = HTTPValidationError,
>(
  conversationId: string,
  params?: GetConversationChatConversationIdGetParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getConversation>>,
        TError,
        TData,
        QueryKey,
        GetConversationChatConversationIdGetParams["cursor"]
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConversation>>,
          TError,
          Awaited<ReturnType<typeof getConversation>>,
          QueryKey
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetConversationInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getConversation>>,
    GetConversationChatConversationIdGetParams["cursor"]
  >,
  TError = HTTPValidationError,
>(
  conversationId: string,
  params?: GetConversationChatConversationIdGetParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getConversation>>,
        TError,
        TData,
        QueryKey,
        GetConversationChatConversationIdGetParams["cursor"]
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Conversation
 */

export function useGetConversationInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getConversation>>,
    GetConversationChatConversationIdGetParams["cursor"]
  >,
  TError = HTTPValidationError,
>(
  conversationId: string,
  params?: GetConversationChatConversationIdGetParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getConversation>>,
        TError,
        TData,
        QueryKey,
        GetConversationChatConversationIdGetParams["cursor"]
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetConversationInfiniteQueryOptions(
    conversationId,
    params,
    options,
  );

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetConversationQueryOptions = <
  TData = Awaited<ReturnType<typeof getConversation>>,
  TError = HTTPValidationError,
>(
  conversationId: string,
  params?: GetConversationChatConversationIdGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getConversation>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetConversationQueryKey(conversationId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getConversation>>> = ({
    signal,
  }) => getConversation(conversationId, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: conversationId !== null && conversationId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getConversation>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetConversationChatConversationIdGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getConversation>>
>;
export type GetConversationChatConversationIdGetQueryError =
  HTTPValidationError;

export function useGetConversation<
  TData = Awaited<ReturnType<typeof getConversation>>,
  TError = HTTPValidationError,
>(
  conversationId: string,
  params: undefined | GetConversationChatConversationIdGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getConversation>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConversation>>,
          TError,
          Awaited<ReturnType<typeof getConversation>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetConversation<
  TData = Awaited<ReturnType<typeof getConversation>>,
  TError = HTTPValidationError,
>(
  conversationId: string,
  params?: GetConversationChatConversationIdGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getConversation>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConversation>>,
          TError,
          Awaited<ReturnType<typeof getConversation>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetConversation<
  TData = Awaited<ReturnType<typeof getConversation>>,
  TError = HTTPValidationError,
>(
  conversationId: string,
  params?: GetConversationChatConversationIdGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getConversation>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Conversation
 */

export function useGetConversation<
  TData = Awaited<ReturnType<typeof getConversation>>,
  TError = HTTPValidationError,
>(
  conversationId: string,
  params?: GetConversationChatConversationIdGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getConversation>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetConversationQueryOptions(
    conversationId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Transcribe an audio message and process it through the chat pipeline.
 *
 * Accepts audio file upload, transcribes it using OpenAI Whisper API,
 * and processes the transcribed text through the same agent orchestration
 * as text messages.
 * @summary Send Voice Message
 */
export const sendVoiceMessage = (
  conversationId: string,
  audioMessageRequest: AudioMessageRequest,
  signal?: AbortSignal,
) => {
  const formData = new FormData();
  if (
    audioMessageRequest.initial_agent !== undefined &&
    audioMessageRequest.initial_agent !== null
  ) {
    formData.append(`initial_agent`, audioMessageRequest.initial_agent);
  }
  if (
    audioMessageRequest.contexts !== undefined &&
    audioMessageRequest.contexts !== null
  ) {
    formData.append(`contexts`, audioMessageRequest.contexts);
  }
  formData.append(`audio_file`, audioMessageRequest.audio_file);

  return orvalClient<unknown>({
    url: `/chat/${conversationId}/voice`,
    method: "POST",
    headers: { "Content-Type": "multipart/form-data" },
    data: formData,
    signal,
  });
};

export const getSendVoiceMessageMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendVoiceMessage>>,
    TError,
    { conversationId: string; data: AudioMessageRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sendVoiceMessage>>,
  TError,
  { conversationId: string; data: AudioMessageRequest },
  TContext
> => {
  const mutationKey = ["sendVoiceMessage"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sendVoiceMessage>>,
    { conversationId: string; data: AudioMessageRequest }
  > = (props) => {
    const { conversationId, data } = props ?? {};

    return sendVoiceMessage(conversationId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type SendVoiceMessageChatConversationIdVoicePostMutationResult =
  NonNullable<Awaited<ReturnType<typeof sendVoiceMessage>>>;
export type SendVoiceMessageChatConversationIdVoicePostMutationBody =
  AudioMessageRequest;
export type SendVoiceMessageChatConversationIdVoicePostMutationError =
  HTTPValidationError;

/**
 * @summary Send Voice Message
 */
export const useSendVoiceMessage = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof sendVoiceMessage>>,
      TError,
      { conversationId: string; data: AudioMessageRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof sendVoiceMessage>>,
  TError,
  { conversationId: string; data: AudioMessageRequest },
  TContext
> => {
  return useMutation(getSendVoiceMessageMutationOptions(options), queryClient);
};

/**
 * @summary Mark Conversation As Read
 */
export const markConversationAsRead = (
  conversationId: string,
  signal?: AbortSignal,
) => {
  return orvalClient<unknown>({
    url: `/chat/${conversationId}/read`,
    method: "POST",
    signal,
  });
};

export const getMarkConversationAsReadMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof markConversationAsRead>>,
    TError,
    { conversationId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof markConversationAsRead>>,
  TError,
  { conversationId: string },
  TContext
> => {
  const mutationKey = ["markConversationAsRead"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof markConversationAsRead>>,
    { conversationId: string }
  > = (props) => {
    const { conversationId } = props ?? {};

    return markConversationAsRead(conversationId);
  };

  return { mutationFn, ...mutationOptions };
};

export type MarkConversationAsReadChatConversationIdReadPostMutationResult =
  NonNullable<Awaited<ReturnType<typeof markConversationAsRead>>>;

export type MarkConversationAsReadChatConversationIdReadPostMutationError =
  HTTPValidationError;

/**
 * @summary Mark Conversation As Read
 */
export const useMarkConversationAsRead = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof markConversationAsRead>>,
      TError,
      { conversationId: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof markConversationAsRead>>,
  TError,
  { conversationId: string },
  TContext
> => {
  return useMutation(
    getMarkConversationAsReadMutationOptions(options),
    queryClient,
  );
};

/**
 * Apply partial updates to an event: feedback score, feedback comment,
 * and/or (for Zocdoc booking events) the `mark_final` flag which sets
 * the event's content `final` to True.
 * @summary Update Event
 */
export const updateEvent = (
  eventId: string,
  updateEventRequest: UpdateEventRequest,
  signal?: AbortSignal,
) => {
  return orvalClient<void>({
    url: `/chat/event/${eventId}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: updateEventRequest,
    signal,
  });
};

export const getUpdateEventMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateEvent>>,
    TError,
    { eventId: string; data: UpdateEventRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateEvent>>,
  TError,
  { eventId: string; data: UpdateEventRequest },
  TContext
> => {
  const mutationKey = ["updateEvent"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateEvent>>,
    { eventId: string; data: UpdateEventRequest }
  > = (props) => {
    const { eventId, data } = props ?? {};

    return updateEvent(eventId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateEventChatEventEventIdPutMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateEvent>>
>;
export type UpdateEventChatEventEventIdPutMutationBody = UpdateEventRequest;
export type UpdateEventChatEventEventIdPutMutationError = HTTPValidationError;

/**
 * @summary Update Event
 */
export const useUpdateEvent = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateEvent>>,
      TError,
      { eventId: string; data: UpdateEventRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateEvent>>,
  TError,
  { eventId: string; data: UpdateEventRequest },
  TContext
> => {
  return useMutation(getUpdateEventMutationOptions(options), queryClient);
};

/**
 * Get clinic requests for a conversation
 * @summary Get Clinic Request
 */
export const getClinicRequest = (
  conversationId: string,
  clinicRequestId: string,
  signal?: AbortSignal,
) => {
  return orvalClient<ClinicRequestModel>({
    url: `/chat/${conversationId}/clinic-requests/${clinicRequestId}`,
    method: "GET",
    signal,
  });
};

export const getGetClinicRequestQueryKey = (
  conversationId: string,
  clinicRequestId: string,
) => {
  return [
    `/chat/${conversationId}/clinic-requests/${clinicRequestId}`,
  ] as const;
};

export const getGetClinicRequestQueryOptions = <
  TData = Awaited<ReturnType<typeof getClinicRequest>>,
  TError = HTTPValidationError,
>(
  conversationId: string,
  clinicRequestId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClinicRequest>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetClinicRequestQueryKey(conversationId, clinicRequestId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getClinicRequest>>
  > = ({ signal }) => getClinicRequest(conversationId, clinicRequestId, signal);

  return {
    queryKey,
    queryFn,
    enabled:
      conversationId !== null &&
      conversationId !== undefined &&
      clinicRequestId !== null &&
      clinicRequestId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getClinicRequest>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetClinicRequestChatConversationIdClinicRequestsClinicRequestIdGetQueryResult =
  NonNullable<Awaited<ReturnType<typeof getClinicRequest>>>;
export type GetClinicRequestChatConversationIdClinicRequestsClinicRequestIdGetQueryError =
  HTTPValidationError;

export function useGetClinicRequest<
  TData = Awaited<ReturnType<typeof getClinicRequest>>,
  TError = HTTPValidationError,
>(
  conversationId: string,
  clinicRequestId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClinicRequest>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClinicRequest>>,
          TError,
          Awaited<ReturnType<typeof getClinicRequest>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetClinicRequest<
  TData = Awaited<ReturnType<typeof getClinicRequest>>,
  TError = HTTPValidationError,
>(
  conversationId: string,
  clinicRequestId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClinicRequest>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClinicRequest>>,
          TError,
          Awaited<ReturnType<typeof getClinicRequest>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetClinicRequest<
  TData = Awaited<ReturnType<typeof getClinicRequest>>,
  TError = HTTPValidationError,
>(
  conversationId: string,
  clinicRequestId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClinicRequest>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Clinic Request
 */

export function useGetClinicRequest<
  TData = Awaited<ReturnType<typeof getClinicRequest>>,
  TError = HTTPValidationError,
>(
  conversationId: string,
  clinicRequestId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClinicRequest>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetClinicRequestQueryOptions(
    conversationId,
    clinicRequestId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Render Home Care Plan As Pdf
 */
export const renderHomeCarePlanAsPdf = (
  messageId: string,
  cacheKey: string,
  signal?: AbortSignal,
) => {
  return orvalClient<unknown>({
    url: `/clinic/message/${messageId}/home-care-plan-pdf/${cacheKey}`,
    method: "GET",
    signal,
  });
};

export const getRenderHomeCarePlanAsPdfQueryKey = (
  messageId: string,
  cacheKey: string,
) => {
  return [
    `/clinic/message/${messageId}/home-care-plan-pdf/${cacheKey}`,
  ] as const;
};

export const getRenderHomeCarePlanAsPdfQueryOptions = <
  TData = Awaited<ReturnType<typeof renderHomeCarePlanAsPdf>>,
  TError = HTTPValidationError,
>(
  messageId: string,
  cacheKey: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof renderHomeCarePlanAsPdf>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getRenderHomeCarePlanAsPdfQueryKey(messageId, cacheKey);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof renderHomeCarePlanAsPdf>>
  > = ({ signal }) => renderHomeCarePlanAsPdf(messageId, cacheKey, signal);

  return {
    queryKey,
    queryFn,
    enabled:
      messageId !== null &&
      messageId !== undefined &&
      cacheKey !== null &&
      cacheKey !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof renderHomeCarePlanAsPdf>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type RenderHomeCarePlanAsPDFClinicMessageMessageIdHomeCarePlanPdfCacheKeyGetQueryResult =
  NonNullable<Awaited<ReturnType<typeof renderHomeCarePlanAsPdf>>>;
export type RenderHomeCarePlanAsPDFClinicMessageMessageIdHomeCarePlanPdfCacheKeyGetQueryError =
  HTTPValidationError;

export function useRenderHomeCarePlanAsPdf<
  TData = Awaited<ReturnType<typeof renderHomeCarePlanAsPdf>>,
  TError = HTTPValidationError,
>(
  messageId: string,
  cacheKey: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof renderHomeCarePlanAsPdf>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof renderHomeCarePlanAsPdf>>,
          TError,
          Awaited<ReturnType<typeof renderHomeCarePlanAsPdf>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useRenderHomeCarePlanAsPdf<
  TData = Awaited<ReturnType<typeof renderHomeCarePlanAsPdf>>,
  TError = HTTPValidationError,
>(
  messageId: string,
  cacheKey: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof renderHomeCarePlanAsPdf>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof renderHomeCarePlanAsPdf>>,
          TError,
          Awaited<ReturnType<typeof renderHomeCarePlanAsPdf>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useRenderHomeCarePlanAsPdf<
  TData = Awaited<ReturnType<typeof renderHomeCarePlanAsPdf>>,
  TError = HTTPValidationError,
>(
  messageId: string,
  cacheKey: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof renderHomeCarePlanAsPdf>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Render Home Care Plan As Pdf
 */

export function useRenderHomeCarePlanAsPdf<
  TData = Awaited<ReturnType<typeof renderHomeCarePlanAsPdf>>,
  TError = HTTPValidationError,
>(
  messageId: string,
  cacheKey: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof renderHomeCarePlanAsPdf>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getRenderHomeCarePlanAsPdfQueryOptions(
    messageId,
    cacheKey,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Create Home Care Plan Pdf Link
 */
export const createHomeCarePlanPdfLink = (
  messageId: string,
  signal?: AbortSignal,
) => {
  return orvalClient<unknown>({
    url: `/clinic/message/${messageId}/home-care-plan-pdf`,
    method: "GET",
    signal,
  });
};

export const getCreateHomeCarePlanPdfLinkQueryKey = (messageId: string) => {
  return [`/clinic/message/${messageId}/home-care-plan-pdf`] as const;
};

export const getCreateHomeCarePlanPdfLinkQueryOptions = <
  TData = Awaited<ReturnType<typeof createHomeCarePlanPdfLink>>,
  TError = HTTPValidationError,
>(
  messageId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof createHomeCarePlanPdfLink>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getCreateHomeCarePlanPdfLinkQueryKey(messageId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof createHomeCarePlanPdfLink>>
  > = ({ signal }) => createHomeCarePlanPdfLink(messageId, signal);

  return {
    queryKey,
    queryFn,
    enabled: messageId !== null && messageId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof createHomeCarePlanPdfLink>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type CreateHomeCarePlanPDFLinkClinicMessageMessageIdHomeCarePlanPdfGetQueryResult =
  NonNullable<Awaited<ReturnType<typeof createHomeCarePlanPdfLink>>>;
export type CreateHomeCarePlanPDFLinkClinicMessageMessageIdHomeCarePlanPdfGetQueryError =
  HTTPValidationError;

export function useCreateHomeCarePlanPdfLink<
  TData = Awaited<ReturnType<typeof createHomeCarePlanPdfLink>>,
  TError = HTTPValidationError,
>(
  messageId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof createHomeCarePlanPdfLink>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof createHomeCarePlanPdfLink>>,
          TError,
          Awaited<ReturnType<typeof createHomeCarePlanPdfLink>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useCreateHomeCarePlanPdfLink<
  TData = Awaited<ReturnType<typeof createHomeCarePlanPdfLink>>,
  TError = HTTPValidationError,
>(
  messageId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof createHomeCarePlanPdfLink>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof createHomeCarePlanPdfLink>>,
          TError,
          Awaited<ReturnType<typeof createHomeCarePlanPdfLink>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useCreateHomeCarePlanPdfLink<
  TData = Awaited<ReturnType<typeof createHomeCarePlanPdfLink>>,
  TError = HTTPValidationError,
>(
  messageId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof createHomeCarePlanPdfLink>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Create Home Care Plan Pdf Link
 */

export function useCreateHomeCarePlanPdfLink<
  TData = Awaited<ReturnType<typeof createHomeCarePlanPdfLink>>,
  TError = HTTPValidationError,
>(
  messageId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof createHomeCarePlanPdfLink>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getCreateHomeCarePlanPdfLinkQueryOptions(
    messageId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Returns a PDF render of the SOAP note attached to the given message.
 * @summary Render Soap Note As Pdf
 */
export const renderSoapNoteAsPdf = (
  messageId: string,
  cacheKey: string,
  signal?: AbortSignal,
) => {
  return orvalClient<unknown>({
    url: `/clinic/message/${messageId}/soap-note-pdf/${cacheKey}`,
    method: "GET",
    signal,
  });
};

export const getRenderSoapNoteAsPdfQueryKey = (
  messageId: string,
  cacheKey: string,
) => {
  return [`/clinic/message/${messageId}/soap-note-pdf/${cacheKey}`] as const;
};

export const getRenderSoapNoteAsPdfQueryOptions = <
  TData = Awaited<ReturnType<typeof renderSoapNoteAsPdf>>,
  TError = HTTPValidationError,
>(
  messageId: string,
  cacheKey: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof renderSoapNoteAsPdf>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getRenderSoapNoteAsPdfQueryKey(messageId, cacheKey);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof renderSoapNoteAsPdf>>
  > = ({ signal }) => renderSoapNoteAsPdf(messageId, cacheKey, signal);

  return {
    queryKey,
    queryFn,
    enabled:
      messageId !== null &&
      messageId !== undefined &&
      cacheKey !== null &&
      cacheKey !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof renderSoapNoteAsPdf>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type RenderSOAPNoteAsPDFClinicMessageMessageIdSoapNotePdfCacheKeyGetQueryResult =
  NonNullable<Awaited<ReturnType<typeof renderSoapNoteAsPdf>>>;
export type RenderSOAPNoteAsPDFClinicMessageMessageIdSoapNotePdfCacheKeyGetQueryError =
  HTTPValidationError;

export function useRenderSoapNoteAsPdf<
  TData = Awaited<ReturnType<typeof renderSoapNoteAsPdf>>,
  TError = HTTPValidationError,
>(
  messageId: string,
  cacheKey: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof renderSoapNoteAsPdf>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof renderSoapNoteAsPdf>>,
          TError,
          Awaited<ReturnType<typeof renderSoapNoteAsPdf>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useRenderSoapNoteAsPdf<
  TData = Awaited<ReturnType<typeof renderSoapNoteAsPdf>>,
  TError = HTTPValidationError,
>(
  messageId: string,
  cacheKey: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof renderSoapNoteAsPdf>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof renderSoapNoteAsPdf>>,
          TError,
          Awaited<ReturnType<typeof renderSoapNoteAsPdf>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useRenderSoapNoteAsPdf<
  TData = Awaited<ReturnType<typeof renderSoapNoteAsPdf>>,
  TError = HTTPValidationError,
>(
  messageId: string,
  cacheKey: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof renderSoapNoteAsPdf>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Render Soap Note As Pdf
 */

export function useRenderSoapNoteAsPdf<
  TData = Awaited<ReturnType<typeof renderSoapNoteAsPdf>>,
  TError = HTTPValidationError,
>(
  messageId: string,
  cacheKey: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof renderSoapNoteAsPdf>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getRenderSoapNoteAsPdfQueryOptions(
    messageId,
    cacheKey,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Authenticated endpoint to generate a downloadable PDF link which expires in 10 minutes
 * @summary Create Soap Note Pdf Link
 */
export const createSoapNotePdfLink = (
  messageId: string,
  signal?: AbortSignal,
) => {
  return orvalClient<unknown>({
    url: `/clinic/message/${messageId}/soap-note-pdf`,
    method: "GET",
    signal,
  });
};

export const getCreateSoapNotePdfLinkQueryKey = (messageId: string) => {
  return [`/clinic/message/${messageId}/soap-note-pdf`] as const;
};

export const getCreateSoapNotePdfLinkQueryOptions = <
  TData = Awaited<ReturnType<typeof createSoapNotePdfLink>>,
  TError = HTTPValidationError,
>(
  messageId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof createSoapNotePdfLink>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getCreateSoapNotePdfLinkQueryKey(messageId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof createSoapNotePdfLink>>
  > = ({ signal }) => createSoapNotePdfLink(messageId, signal);

  return {
    queryKey,
    queryFn,
    enabled: messageId !== null && messageId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof createSoapNotePdfLink>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type CreateSOAPNotePDFLinkClinicMessageMessageIdSoapNotePdfGetQueryResult =
  NonNullable<Awaited<ReturnType<typeof createSoapNotePdfLink>>>;
export type CreateSOAPNotePDFLinkClinicMessageMessageIdSoapNotePdfGetQueryError =
  HTTPValidationError;

export function useCreateSoapNotePdfLink<
  TData = Awaited<ReturnType<typeof createSoapNotePdfLink>>,
  TError = HTTPValidationError,
>(
  messageId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof createSoapNotePdfLink>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof createSoapNotePdfLink>>,
          TError,
          Awaited<ReturnType<typeof createSoapNotePdfLink>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useCreateSoapNotePdfLink<
  TData = Awaited<ReturnType<typeof createSoapNotePdfLink>>,
  TError = HTTPValidationError,
>(
  messageId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof createSoapNotePdfLink>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof createSoapNotePdfLink>>,
          TError,
          Awaited<ReturnType<typeof createSoapNotePdfLink>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useCreateSoapNotePdfLink<
  TData = Awaited<ReturnType<typeof createSoapNotePdfLink>>,
  TError = HTTPValidationError,
>(
  messageId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof createSoapNotePdfLink>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Create Soap Note Pdf Link
 */

export function useCreateSoapNotePdfLink<
  TData = Awaited<ReturnType<typeof createSoapNotePdfLink>>,
  TError = HTTPValidationError,
>(
  messageId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof createSoapNotePdfLink>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getCreateSoapNotePdfLinkQueryOptions(messageId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Endpoint to retrieve an attachment from S3 based on a previously-generated cache key.
 * @summary Get Attachment For Message
 */
export const getAttachmentForMessage = (
  messageId: string,
  cacheKey: string,
  signal?: AbortSignal,
) => {
  return orvalClient<unknown>({
    url: `/clinic/message/${messageId}/attachment/${cacheKey}`,
    method: "GET",
    signal,
  });
};

export const getGetAttachmentForMessageQueryKey = (
  messageId: string,
  cacheKey: string,
) => {
  return [`/clinic/message/${messageId}/attachment/${cacheKey}`] as const;
};

export const getGetAttachmentForMessageQueryOptions = <
  TData = Awaited<ReturnType<typeof getAttachmentForMessage>>,
  TError = HTTPValidationError,
>(
  messageId: string,
  cacheKey: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAttachmentForMessage>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetAttachmentForMessageQueryKey(messageId, cacheKey);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAttachmentForMessage>>
  > = ({ signal }) => getAttachmentForMessage(messageId, cacheKey, signal);

  return {
    queryKey,
    queryFn,
    enabled:
      messageId !== null &&
      messageId !== undefined &&
      cacheKey !== null &&
      cacheKey !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAttachmentForMessage>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAttachmentForMessageClinicMessageMessageIdAttachmentCacheKeyGetQueryResult =
  NonNullable<Awaited<ReturnType<typeof getAttachmentForMessage>>>;
export type GetAttachmentForMessageClinicMessageMessageIdAttachmentCacheKeyGetQueryError =
  HTTPValidationError;

export function useGetAttachmentForMessage<
  TData = Awaited<ReturnType<typeof getAttachmentForMessage>>,
  TError = HTTPValidationError,
>(
  messageId: string,
  cacheKey: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAttachmentForMessage>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAttachmentForMessage>>,
          TError,
          Awaited<ReturnType<typeof getAttachmentForMessage>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAttachmentForMessage<
  TData = Awaited<ReturnType<typeof getAttachmentForMessage>>,
  TError = HTTPValidationError,
>(
  messageId: string,
  cacheKey: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAttachmentForMessage>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAttachmentForMessage>>,
          TError,
          Awaited<ReturnType<typeof getAttachmentForMessage>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAttachmentForMessage<
  TData = Awaited<ReturnType<typeof getAttachmentForMessage>>,
  TError = HTTPValidationError,
>(
  messageId: string,
  cacheKey: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAttachmentForMessage>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Attachment For Message
 */

export function useGetAttachmentForMessage<
  TData = Awaited<ReturnType<typeof getAttachmentForMessage>>,
  TError = HTTPValidationError,
>(
  messageId: string,
  cacheKey: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAttachmentForMessage>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetAttachmentForMessageQueryOptions(
    messageId,
    cacheKey,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Authenticated endpoint to generate an attachment link which expires in 10 minutes.
 * @summary Create Attachment Link
 */
export const createAttachmentLink = (
  messageId: string,
  signal?: AbortSignal,
) => {
  return orvalClient<unknown>({
    url: `/clinic/message/${messageId}/attachment`,
    method: "GET",
    signal,
  });
};

export const getCreateAttachmentLinkQueryKey = (messageId: string) => {
  return [`/clinic/message/${messageId}/attachment`] as const;
};

export const getCreateAttachmentLinkQueryOptions = <
  TData = Awaited<ReturnType<typeof createAttachmentLink>>,
  TError = HTTPValidationError,
>(
  messageId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof createAttachmentLink>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getCreateAttachmentLinkQueryKey(messageId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof createAttachmentLink>>
  > = ({ signal }) => createAttachmentLink(messageId, signal);

  return {
    queryKey,
    queryFn,
    enabled: messageId !== null && messageId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof createAttachmentLink>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type CreateAttachmentLinkClinicMessageMessageIdAttachmentGetQueryResult =
  NonNullable<Awaited<ReturnType<typeof createAttachmentLink>>>;
export type CreateAttachmentLinkClinicMessageMessageIdAttachmentGetQueryError =
  HTTPValidationError;

export function useCreateAttachmentLink<
  TData = Awaited<ReturnType<typeof createAttachmentLink>>,
  TError = HTTPValidationError,
>(
  messageId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof createAttachmentLink>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof createAttachmentLink>>,
          TError,
          Awaited<ReturnType<typeof createAttachmentLink>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useCreateAttachmentLink<
  TData = Awaited<ReturnType<typeof createAttachmentLink>>,
  TError = HTTPValidationError,
>(
  messageId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof createAttachmentLink>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof createAttachmentLink>>,
          TError,
          Awaited<ReturnType<typeof createAttachmentLink>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useCreateAttachmentLink<
  TData = Awaited<ReturnType<typeof createAttachmentLink>>,
  TError = HTTPValidationError,
>(
  messageId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof createAttachmentLink>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Create Attachment Link
 */

export function useCreateAttachmentLink<
  TData = Awaited<ReturnType<typeof createAttachmentLink>>,
  TError = HTTPValidationError,
>(
  messageId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof createAttachmentLink>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getCreateAttachmentLinkQueryOptions(messageId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Submit clinic request to Curai from a superclinical encounter for the registered authenticated user
 * @summary Submit An Async Clinic Request To Curai
 */
export const submitAnAsyncClinicRequestToCurai = (
  createCuraiVisitAsyncRequest: CreateCuraiVisitAsyncRequest,
  signal?: AbortSignal,
) => {
  return orvalClient<unknown>({
    url: `/clinic/visit/async-request`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createCuraiVisitAsyncRequest,
    signal,
  });
};

export const getSubmitAnAsyncClinicRequestToCuraiMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof submitAnAsyncClinicRequestToCurai>>,
    TError,
    { data: CreateCuraiVisitAsyncRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof submitAnAsyncClinicRequestToCurai>>,
  TError,
  { data: CreateCuraiVisitAsyncRequest },
  TContext
> => {
  const mutationKey = ["submitAnAsyncClinicRequestToCurai"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof submitAnAsyncClinicRequestToCurai>>,
    { data: CreateCuraiVisitAsyncRequest }
  > = (props) => {
    const { data } = props ?? {};

    return submitAnAsyncClinicRequestToCurai(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type SubmitAnAsyncClinicRequestToCuraiClinicVisitAsyncRequestPostMutationResult =
  NonNullable<Awaited<ReturnType<typeof submitAnAsyncClinicRequestToCurai>>>;
export type SubmitAnAsyncClinicRequestToCuraiClinicVisitAsyncRequestPostMutationBody =
  CreateCuraiVisitAsyncRequest;
export type SubmitAnAsyncClinicRequestToCuraiClinicVisitAsyncRequestPostMutationError =
  HTTPValidationError;

/**
 * @summary Submit An Async Clinic Request To Curai
 */
export const useSubmitAnAsyncClinicRequestToCurai = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof submitAnAsyncClinicRequestToCurai>>,
      TError,
      { data: CreateCuraiVisitAsyncRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof submitAnAsyncClinicRequestToCurai>>,
  TError,
  { data: CreateCuraiVisitAsyncRequest },
  TContext
> => {
  return useMutation(
    getSubmitAnAsyncClinicRequestToCuraiMutationOptions(options),
    queryClient,
  );
};

/**
 * Webhook for Curai to close out a clinic request
 * @summary Close Async Clinic Request
 */
export const closeAsyncClinicRequest = (
  closeClinicRequestRequest: CloseClinicRequestRequest,
  signal?: AbortSignal,
) => {
  return orvalClient<unknown>({
    url: `/clinic/visit/async-request/close`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: closeClinicRequestRequest,
    signal,
  });
};

export const getCloseAsyncClinicRequestMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof closeAsyncClinicRequest>>,
    TError,
    { data: CloseClinicRequestRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof closeAsyncClinicRequest>>,
  TError,
  { data: CloseClinicRequestRequest },
  TContext
> => {
  const mutationKey = ["closeAsyncClinicRequest"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof closeAsyncClinicRequest>>,
    { data: CloseClinicRequestRequest }
  > = (props) => {
    const { data } = props ?? {};

    return closeAsyncClinicRequest(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CloseAsyncClinicRequestClinicVisitAsyncRequestClosePostMutationResult =
  NonNullable<Awaited<ReturnType<typeof closeAsyncClinicRequest>>>;
export type CloseAsyncClinicRequestClinicVisitAsyncRequestClosePostMutationBody =
  CloseClinicRequestRequest;
export type CloseAsyncClinicRequestClinicVisitAsyncRequestClosePostMutationError =
  HTTPValidationError;

/**
 * @summary Close Async Clinic Request
 */
export const useCloseAsyncClinicRequest = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof closeAsyncClinicRequest>>,
      TError,
      { data: CloseClinicRequestRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof closeAsyncClinicRequest>>,
  TError,
  { data: CloseClinicRequestRequest },
  TContext
> => {
  return useMutation(
    getCloseAsyncClinicRequestMutationOptions(options),
    queryClient,
  );
};

/**
 * Transition an async clinic request (ASYNC_DX, ASYNC_RX, RX_RENEWAL) to a VISIT.
 *
 * Archives the old clinic request events, cancels the async CR, and creates a
 * new VISIT-type clinic request with the appropriate events.
 * @summary Transition An Async Clinic Request To A Full Visit
 */
export const transitionAnAsyncClinicRequestToAFullVisit = (
  clinicRequestId: string,
  signal?: AbortSignal,
) => {
  return orvalClient<ClinicRequestModel>({
    url: `/clinic/clinic-request/${clinicRequestId}/transition-to-visit`,
    method: "POST",
    signal,
  });
};

export const getTransitionAnAsyncClinicRequestToAFullVisitMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof transitionAnAsyncClinicRequestToAFullVisit>>,
    TError,
    { clinicRequestId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof transitionAnAsyncClinicRequestToAFullVisit>>,
  TError,
  { clinicRequestId: string },
  TContext
> => {
  const mutationKey = ["transitionAnAsyncClinicRequestToAFullVisit"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof transitionAnAsyncClinicRequestToAFullVisit>>,
    { clinicRequestId: string }
  > = (props) => {
    const { clinicRequestId } = props ?? {};

    return transitionAnAsyncClinicRequestToAFullVisit(clinicRequestId);
  };

  return { mutationFn, ...mutationOptions };
};

export type TransitionAnAsyncClinicRequestToAFullVisitClinicClinicRequestClinicRequestIdTransitionToVisitPostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof transitionAnAsyncClinicRequestToAFullVisit>>
  >;

export type TransitionAnAsyncClinicRequestToAFullVisitClinicClinicRequestClinicRequestIdTransitionToVisitPostMutationError =
  HTTPValidationError;

/**
 * @summary Transition An Async Clinic Request To A Full Visit
 */
export const useTransitionAnAsyncClinicRequestToAFullVisit = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof transitionAnAsyncClinicRequestToAFullVisit>>,
      TError,
      { clinicRequestId: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof transitionAnAsyncClinicRequestToAFullVisit>>,
  TError,
  { clinicRequestId: string },
  TContext
> => {
  return useMutation(
    getTransitionAnAsyncClinicRequestToAFullVisitMutationOptions(options),
    queryClient,
  );
};

/**
 * @summary Create Curai Visit From Superclinical Encounter For The Authenticated Registered User
 */
export const createCuraiVisitFromSuperclinicalEncounterForTheAuthenticatedRegisteredUser =
  (createCuraiVisitRequest: CreateCuraiVisitRequest, signal?: AbortSignal) => {
    return orvalClient<CreateCuraiVisitResponse>({
      url: `/clinic/visit`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createCuraiVisitRequest,
      signal,
    });
  };

export const getCreateCuraiVisitFromSuperclinicalEncounterForTheAuthenticatedRegisteredUserMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof createCuraiVisitFromSuperclinicalEncounterForTheAuthenticatedRegisteredUser
        >
      >,
      TError,
      { data: CreateCuraiVisitRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof createCuraiVisitFromSuperclinicalEncounterForTheAuthenticatedRegisteredUser
      >
    >,
    TError,
    { data: CreateCuraiVisitRequest },
    TContext
  > => {
    const mutationKey = [
      "createCuraiVisitFromSuperclinicalEncounterForTheAuthenticatedRegisteredUser",
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof createCuraiVisitFromSuperclinicalEncounterForTheAuthenticatedRegisteredUser
        >
      >,
      { data: CreateCuraiVisitRequest }
    > = (props) => {
      const { data } = props ?? {};

      return createCuraiVisitFromSuperclinicalEncounterForTheAuthenticatedRegisteredUser(
        data,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type CreateCuraiVisitFromSuperclinicalEncounterForTheAuthenticatedRegisteredUserClinicVisitPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof createCuraiVisitFromSuperclinicalEncounterForTheAuthenticatedRegisteredUser
      >
    >
  >;
export type CreateCuraiVisitFromSuperclinicalEncounterForTheAuthenticatedRegisteredUserClinicVisitPostMutationBody =
  CreateCuraiVisitRequest;
export type CreateCuraiVisitFromSuperclinicalEncounterForTheAuthenticatedRegisteredUserClinicVisitPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Curai Visit From Superclinical Encounter For The Authenticated Registered User
 */
export const useCreateCuraiVisitFromSuperclinicalEncounterForTheAuthenticatedRegisteredUser =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof createCuraiVisitFromSuperclinicalEncounterForTheAuthenticatedRegisteredUser
          >
        >,
        TError,
        { data: CreateCuraiVisitRequest },
        TContext
      >;
    },
    queryClient?: QueryClient,
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof createCuraiVisitFromSuperclinicalEncounterForTheAuthenticatedRegisteredUser
      >
    >,
    TError,
    { data: CreateCuraiVisitRequest },
    TContext
  > => {
    return useMutation(
      getCreateCuraiVisitFromSuperclinicalEncounterForTheAuthenticatedRegisteredUserMutationOptions(
        options,
      ),
      queryClient,
    );
  };

/**
 * @summary Update Ongoing Curai Visit From Another Nori Conversation
 */
export const updateOngoingCuraiVisitFromAnotherNoriConversation = (
  updateCuraiVisitRequest: UpdateCuraiVisitRequest,
  signal?: AbortSignal,
) => {
  return orvalClient<unknown>({
    url: `/clinic/visit`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: updateCuraiVisitRequest,
    signal,
  });
};

export const getUpdateOngoingCuraiVisitFromAnotherNoriConversationMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof updateOngoingCuraiVisitFromAnotherNoriConversation>
      >,
      TError,
      { data: UpdateCuraiVisitRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof updateOngoingCuraiVisitFromAnotherNoriConversation>
    >,
    TError,
    { data: UpdateCuraiVisitRequest },
    TContext
  > => {
    const mutationKey = ["updateOngoingCuraiVisitFromAnotherNoriConversation"];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof updateOngoingCuraiVisitFromAnotherNoriConversation>
      >,
      { data: UpdateCuraiVisitRequest }
    > = (props) => {
      const { data } = props ?? {};

      return updateOngoingCuraiVisitFromAnotherNoriConversation(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateOngoingCuraiVisitFromAnotherNoriConversationClinicVisitPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof updateOngoingCuraiVisitFromAnotherNoriConversation>
    >
  >;
export type UpdateOngoingCuraiVisitFromAnotherNoriConversationClinicVisitPutMutationBody =
  UpdateCuraiVisitRequest;
export type UpdateOngoingCuraiVisitFromAnotherNoriConversationClinicVisitPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Ongoing Curai Visit From Another Nori Conversation
 */
export const useUpdateOngoingCuraiVisitFromAnotherNoriConversation = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof updateOngoingCuraiVisitFromAnotherNoriConversation>
      >,
      TError,
      { data: UpdateCuraiVisitRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<
    ReturnType<typeof updateOngoingCuraiVisitFromAnotherNoriConversation>
  >,
  TError,
  { data: UpdateCuraiVisitRequest },
  TContext
> => {
  return useMutation(
    getUpdateOngoingCuraiVisitFromAnotherNoriConversationMutationOptions(
      options,
    ),
    queryClient,
  );
};

/**
 * @summary Resume Curai Visit
 */
export const resumeCuraiVisit = (
  conversationId: string,
  signal?: AbortSignal,
) => {
  return orvalClient<unknown>({
    url: `/clinic/visit/${conversationId}/resume`,
    method: "PUT",
    signal,
  });
};

export const getResumeCuraiVisitMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resumeCuraiVisit>>,
    TError,
    { conversationId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof resumeCuraiVisit>>,
  TError,
  { conversationId: string },
  TContext
> => {
  const mutationKey = ["resumeCuraiVisit"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof resumeCuraiVisit>>,
    { conversationId: string }
  > = (props) => {
    const { conversationId } = props ?? {};

    return resumeCuraiVisit(conversationId);
  };

  return { mutationFn, ...mutationOptions };
};

export type ResumeCuraiVisitClinicVisitConversationIdResumePutMutationResult =
  NonNullable<Awaited<ReturnType<typeof resumeCuraiVisit>>>;

export type ResumeCuraiVisitClinicVisitConversationIdResumePutMutationError =
  HTTPValidationError;

/**
 * @summary Resume Curai Visit
 */
export const useResumeCuraiVisit = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof resumeCuraiVisit>>,
      TError,
      { conversationId: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof resumeCuraiVisit>>,
  TError,
  { conversationId: string },
  TContext
> => {
  return useMutation(getResumeCuraiVisitMutationOptions(options), queryClient);
};

/**
 * Get status of encounter associated with Curai visit
 * @summary Get Status Of Encounter Associated With Curai Visit
 */
export const getStatusOfEncounterAssociatedWithCuraiVisit = (
  conversationId: string,
  params?: GetStatusOfEncounterAssociatedWithCuraiVisitClinicVisitConversationIdStatusGetParams,
  signal?: AbortSignal,
) => {
  return orvalClient<UniversalClinicVisitStatusResponse>({
    url: `/clinic/visit/${conversationId}/status`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetStatusOfEncounterAssociatedWithCuraiVisitQueryKey = (
  conversationId: string,
  params?: GetStatusOfEncounterAssociatedWithCuraiVisitClinicVisitConversationIdStatusGetParams,
) => {
  return [
    `/clinic/visit/${conversationId}/status`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetStatusOfEncounterAssociatedWithCuraiVisitQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getStatusOfEncounterAssociatedWithCuraiVisit>
  >,
  TError = HTTPValidationError,
>(
  conversationId: string,
  params?: GetStatusOfEncounterAssociatedWithCuraiVisitClinicVisitConversationIdStatusGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getStatusOfEncounterAssociatedWithCuraiVisit>
        >,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetStatusOfEncounterAssociatedWithCuraiVisitQueryKey(
      conversationId,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getStatusOfEncounterAssociatedWithCuraiVisit>>
  > = ({ signal }) =>
    getStatusOfEncounterAssociatedWithCuraiVisit(
      conversationId,
      params,
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: conversationId !== null && conversationId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getStatusOfEncounterAssociatedWithCuraiVisit>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetStatusOfEncounterAssociatedWithCuraiVisitClinicVisitConversationIdStatusGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getStatusOfEncounterAssociatedWithCuraiVisit>>
  >;
export type GetStatusOfEncounterAssociatedWithCuraiVisitClinicVisitConversationIdStatusGetQueryError =
  HTTPValidationError;

export function useGetStatusOfEncounterAssociatedWithCuraiVisit<
  TData = Awaited<
    ReturnType<typeof getStatusOfEncounterAssociatedWithCuraiVisit>
  >,
  TError = HTTPValidationError,
>(
  conversationId: string,
  params:
    | undefined
    | GetStatusOfEncounterAssociatedWithCuraiVisitClinicVisitConversationIdStatusGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getStatusOfEncounterAssociatedWithCuraiVisit>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getStatusOfEncounterAssociatedWithCuraiVisit>
          >,
          TError,
          Awaited<
            ReturnType<typeof getStatusOfEncounterAssociatedWithCuraiVisit>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetStatusOfEncounterAssociatedWithCuraiVisit<
  TData = Awaited<
    ReturnType<typeof getStatusOfEncounterAssociatedWithCuraiVisit>
  >,
  TError = HTTPValidationError,
>(
  conversationId: string,
  params?: GetStatusOfEncounterAssociatedWithCuraiVisitClinicVisitConversationIdStatusGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getStatusOfEncounterAssociatedWithCuraiVisit>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getStatusOfEncounterAssociatedWithCuraiVisit>
          >,
          TError,
          Awaited<
            ReturnType<typeof getStatusOfEncounterAssociatedWithCuraiVisit>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetStatusOfEncounterAssociatedWithCuraiVisit<
  TData = Awaited<
    ReturnType<typeof getStatusOfEncounterAssociatedWithCuraiVisit>
  >,
  TError = HTTPValidationError,
>(
  conversationId: string,
  params?: GetStatusOfEncounterAssociatedWithCuraiVisitClinicVisitConversationIdStatusGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getStatusOfEncounterAssociatedWithCuraiVisit>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Status Of Encounter Associated With Curai Visit
 */

export function useGetStatusOfEncounterAssociatedWithCuraiVisit<
  TData = Awaited<
    ReturnType<typeof getStatusOfEncounterAssociatedWithCuraiVisit>
  >,
  TError = HTTPValidationError,
>(
  conversationId: string,
  params?: GetStatusOfEncounterAssociatedWithCuraiVisitClinicVisitConversationIdStatusGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getStatusOfEncounterAssociatedWithCuraiVisit>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetStatusOfEncounterAssociatedWithCuraiVisitQueryOptions(
      conversationId,
      params,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Temp route to backfill ``universal_clinic_id`` to match clinic_request_ids
 * Returns 404 with an explicit reason for shapes the resolver can't bind to
 * @summary Resolve A Universal-Clinic External Session Id To Its Canonical Clinicrequest Id
 */
export const resolveAUniversalClinicExternalSessionIdToItsCanonicalClinicrequestId =
  (
    params: ResolveAUniversalClinicExternalSessionIdToItsCanonicalClinicRequestIdClinicRequestResolveGetParams,
    signal?: AbortSignal,
  ) => {
    return orvalClient<ResolveExternalSessionResponse>({
      url: `/clinic/request/resolve`,
      method: "GET",
      params,
      signal,
    });
  };

export const getResolveAUniversalClinicExternalSessionIdToItsCanonicalClinicrequestIdQueryKey =
  (
    params?: ResolveAUniversalClinicExternalSessionIdToItsCanonicalClinicRequestIdClinicRequestResolveGetParams,
  ) => {
    return [`/clinic/request/resolve`, ...(params ? [params] : [])] as const;
  };

export const getResolveAUniversalClinicExternalSessionIdToItsCanonicalClinicrequestIdQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof resolveAUniversalClinicExternalSessionIdToItsCanonicalClinicrequestId
      >
    >,
    TError = HTTPValidationError,
  >(
    params: ResolveAUniversalClinicExternalSessionIdToItsCanonicalClinicRequestIdClinicRequestResolveGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof resolveAUniversalClinicExternalSessionIdToItsCanonicalClinicrequestId
            >
          >,
          TError,
          TData
        >
      >;
    },
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getResolveAUniversalClinicExternalSessionIdToItsCanonicalClinicrequestIdQueryKey(
        params,
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof resolveAUniversalClinicExternalSessionIdToItsCanonicalClinicrequestId
        >
      >
    > = ({ signal }) =>
      resolveAUniversalClinicExternalSessionIdToItsCanonicalClinicrequestId(
        params,
        signal,
      );

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof resolveAUniversalClinicExternalSessionIdToItsCanonicalClinicrequestId
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
  };

export type ResolveAUniversalClinicExternalSessionIdToItsCanonicalClinicRequestIdClinicRequestResolveGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof resolveAUniversalClinicExternalSessionIdToItsCanonicalClinicrequestId
      >
    >
  >;
export type ResolveAUniversalClinicExternalSessionIdToItsCanonicalClinicRequestIdClinicRequestResolveGetQueryError =
  HTTPValidationError;

export function useResolveAUniversalClinicExternalSessionIdToItsCanonicalClinicrequestId<
  TData = Awaited<
    ReturnType<
      typeof resolveAUniversalClinicExternalSessionIdToItsCanonicalClinicrequestId
    >
  >,
  TError = HTTPValidationError,
>(
  params: ResolveAUniversalClinicExternalSessionIdToItsCanonicalClinicRequestIdClinicRequestResolveGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof resolveAUniversalClinicExternalSessionIdToItsCanonicalClinicrequestId
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof resolveAUniversalClinicExternalSessionIdToItsCanonicalClinicrequestId
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof resolveAUniversalClinicExternalSessionIdToItsCanonicalClinicrequestId
            >
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useResolveAUniversalClinicExternalSessionIdToItsCanonicalClinicrequestId<
  TData = Awaited<
    ReturnType<
      typeof resolveAUniversalClinicExternalSessionIdToItsCanonicalClinicrequestId
    >
  >,
  TError = HTTPValidationError,
>(
  params: ResolveAUniversalClinicExternalSessionIdToItsCanonicalClinicRequestIdClinicRequestResolveGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof resolveAUniversalClinicExternalSessionIdToItsCanonicalClinicrequestId
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof resolveAUniversalClinicExternalSessionIdToItsCanonicalClinicrequestId
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof resolveAUniversalClinicExternalSessionIdToItsCanonicalClinicrequestId
            >
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useResolveAUniversalClinicExternalSessionIdToItsCanonicalClinicrequestId<
  TData = Awaited<
    ReturnType<
      typeof resolveAUniversalClinicExternalSessionIdToItsCanonicalClinicrequestId
    >
  >,
  TError = HTTPValidationError,
>(
  params: ResolveAUniversalClinicExternalSessionIdToItsCanonicalClinicRequestIdClinicRequestResolveGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof resolveAUniversalClinicExternalSessionIdToItsCanonicalClinicrequestId
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Resolve A Universal-Clinic External Session Id To Its Canonical Clinicrequest Id
 */

export function useResolveAUniversalClinicExternalSessionIdToItsCanonicalClinicrequestId<
  TData = Awaited<
    ReturnType<
      typeof resolveAUniversalClinicExternalSessionIdToItsCanonicalClinicrequestId
    >
  >,
  TError = HTTPValidationError,
>(
  params: ResolveAUniversalClinicExternalSessionIdToItsCanonicalClinicRequestIdClinicRequestResolveGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof resolveAUniversalClinicExternalSessionIdToItsCanonicalClinicrequestId
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getResolveAUniversalClinicExternalSessionIdToItsCanonicalClinicrequestIdQueryOptions(
      params,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Returns the Braintrust span ids for the conversation for the given clinic request
 * Use by external services to append spans to the same trace.
 * Legacy curai/nori conversation ids are also accepted via ``resolve_external_session``
 * for now for backwards compatibility
 * @summary Get Braintrust Trace Metadata For A Clinic Request
 */
export const getBraintrustTraceMetadataForAClinicRequest = (
  clinicRequestId: string,
  params: GetBraintrustTraceMetadataForAClinicRequestClinicRequestClinicRequestIdTraceMetadataGetParams,
  signal?: AbortSignal,
) => {
  return orvalClient<ConversationTraceMetadataResponse>({
    url: `/clinic/request/${clinicRequestId}/trace-metadata`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetBraintrustTraceMetadataForAClinicRequestQueryKey = (
  clinicRequestId: string,
  params?: GetBraintrustTraceMetadataForAClinicRequestClinicRequestClinicRequestIdTraceMetadataGetParams,
) => {
  return [
    `/clinic/request/${clinicRequestId}/trace-metadata`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetBraintrustTraceMetadataForAClinicRequestQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getBraintrustTraceMetadataForAClinicRequest>
  >,
  TError = HTTPValidationError,
>(
  clinicRequestId: string,
  params: GetBraintrustTraceMetadataForAClinicRequestClinicRequestClinicRequestIdTraceMetadataGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getBraintrustTraceMetadataForAClinicRequest>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetBraintrustTraceMetadataForAClinicRequestQueryKey(
      clinicRequestId,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBraintrustTraceMetadataForAClinicRequest>>
  > = ({ signal }) =>
    getBraintrustTraceMetadataForAClinicRequest(
      clinicRequestId,
      params,
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: clinicRequestId !== null && clinicRequestId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getBraintrustTraceMetadataForAClinicRequest>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetBraintrustTraceMetadataForAClinicRequestClinicRequestClinicRequestIdTraceMetadataGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getBraintrustTraceMetadataForAClinicRequest>>
  >;
export type GetBraintrustTraceMetadataForAClinicRequestClinicRequestClinicRequestIdTraceMetadataGetQueryError =
  HTTPValidationError;

export function useGetBraintrustTraceMetadataForAClinicRequest<
  TData = Awaited<
    ReturnType<typeof getBraintrustTraceMetadataForAClinicRequest>
  >,
  TError = HTTPValidationError,
>(
  clinicRequestId: string,
  params: GetBraintrustTraceMetadataForAClinicRequestClinicRequestClinicRequestIdTraceMetadataGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getBraintrustTraceMetadataForAClinicRequest>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getBraintrustTraceMetadataForAClinicRequest>
          >,
          TError,
          Awaited<
            ReturnType<typeof getBraintrustTraceMetadataForAClinicRequest>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetBraintrustTraceMetadataForAClinicRequest<
  TData = Awaited<
    ReturnType<typeof getBraintrustTraceMetadataForAClinicRequest>
  >,
  TError = HTTPValidationError,
>(
  clinicRequestId: string,
  params: GetBraintrustTraceMetadataForAClinicRequestClinicRequestClinicRequestIdTraceMetadataGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getBraintrustTraceMetadataForAClinicRequest>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getBraintrustTraceMetadataForAClinicRequest>
          >,
          TError,
          Awaited<
            ReturnType<typeof getBraintrustTraceMetadataForAClinicRequest>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetBraintrustTraceMetadataForAClinicRequest<
  TData = Awaited<
    ReturnType<typeof getBraintrustTraceMetadataForAClinicRequest>
  >,
  TError = HTTPValidationError,
>(
  clinicRequestId: string,
  params: GetBraintrustTraceMetadataForAClinicRequestClinicRequestClinicRequestIdTraceMetadataGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getBraintrustTraceMetadataForAClinicRequest>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Braintrust Trace Metadata For A Clinic Request
 */

export function useGetBraintrustTraceMetadataForAClinicRequest<
  TData = Awaited<
    ReturnType<typeof getBraintrustTraceMetadataForAClinicRequest>
  >,
  TError = HTTPValidationError,
>(
  clinicRequestId: string,
  params: GetBraintrustTraceMetadataForAClinicRequestClinicRequestClinicRequestIdTraceMetadataGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getBraintrustTraceMetadataForAClinicRequest>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetBraintrustTraceMetadataForAClinicRequestQueryOptions(
      clinicRequestId,
      params,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Stores the clinic-side Braintrust child span id on the ClinicRequest for the given visit.
 *
 * Per-visit rather than per-conversation: a conversation can produce many visits over
 * its lifetime.
 * @summary Update Clinic Braintrust Trace Metadata For A Clinic Request
 */
export const updateClinicBraintrustTraceMetadataForAClinicRequest = (
  clinicRequestId: string,
  updateConversationTraceMetadataRequest: UpdateConversationTraceMetadataRequest,
  signal?: AbortSignal,
) => {
  return orvalClient<void>({
    url: `/clinic/request/${clinicRequestId}/trace-metadata`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: updateConversationTraceMetadataRequest,
    signal,
  });
};

export const getUpdateClinicBraintrustTraceMetadataForAClinicRequestMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof updateClinicBraintrustTraceMetadataForAClinicRequest>
      >,
      TError,
      { clinicRequestId: string; data: UpdateConversationTraceMetadataRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof updateClinicBraintrustTraceMetadataForAClinicRequest>
    >,
    TError,
    { clinicRequestId: string; data: UpdateConversationTraceMetadataRequest },
    TContext
  > => {
    const mutationKey = [
      "updateClinicBraintrustTraceMetadataForAClinicRequest",
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof updateClinicBraintrustTraceMetadataForAClinicRequest>
      >,
      { clinicRequestId: string; data: UpdateConversationTraceMetadataRequest }
    > = (props) => {
      const { clinicRequestId, data } = props ?? {};

      return updateClinicBraintrustTraceMetadataForAClinicRequest(
        clinicRequestId,
        data,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateClinicBraintrustTraceMetadataForAClinicRequestClinicRequestClinicRequestIdTraceMetadataPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof updateClinicBraintrustTraceMetadataForAClinicRequest>
    >
  >;
export type UpdateClinicBraintrustTraceMetadataForAClinicRequestClinicRequestClinicRequestIdTraceMetadataPutMutationBody =
  UpdateConversationTraceMetadataRequest;
export type UpdateClinicBraintrustTraceMetadataForAClinicRequestClinicRequestClinicRequestIdTraceMetadataPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Clinic Braintrust Trace Metadata For A Clinic Request
 */
export const useUpdateClinicBraintrustTraceMetadataForAClinicRequest = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof updateClinicBraintrustTraceMetadataForAClinicRequest>
      >,
      TError,
      { clinicRequestId: string; data: UpdateConversationTraceMetadataRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<
    ReturnType<typeof updateClinicBraintrustTraceMetadataForAClinicRequest>
  >,
  TError,
  { clinicRequestId: string; data: UpdateConversationTraceMetadataRequest },
  TContext
> => {
  return useMutation(
    getUpdateClinicBraintrustTraceMetadataForAClinicRequestMutationOptions(
      options,
    ),
    queryClient,
  );
};

/**
 * @summary Get Clinic Status For Patient
 */
export const getClinicStatusForPatient = (signal?: AbortSignal) => {
  return orvalClient<CuraiPatientStatusResponse>({
    url: `/clinic/patient/status`,
    method: "GET",
    signal,
  });
};

export const getGetClinicStatusForPatientQueryKey = () => {
  return [`/clinic/patient/status`] as const;
};

export const getGetClinicStatusForPatientQueryOptions = <
  TData = Awaited<ReturnType<typeof getClinicStatusForPatient>>,
  TError = HTTPValidationError,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getClinicStatusForPatient>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetClinicStatusForPatientQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getClinicStatusForPatient>>
  > = ({ signal }) => getClinicStatusForPatient(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getClinicStatusForPatient>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetClinicStatusForPatientClinicPatientStatusGetQueryResult =
  NonNullable<Awaited<ReturnType<typeof getClinicStatusForPatient>>>;
export type GetClinicStatusForPatientClinicPatientStatusGetQueryError =
  HTTPValidationError;

export function useGetClinicStatusForPatient<
  TData = Awaited<ReturnType<typeof getClinicStatusForPatient>>,
  TError = HTTPValidationError,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClinicStatusForPatient>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClinicStatusForPatient>>,
          TError,
          Awaited<ReturnType<typeof getClinicStatusForPatient>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetClinicStatusForPatient<
  TData = Awaited<ReturnType<typeof getClinicStatusForPatient>>,
  TError = HTTPValidationError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClinicStatusForPatient>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClinicStatusForPatient>>,
          TError,
          Awaited<ReturnType<typeof getClinicStatusForPatient>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetClinicStatusForPatient<
  TData = Awaited<ReturnType<typeof getClinicStatusForPatient>>,
  TError = HTTPValidationError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClinicStatusForPatient>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Clinic Status For Patient
 */

export function useGetClinicStatusForPatient<
  TData = Awaited<ReturnType<typeof getClinicStatusForPatient>>,
  TError = HTTPValidationError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClinicStatusForPatient>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetClinicStatusForPatientQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get Pre-Clinic Steps
 */
export const getPreClinicSteps = (
  params: GetPreClinicStepsClinicPreClinicStepsGetParams,
  signal?: AbortSignal,
) => {
  return orvalClient<PreClinicStepsResponse>({
    url: `/clinic/pre-clinic-steps`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetPreClinicStepsQueryKey = (
  params?: GetPreClinicStepsClinicPreClinicStepsGetParams,
) => {
  return [`/clinic/pre-clinic-steps`, ...(params ? [params] : [])] as const;
};

export const getGetPreClinicStepsQueryOptions = <
  TData = Awaited<ReturnType<typeof getPreClinicSteps>>,
  TError = HTTPValidationError,
>(
  params: GetPreClinicStepsClinicPreClinicStepsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPreClinicSteps>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetPreClinicStepsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPreClinicSteps>>
  > = ({ signal }) => getPreClinicSteps(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPreClinicSteps>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPreClinicStepsClinicPreClinicStepsGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPreClinicSteps>>
>;
export type GetPreClinicStepsClinicPreClinicStepsGetQueryError =
  HTTPValidationError;

export function useGetPreClinicSteps<
  TData = Awaited<ReturnType<typeof getPreClinicSteps>>,
  TError = HTTPValidationError,
>(
  params: GetPreClinicStepsClinicPreClinicStepsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPreClinicSteps>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPreClinicSteps>>,
          TError,
          Awaited<ReturnType<typeof getPreClinicSteps>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPreClinicSteps<
  TData = Awaited<ReturnType<typeof getPreClinicSteps>>,
  TError = HTTPValidationError,
>(
  params: GetPreClinicStepsClinicPreClinicStepsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPreClinicSteps>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPreClinicSteps>>,
          TError,
          Awaited<ReturnType<typeof getPreClinicSteps>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPreClinicSteps<
  TData = Awaited<ReturnType<typeof getPreClinicSteps>>,
  TError = HTTPValidationError,
>(
  params: GetPreClinicStepsClinicPreClinicStepsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPreClinicSteps>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Pre-Clinic Steps
 */

export function useGetPreClinicSteps<
  TData = Awaited<ReturnType<typeof getPreClinicSteps>>,
  TError = HTTPValidationError,
>(
  params: GetPreClinicStepsClinicPreClinicStepsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPreClinicSteps>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetPreClinicStepsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get Patient Order History
 */
export const getPatientOrderHistory = (
  params?: GetPatientOrderHistoryClinicOrdersGetParams,
  signal?: AbortSignal,
) => {
  return orvalClient<PatientOrderHistoryResponse>({
    url: `/clinic/orders`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetPatientOrderHistoryInfiniteQueryKey = (
  params?: GetPatientOrderHistoryClinicOrdersGetParams,
) => {
  return ["infinite", `/clinic/orders`, ...(params ? [params] : [])] as const;
};

export const getGetPatientOrderHistoryQueryKey = (
  params?: GetPatientOrderHistoryClinicOrdersGetParams,
) => {
  return [`/clinic/orders`, ...(params ? [params] : [])] as const;
};

export const getGetPatientOrderHistoryInfiniteQueryOptions = <
  TData = InfiniteData<
    Awaited<ReturnType<typeof getPatientOrderHistory>>,
    GetPatientOrderHistoryClinicOrdersGetParams["cursor"]
  >,
  TError = HTTPValidationError,
>(
  params?: GetPatientOrderHistoryClinicOrdersGetParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getPatientOrderHistory>>,
        TError,
        TData,
        QueryKey,
        GetPatientOrderHistoryClinicOrdersGetParams["cursor"]
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetPatientOrderHistoryInfiniteQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPatientOrderHistory>>,
    QueryKey,
    GetPatientOrderHistoryClinicOrdersGetParams["cursor"]
  > = ({ signal, pageParam }) =>
    getPatientOrderHistory(
      { ...params, cursor: pageParam ?? params?.["cursor"] },
      signal,
    );

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getPatientOrderHistory>>,
    TError,
    TData,
    QueryKey,
    GetPatientOrderHistoryClinicOrdersGetParams["cursor"]
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPatientOrderHistoryClinicOrdersGetInfiniteQueryResult =
  NonNullable<Awaited<ReturnType<typeof getPatientOrderHistory>>>;
export type GetPatientOrderHistoryClinicOrdersGetInfiniteQueryError =
  HTTPValidationError;

export function useGetPatientOrderHistoryInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getPatientOrderHistory>>,
    GetPatientOrderHistoryClinicOrdersGetParams["cursor"]
  >,
  TError = HTTPValidationError,
>(
  params: undefined | GetPatientOrderHistoryClinicOrdersGetParams,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getPatientOrderHistory>>,
        TError,
        TData,
        QueryKey,
        GetPatientOrderHistoryClinicOrdersGetParams["cursor"]
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientOrderHistory>>,
          TError,
          Awaited<ReturnType<typeof getPatientOrderHistory>>,
          QueryKey
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPatientOrderHistoryInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getPatientOrderHistory>>,
    GetPatientOrderHistoryClinicOrdersGetParams["cursor"]
  >,
  TError = HTTPValidationError,
>(
  params?: GetPatientOrderHistoryClinicOrdersGetParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getPatientOrderHistory>>,
        TError,
        TData,
        QueryKey,
        GetPatientOrderHistoryClinicOrdersGetParams["cursor"]
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientOrderHistory>>,
          TError,
          Awaited<ReturnType<typeof getPatientOrderHistory>>,
          QueryKey
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPatientOrderHistoryInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getPatientOrderHistory>>,
    GetPatientOrderHistoryClinicOrdersGetParams["cursor"]
  >,
  TError = HTTPValidationError,
>(
  params?: GetPatientOrderHistoryClinicOrdersGetParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getPatientOrderHistory>>,
        TError,
        TData,
        QueryKey,
        GetPatientOrderHistoryClinicOrdersGetParams["cursor"]
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Patient Order History
 */

export function useGetPatientOrderHistoryInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getPatientOrderHistory>>,
    GetPatientOrderHistoryClinicOrdersGetParams["cursor"]
  >,
  TError = HTTPValidationError,
>(
  params?: GetPatientOrderHistoryClinicOrdersGetParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getPatientOrderHistory>>,
        TError,
        TData,
        QueryKey,
        GetPatientOrderHistoryClinicOrdersGetParams["cursor"]
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetPatientOrderHistoryInfiniteQueryOptions(
    params,
    options,
  );

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetPatientOrderHistoryQueryOptions = <
  TData = Awaited<ReturnType<typeof getPatientOrderHistory>>,
  TError = HTTPValidationError,
>(
  params?: GetPatientOrderHistoryClinicOrdersGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPatientOrderHistory>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetPatientOrderHistoryQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPatientOrderHistory>>
  > = ({ signal }) => getPatientOrderHistory(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPatientOrderHistory>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPatientOrderHistoryClinicOrdersGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPatientOrderHistory>>
>;
export type GetPatientOrderHistoryClinicOrdersGetQueryError =
  HTTPValidationError;

export function useGetPatientOrderHistory<
  TData = Awaited<ReturnType<typeof getPatientOrderHistory>>,
  TError = HTTPValidationError,
>(
  params: undefined | GetPatientOrderHistoryClinicOrdersGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPatientOrderHistory>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientOrderHistory>>,
          TError,
          Awaited<ReturnType<typeof getPatientOrderHistory>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPatientOrderHistory<
  TData = Awaited<ReturnType<typeof getPatientOrderHistory>>,
  TError = HTTPValidationError,
>(
  params?: GetPatientOrderHistoryClinicOrdersGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPatientOrderHistory>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientOrderHistory>>,
          TError,
          Awaited<ReturnType<typeof getPatientOrderHistory>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPatientOrderHistory<
  TData = Awaited<ReturnType<typeof getPatientOrderHistory>>,
  TError = HTTPValidationError,
>(
  params?: GetPatientOrderHistoryClinicOrdersGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPatientOrderHistory>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Patient Order History
 */

export function useGetPatientOrderHistory<
  TData = Awaited<ReturnType<typeof getPatientOrderHistory>>,
  TError = HTTPValidationError,
>(
  params?: GetPatientOrderHistoryClinicOrdersGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPatientOrderHistory>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetPatientOrderHistoryQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Get all of the user's care plans across conversations, most recent first.
 * @summary Get Patient Care Plans
 */
export const getPatientCarePlans = (signal?: AbortSignal) => {
  return orvalClient<CarePlanListItem[]>({
    url: `/clinic/care-plans`,
    method: "GET",
    signal,
  });
};

export const getGetPatientCarePlansQueryKey = () => {
  return [`/clinic/care-plans`] as const;
};

export const getGetPatientCarePlansQueryOptions = <
  TData = Awaited<ReturnType<typeof getPatientCarePlans>>,
  TError = HTTPValidationError,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getPatientCarePlans>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPatientCarePlansQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPatientCarePlans>>
  > = ({ signal }) => getPatientCarePlans(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPatientCarePlans>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPatientCarePlansClinicCarePlansGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPatientCarePlans>>
>;
export type GetPatientCarePlansClinicCarePlansGetQueryError =
  HTTPValidationError;

export function useGetPatientCarePlans<
  TData = Awaited<ReturnType<typeof getPatientCarePlans>>,
  TError = HTTPValidationError,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPatientCarePlans>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientCarePlans>>,
          TError,
          Awaited<ReturnType<typeof getPatientCarePlans>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPatientCarePlans<
  TData = Awaited<ReturnType<typeof getPatientCarePlans>>,
  TError = HTTPValidationError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPatientCarePlans>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientCarePlans>>,
          TError,
          Awaited<ReturnType<typeof getPatientCarePlans>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPatientCarePlans<
  TData = Awaited<ReturnType<typeof getPatientCarePlans>>,
  TError = HTTPValidationError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPatientCarePlans>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Patient Care Plans
 */

export function useGetPatientCarePlans<
  TData = Awaited<ReturnType<typeof getPatientCarePlans>>,
  TError = HTTPValidationError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPatientCarePlans>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetPatientCarePlansQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Send a message in a Curai visit
 * @summary Send Message In Curai Visit
 */
export const sendMessageInCuraiVisit = (
  conversationId: string,
  sendCuraiMessageRequest: SendCuraiMessageRequest,
  signal?: AbortSignal,
) => {
  return orvalClient<SendCuraiMessageResponse>({
    url: `/clinic/visit/${conversationId}/message`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: sendCuraiMessageRequest,
    signal,
  });
};

export const getSendMessageInCuraiVisitMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendMessageInCuraiVisit>>,
    TError,
    { conversationId: string; data: SendCuraiMessageRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sendMessageInCuraiVisit>>,
  TError,
  { conversationId: string; data: SendCuraiMessageRequest },
  TContext
> => {
  const mutationKey = ["sendMessageInCuraiVisit"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sendMessageInCuraiVisit>>,
    { conversationId: string; data: SendCuraiMessageRequest }
  > = (props) => {
    const { conversationId, data } = props ?? {};

    return sendMessageInCuraiVisit(conversationId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type SendMessageInCuraiVisitClinicVisitConversationIdMessagePostMutationResult =
  NonNullable<Awaited<ReturnType<typeof sendMessageInCuraiVisit>>>;
export type SendMessageInCuraiVisitClinicVisitConversationIdMessagePostMutationBody =
  SendCuraiMessageRequest;
export type SendMessageInCuraiVisitClinicVisitConversationIdMessagePostMutationError =
  HTTPValidationError;

/**
 * @summary Send Message In Curai Visit
 */
export const useSendMessageInCuraiVisit = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof sendMessageInCuraiVisit>>,
      TError,
      { conversationId: string; data: SendCuraiMessageRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof sendMessageInCuraiVisit>>,
  TError,
  { conversationId: string; data: SendCuraiMessageRequest },
  TContext
> => {
  return useMutation(
    getSendMessageInCuraiVisitMutationOptions(options),
    queryClient,
  );
};

/**
 * Webhook for Curai to close a conversation at the conclusion of a Curai visit
 * @summary Close Conversation
 */
export const closeConversation = (
  closeConversationRequest: CloseConversationRequest,
  signal?: AbortSignal,
) => {
  return orvalClient<unknown>({
    url: `/clinic/visit/close`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: closeConversationRequest,
    signal,
  });
};

export const getCloseConversationMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof closeConversation>>,
    TError,
    { data: CloseConversationRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof closeConversation>>,
  TError,
  { data: CloseConversationRequest },
  TContext
> => {
  const mutationKey = ["closeConversation"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof closeConversation>>,
    { data: CloseConversationRequest }
  > = (props) => {
    const { data } = props ?? {};

    return closeConversation(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CloseConversationClinicVisitClosePostMutationResult = NonNullable<
  Awaited<ReturnType<typeof closeConversation>>
>;
export type CloseConversationClinicVisitClosePostMutationBody =
  CloseConversationRequest;
export type CloseConversationClinicVisitClosePostMutationError =
  HTTPValidationError;

/**
 * @summary Close Conversation
 */
export const useCloseConversation = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof closeConversation>>,
      TError,
      { data: CloseConversationRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof closeConversation>>,
  TError,
  { data: CloseConversationRequest },
  TContext
> => {
  return useMutation(getCloseConversationMutationOptions(options), queryClient);
};

/**
 * Get requirements for starting a clinic visit based on the patient's state.
 * @summary Get Clinic Visit Requirements
 */
export const getClinicVisitRequirements = (
  params: GetClinicVisitRequirementsClinicRequirementsGetParams,
  signal?: AbortSignal,
) => {
  return orvalClient<ClinicRequirementsResponse>({
    url: `/clinic/requirements`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetClinicVisitRequirementsQueryKey = (
  params?: GetClinicVisitRequirementsClinicRequirementsGetParams,
) => {
  return [`/clinic/requirements`, ...(params ? [params] : [])] as const;
};

export const getGetClinicVisitRequirementsQueryOptions = <
  TData = Awaited<ReturnType<typeof getClinicVisitRequirements>>,
  TError = HTTPValidationError,
>(
  params: GetClinicVisitRequirementsClinicRequirementsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClinicVisitRequirements>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetClinicVisitRequirementsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getClinicVisitRequirements>>
  > = ({ signal }) => getClinicVisitRequirements(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getClinicVisitRequirements>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetClinicVisitRequirementsClinicRequirementsGetQueryResult =
  NonNullable<Awaited<ReturnType<typeof getClinicVisitRequirements>>>;
export type GetClinicVisitRequirementsClinicRequirementsGetQueryError =
  HTTPValidationError;

export function useGetClinicVisitRequirements<
  TData = Awaited<ReturnType<typeof getClinicVisitRequirements>>,
  TError = HTTPValidationError,
>(
  params: GetClinicVisitRequirementsClinicRequirementsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClinicVisitRequirements>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClinicVisitRequirements>>,
          TError,
          Awaited<ReturnType<typeof getClinicVisitRequirements>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetClinicVisitRequirements<
  TData = Awaited<ReturnType<typeof getClinicVisitRequirements>>,
  TError = HTTPValidationError,
>(
  params: GetClinicVisitRequirementsClinicRequirementsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClinicVisitRequirements>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClinicVisitRequirements>>,
          TError,
          Awaited<ReturnType<typeof getClinicVisitRequirements>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetClinicVisitRequirements<
  TData = Awaited<ReturnType<typeof getClinicVisitRequirements>>,
  TError = HTTPValidationError,
>(
  params: GetClinicVisitRequirementsClinicRequirementsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClinicVisitRequirements>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Clinic Visit Requirements
 */

export function useGetClinicVisitRequirements<
  TData = Awaited<ReturnType<typeof getClinicVisitRequirements>>,
  TError = HTTPValidationError,
>(
  params: GetClinicVisitRequirementsClinicRequirementsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClinicVisitRequirements>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetClinicVisitRequirementsQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Search Pharmacies
 */
export const searchPharmacies = (
  pharmacySearchRequest: PharmacySearchRequest,
  signal?: AbortSignal,
) => {
  return orvalClient<PharmacyLocation[]>({
    url: `/clinic/pharmacies/search`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: pharmacySearchRequest,
    signal,
  });
};

export const getSearchPharmaciesMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof searchPharmacies>>,
    TError,
    { data: PharmacySearchRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof searchPharmacies>>,
  TError,
  { data: PharmacySearchRequest },
  TContext
> => {
  const mutationKey = ["searchPharmacies"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof searchPharmacies>>,
    { data: PharmacySearchRequest }
  > = (props) => {
    const { data } = props ?? {};

    return searchPharmacies(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type SearchPharmaciesClinicPharmaciesSearchPostMutationResult =
  NonNullable<Awaited<ReturnType<typeof searchPharmacies>>>;
export type SearchPharmaciesClinicPharmaciesSearchPostMutationBody =
  PharmacySearchRequest;
export type SearchPharmaciesClinicPharmaciesSearchPostMutationError =
  HTTPValidationError;

/**
 * @summary Search Pharmacies
 */
export const useSearchPharmacies = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof searchPharmacies>>,
      TError,
      { data: PharmacySearchRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof searchPharmacies>>,
  TError,
  { data: PharmacySearchRequest },
  TContext
> => {
  return useMutation(getSearchPharmaciesMutationOptions(options), queryClient);
};

/**
 * @summary Get Memory From Conversation By Type
 */
export const getMemoryFromConversationByType = (
  conversationId: string,
  memoryType: string,
  signal?: AbortSignal,
) => {
  return orvalClient<MemoryResponse>({
    url: `/clinic/memory/${conversationId}/${memoryType}`,
    method: "GET",
    signal,
  });
};

export const getGetMemoryFromConversationByTypeQueryKey = (
  conversationId: string,
  memoryType: string,
) => {
  return [`/clinic/memory/${conversationId}/${memoryType}`] as const;
};

export const getGetMemoryFromConversationByTypeQueryOptions = <
  TData = Awaited<ReturnType<typeof getMemoryFromConversationByType>>,
  TError = HTTPValidationError,
>(
  conversationId: string,
  memoryType: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMemoryFromConversationByType>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetMemoryFromConversationByTypeQueryKey(conversationId, memoryType);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMemoryFromConversationByType>>
  > = ({ signal }) =>
    getMemoryFromConversationByType(conversationId, memoryType, signal);

  return {
    queryKey,
    queryFn,
    enabled:
      conversationId !== null &&
      conversationId !== undefined &&
      memoryType !== null &&
      memoryType !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getMemoryFromConversationByType>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMemoryFromConversationByTypeClinicMemoryConversationIdMemoryTypeGetQueryResult =
  NonNullable<Awaited<ReturnType<typeof getMemoryFromConversationByType>>>;
export type GetMemoryFromConversationByTypeClinicMemoryConversationIdMemoryTypeGetQueryError =
  HTTPValidationError;

export function useGetMemoryFromConversationByType<
  TData = Awaited<ReturnType<typeof getMemoryFromConversationByType>>,
  TError = HTTPValidationError,
>(
  conversationId: string,
  memoryType: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMemoryFromConversationByType>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMemoryFromConversationByType>>,
          TError,
          Awaited<ReturnType<typeof getMemoryFromConversationByType>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetMemoryFromConversationByType<
  TData = Awaited<ReturnType<typeof getMemoryFromConversationByType>>,
  TError = HTTPValidationError,
>(
  conversationId: string,
  memoryType: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMemoryFromConversationByType>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMemoryFromConversationByType>>,
          TError,
          Awaited<ReturnType<typeof getMemoryFromConversationByType>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetMemoryFromConversationByType<
  TData = Awaited<ReturnType<typeof getMemoryFromConversationByType>>,
  TError = HTTPValidationError,
>(
  conversationId: string,
  memoryType: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMemoryFromConversationByType>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Memory From Conversation By Type
 */

export function useGetMemoryFromConversationByType<
  TData = Awaited<ReturnType<typeof getMemoryFromConversationByType>>,
  TError = HTTPValidationError,
>(
  conversationId: string,
  memoryType: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMemoryFromConversationByType>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetMemoryFromConversationByTypeQueryOptions(
    conversationId,
    memoryType,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Create Event
 */
export const createEvent = (
  incomingEventModel: IncomingEventModel,
  signal?: AbortSignal,
) => {
  return orvalClient<unknown>({
    url: `/clinic/event`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: incomingEventModel,
    signal,
  });
};

export const getCreateEventMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createEvent>>,
    TError,
    { data: IncomingEventModel },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createEvent>>,
  TError,
  { data: IncomingEventModel },
  TContext
> => {
  const mutationKey = ["createEvent"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createEvent>>,
    { data: IncomingEventModel }
  > = (props) => {
    const { data } = props ?? {};

    return createEvent(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateEventClinicEventPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof createEvent>>
>;
export type CreateEventClinicEventPostMutationBody = IncomingEventModel;
export type CreateEventClinicEventPostMutationError = HTTPValidationError;

/**
 * @summary Create Event
 */
export const useCreateEvent = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createEvent>>,
      TError,
      { data: IncomingEventModel },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createEvent>>,
  TError,
  { data: IncomingEventModel },
  TContext
> => {
  return useMutation(getCreateEventMutationOptions(options), queryClient);
};

/**
 * @summary Stage Test Visit
 */
export const stageTestVisit = (
  noriConversationId: string,
  signal?: AbortSignal,
) => {
  return orvalClient<unknown>({
    url: `/clinic/stage-test-visit/${noriConversationId}`,
    method: "POST",
    signal,
  });
};

export const getStageTestVisitMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof stageTestVisit>>,
    TError,
    { noriConversationId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof stageTestVisit>>,
  TError,
  { noriConversationId: string },
  TContext
> => {
  const mutationKey = ["stageTestVisit"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof stageTestVisit>>,
    { noriConversationId: string }
  > = (props) => {
    const { noriConversationId } = props ?? {};

    return stageTestVisit(noriConversationId);
  };

  return { mutationFn, ...mutationOptions };
};

export type StageTestVisitClinicStageTestVisitNoriConversationIdPostMutationResult =
  NonNullable<Awaited<ReturnType<typeof stageTestVisit>>>;

export type StageTestVisitClinicStageTestVisitNoriConversationIdPostMutationError =
  HTTPValidationError;

/**
 * @summary Stage Test Visit
 */
export const useStageTestVisit = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof stageTestVisit>>,
      TError,
      { noriConversationId: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof stageTestVisit>>,
  TError,
  { noriConversationId: string },
  TContext
> => {
  return useMutation(getStageTestVisitMutationOptions(options), queryClient);
};

/**
 * Queue Universal Clinic outreach for delivery in a Nori conversation.
 * @summary Create Outreach Conversation From Universal Clinic
 */
export const createOutreachConversationFromUniversalClinic = (
  incomingOutreachModel: IncomingOutreachModel,
  signal?: AbortSignal,
) => {
  return orvalClient<unknown>({
    url: `/clinic/outreach`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: incomingOutreachModel,
    signal,
  });
};

export const getCreateOutreachConversationFromUniversalClinicMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createOutreachConversationFromUniversalClinic>>,
    TError,
    { data: IncomingOutreachModel },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createOutreachConversationFromUniversalClinic>>,
  TError,
  { data: IncomingOutreachModel },
  TContext
> => {
  const mutationKey = ["createOutreachConversationFromUniversalClinic"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createOutreachConversationFromUniversalClinic>>,
    { data: IncomingOutreachModel }
  > = (props) => {
    const { data } = props ?? {};

    return createOutreachConversationFromUniversalClinic(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateOutreachConversationFromUniversalClinicClinicOutreachPostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof createOutreachConversationFromUniversalClinic>>
  >;
export type CreateOutreachConversationFromUniversalClinicClinicOutreachPostMutationBody =
  IncomingOutreachModel;
export type CreateOutreachConversationFromUniversalClinicClinicOutreachPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Outreach Conversation From Universal Clinic
 */
export const useCreateOutreachConversationFromUniversalClinic = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createOutreachConversationFromUniversalClinic>>,
      TError,
      { data: IncomingOutreachModel },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createOutreachConversationFromUniversalClinic>>,
  TError,
  { data: IncomingOutreachModel },
  TContext
> => {
  return useMutation(
    getCreateOutreachConversationFromUniversalClinicMutationOptions(options),
    queryClient,
  );
};

/**
 * Create a video visit token
 * @summary Create Video Visit Meeting Token
 */
export const createVideoVisitMeetingToken = (
  videoVisitTokenRequest: VideoVisitTokenRequest,
  signal?: AbortSignal,
) => {
  return orvalClient<VideoVisitTokenResponse>({
    url: `/clinic/video-visit/token`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: videoVisitTokenRequest,
    signal,
  });
};

export const getCreateVideoVisitMeetingTokenMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createVideoVisitMeetingToken>>,
    TError,
    { data: VideoVisitTokenRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createVideoVisitMeetingToken>>,
  TError,
  { data: VideoVisitTokenRequest },
  TContext
> => {
  const mutationKey = ["createVideoVisitMeetingToken"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createVideoVisitMeetingToken>>,
    { data: VideoVisitTokenRequest }
  > = (props) => {
    const { data } = props ?? {};

    return createVideoVisitMeetingToken(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateVideoVisitMeetingTokenClinicVideoVisitTokenPostMutationResult =
  NonNullable<Awaited<ReturnType<typeof createVideoVisitMeetingToken>>>;
export type CreateVideoVisitMeetingTokenClinicVideoVisitTokenPostMutationBody =
  VideoVisitTokenRequest;
export type CreateVideoVisitMeetingTokenClinicVideoVisitTokenPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Video Visit Meeting Token
 */
export const useCreateVideoVisitMeetingToken = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createVideoVisitMeetingToken>>,
      TError,
      { data: VideoVisitTokenRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createVideoVisitMeetingToken>>,
  TError,
  { data: VideoVisitTokenRequest },
  TContext
> => {
  return useMutation(
    getCreateVideoVisitMeetingTokenMutationOptions(options),
    queryClient,
  );
};

/**
 * Record the patient's per-encounter consent to record (and use AI on) the video visit.
 * @summary Set Video Visit Recording Consent
 */
export const setVideoVisitRecordingConsent = (
  videoVisitConsentRequest: VideoVisitConsentRequest,
  signal?: AbortSignal,
) => {
  return orvalClient<VideoVisitConsentResponse>({
    url: `/clinic/video-visit/consent`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: videoVisitConsentRequest,
    signal,
  });
};

export const getSetVideoVisitRecordingConsentMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setVideoVisitRecordingConsent>>,
    TError,
    { data: VideoVisitConsentRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof setVideoVisitRecordingConsent>>,
  TError,
  { data: VideoVisitConsentRequest },
  TContext
> => {
  const mutationKey = ["setVideoVisitRecordingConsent"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setVideoVisitRecordingConsent>>,
    { data: VideoVisitConsentRequest }
  > = (props) => {
    const { data } = props ?? {};

    return setVideoVisitRecordingConsent(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type SetVideoVisitRecordingConsentClinicVideoVisitConsentPostMutationResult =
  NonNullable<Awaited<ReturnType<typeof setVideoVisitRecordingConsent>>>;
export type SetVideoVisitRecordingConsentClinicVideoVisitConsentPostMutationBody =
  VideoVisitConsentRequest;
export type SetVideoVisitRecordingConsentClinicVideoVisitConsentPostMutationError =
  HTTPValidationError;

/**
 * @summary Set Video Visit Recording Consent
 */
export const useSetVideoVisitRecordingConsent = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof setVideoVisitRecordingConsent>>,
      TError,
      { data: VideoVisitConsentRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof setVideoVisitRecordingConsent>>,
  TError,
  { data: VideoVisitConsentRequest },
  TContext
> => {
  return useMutation(
    getSetVideoVisitRecordingConsentMutationOptions(options),
    queryClient,
  );
};

/**
 * Read per-encounter recording consent (bool; fail-closed to False).
 * @summary Get Video Visit Recording Consent
 */
export const getVideoVisitRecordingConsent = (
  params: GetVideoVisitRecordingConsentClinicVideoVisitConsentGetParams,
  signal?: AbortSignal,
) => {
  return orvalClient<VideoVisitConsentResponse>({
    url: `/clinic/video-visit/consent`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetVideoVisitRecordingConsentQueryKey = (
  params?: GetVideoVisitRecordingConsentClinicVideoVisitConsentGetParams,
) => {
  return [`/clinic/video-visit/consent`, ...(params ? [params] : [])] as const;
};

export const getGetVideoVisitRecordingConsentQueryOptions = <
  TData = Awaited<ReturnType<typeof getVideoVisitRecordingConsent>>,
  TError = HTTPValidationError,
>(
  params: GetVideoVisitRecordingConsentClinicVideoVisitConsentGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getVideoVisitRecordingConsent>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetVideoVisitRecordingConsentQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getVideoVisitRecordingConsent>>
  > = ({ signal }) => getVideoVisitRecordingConsent(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getVideoVisitRecordingConsent>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetVideoVisitRecordingConsentClinicVideoVisitConsentGetQueryResult =
  NonNullable<Awaited<ReturnType<typeof getVideoVisitRecordingConsent>>>;
export type GetVideoVisitRecordingConsentClinicVideoVisitConsentGetQueryError =
  HTTPValidationError;

export function useGetVideoVisitRecordingConsent<
  TData = Awaited<ReturnType<typeof getVideoVisitRecordingConsent>>,
  TError = HTTPValidationError,
>(
  params: GetVideoVisitRecordingConsentClinicVideoVisitConsentGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getVideoVisitRecordingConsent>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVideoVisitRecordingConsent>>,
          TError,
          Awaited<ReturnType<typeof getVideoVisitRecordingConsent>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetVideoVisitRecordingConsent<
  TData = Awaited<ReturnType<typeof getVideoVisitRecordingConsent>>,
  TError = HTTPValidationError,
>(
  params: GetVideoVisitRecordingConsentClinicVideoVisitConsentGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getVideoVisitRecordingConsent>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVideoVisitRecordingConsent>>,
          TError,
          Awaited<ReturnType<typeof getVideoVisitRecordingConsent>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetVideoVisitRecordingConsent<
  TData = Awaited<ReturnType<typeof getVideoVisitRecordingConsent>>,
  TError = HTTPValidationError,
>(
  params: GetVideoVisitRecordingConsentClinicVideoVisitConsentGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getVideoVisitRecordingConsent>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Video Visit Recording Consent
 */

export function useGetVideoVisitRecordingConsent<
  TData = Awaited<ReturnType<typeof getVideoVisitRecordingConsent>>,
  TError = HTTPValidationError,
>(
  params: GetVideoVisitRecordingConsentClinicVideoVisitConsentGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getVideoVisitRecordingConsent>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetVideoVisitRecordingConsentQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get Clinician Wait Time
 */
export const getClinicianWaitTime = (signal?: AbortSignal) => {
  return orvalClient<WaitTimeResponse>({
    url: `/clinic/wait-time`,
    method: "GET",
    signal,
  });
};

export const getGetClinicianWaitTimeQueryKey = () => {
  return [`/clinic/wait-time`] as const;
};

export const getGetClinicianWaitTimeQueryOptions = <
  TData = Awaited<ReturnType<typeof getClinicianWaitTime>>,
  TError = HTTPValidationError,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getClinicianWaitTime>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetClinicianWaitTimeQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getClinicianWaitTime>>
  > = ({ signal }) => getClinicianWaitTime(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getClinicianWaitTime>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetClinicianWaitTimeClinicWaitTimeGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getClinicianWaitTime>>
>;
export type GetClinicianWaitTimeClinicWaitTimeGetQueryError =
  HTTPValidationError;

export function useGetClinicianWaitTime<
  TData = Awaited<ReturnType<typeof getClinicianWaitTime>>,
  TError = HTTPValidationError,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClinicianWaitTime>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClinicianWaitTime>>,
          TError,
          Awaited<ReturnType<typeof getClinicianWaitTime>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetClinicianWaitTime<
  TData = Awaited<ReturnType<typeof getClinicianWaitTime>>,
  TError = HTTPValidationError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClinicianWaitTime>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClinicianWaitTime>>,
          TError,
          Awaited<ReturnType<typeof getClinicianWaitTime>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetClinicianWaitTime<
  TData = Awaited<ReturnType<typeof getClinicianWaitTime>>,
  TError = HTTPValidationError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClinicianWaitTime>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Clinician Wait Time
 */

export function useGetClinicianWaitTime<
  TData = Awaited<ReturnType<typeof getClinicianWaitTime>>,
  TError = HTTPValidationError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClinicianWaitTime>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetClinicianWaitTimeQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * History list of the user's conversation groups, newest first.
 *
 * A group describes itself: everything a row renders is stored on it, so this reads the
 * `created_at_index` GSI and never touches the conversation table. Groups that predate those
 * fields are filled in by the conversation group backfill, which runs before the flag opens
 * this list to anyone.
 *
 * Hidden groups are dropped after the page has been read, so a page can come back shorter than
 * `limit` while `has_more` is still true. That is fine for the list, which asks for the next
 * page once it reaches the end of what it rendered — but only as long as it rendered something,
 * which is why an empty page is topped up here rather than returned.
 * @summary Get Conversation Groups
 */
export const getConversationGroups = (
  params?: GetConversationGroupsConversationGroupsGetParams,
  signal?: AbortSignal,
) => {
  return orvalClient<ConversationGroupsResponse>({
    url: `/conversation-groups/`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetConversationGroupsInfiniteQueryKey = (
  params?: GetConversationGroupsConversationGroupsGetParams,
) => {
  return [
    "infinite",
    `/conversation-groups/`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetConversationGroupsQueryKey = (
  params?: GetConversationGroupsConversationGroupsGetParams,
) => {
  return [`/conversation-groups/`, ...(params ? [params] : [])] as const;
};

export const getGetConversationGroupsInfiniteQueryOptions = <
  TData = InfiniteData<
    Awaited<ReturnType<typeof getConversationGroups>>,
    GetConversationGroupsConversationGroupsGetParams["cursor"]
  >,
  TError = HTTPValidationError,
>(
  params?: GetConversationGroupsConversationGroupsGetParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getConversationGroups>>,
        TError,
        TData,
        QueryKey,
        GetConversationGroupsConversationGroupsGetParams["cursor"]
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetConversationGroupsInfiniteQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getConversationGroups>>,
    QueryKey,
    GetConversationGroupsConversationGroupsGetParams["cursor"]
  > = ({ signal, pageParam }) =>
    getConversationGroups(
      { ...params, cursor: pageParam ?? params?.["cursor"] },
      signal,
    );

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getConversationGroups>>,
    TError,
    TData,
    QueryKey,
    GetConversationGroupsConversationGroupsGetParams["cursor"]
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetConversationGroupsConversationGroupsGetInfiniteQueryResult =
  NonNullable<Awaited<ReturnType<typeof getConversationGroups>>>;
export type GetConversationGroupsConversationGroupsGetInfiniteQueryError =
  HTTPValidationError;

export function useGetConversationGroupsInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getConversationGroups>>,
    GetConversationGroupsConversationGroupsGetParams["cursor"]
  >,
  TError = HTTPValidationError,
>(
  params: undefined | GetConversationGroupsConversationGroupsGetParams,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getConversationGroups>>,
        TError,
        TData,
        QueryKey,
        GetConversationGroupsConversationGroupsGetParams["cursor"]
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConversationGroups>>,
          TError,
          Awaited<ReturnType<typeof getConversationGroups>>,
          QueryKey
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetConversationGroupsInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getConversationGroups>>,
    GetConversationGroupsConversationGroupsGetParams["cursor"]
  >,
  TError = HTTPValidationError,
>(
  params?: GetConversationGroupsConversationGroupsGetParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getConversationGroups>>,
        TError,
        TData,
        QueryKey,
        GetConversationGroupsConversationGroupsGetParams["cursor"]
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConversationGroups>>,
          TError,
          Awaited<ReturnType<typeof getConversationGroups>>,
          QueryKey
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetConversationGroupsInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getConversationGroups>>,
    GetConversationGroupsConversationGroupsGetParams["cursor"]
  >,
  TError = HTTPValidationError,
>(
  params?: GetConversationGroupsConversationGroupsGetParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getConversationGroups>>,
        TError,
        TData,
        QueryKey,
        GetConversationGroupsConversationGroupsGetParams["cursor"]
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Conversation Groups
 */

export function useGetConversationGroupsInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getConversationGroups>>,
    GetConversationGroupsConversationGroupsGetParams["cursor"]
  >,
  TError = HTTPValidationError,
>(
  params?: GetConversationGroupsConversationGroupsGetParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getConversationGroups>>,
        TError,
        TData,
        QueryKey,
        GetConversationGroupsConversationGroupsGetParams["cursor"]
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetConversationGroupsInfiniteQueryOptions(
    params,
    options,
  );

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetConversationGroupsQueryOptions = <
  TData = Awaited<ReturnType<typeof getConversationGroups>>,
  TError = HTTPValidationError,
>(
  params?: GetConversationGroupsConversationGroupsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getConversationGroups>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetConversationGroupsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getConversationGroups>>
  > = ({ signal }) => getConversationGroups(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getConversationGroups>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetConversationGroupsConversationGroupsGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getConversationGroups>>
>;
export type GetConversationGroupsConversationGroupsGetQueryError =
  HTTPValidationError;

export function useGetConversationGroups<
  TData = Awaited<ReturnType<typeof getConversationGroups>>,
  TError = HTTPValidationError,
>(
  params: undefined | GetConversationGroupsConversationGroupsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getConversationGroups>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConversationGroups>>,
          TError,
          Awaited<ReturnType<typeof getConversationGroups>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetConversationGroups<
  TData = Awaited<ReturnType<typeof getConversationGroups>>,
  TError = HTTPValidationError,
>(
  params?: GetConversationGroupsConversationGroupsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getConversationGroups>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConversationGroups>>,
          TError,
          Awaited<ReturnType<typeof getConversationGroups>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetConversationGroups<
  TData = Awaited<ReturnType<typeof getConversationGroups>>,
  TError = HTTPValidationError,
>(
  params?: GetConversationGroupsConversationGroupsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getConversationGroups>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Conversation Groups
 */

export function useGetConversationGroups<
  TData = Awaited<ReturnType<typeof getConversationGroups>>,
  TError = HTTPValidationError,
>(
  params?: GetConversationGroupsConversationGroupsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getConversationGroups>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetConversationGroupsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * A conversation group and a page of its NORI messages as one continuous stream.
 * @summary Get Conversation Group
 */
export const getConversationGroup = (
  conversationGroupId: string,
  params?: GetConversationGroupConversationGroupsConversationGroupIdGetParams,
  signal?: AbortSignal,
) => {
  return orvalClient<ConversationGroupResponse>({
    url: `/conversation-groups/${conversationGroupId}`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetConversationGroupQueryKey = (
  conversationGroupId: string,
  params?: GetConversationGroupConversationGroupsConversationGroupIdGetParams,
) => {
  return [
    `/conversation-groups/${conversationGroupId}`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetConversationGroupQueryOptions = <
  TData = Awaited<ReturnType<typeof getConversationGroup>>,
  TError = HTTPValidationError,
>(
  conversationGroupId: string,
  params?: GetConversationGroupConversationGroupsConversationGroupIdGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getConversationGroup>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetConversationGroupQueryKey(conversationGroupId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getConversationGroup>>
  > = ({ signal }) => getConversationGroup(conversationGroupId, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: conversationGroupId !== null && conversationGroupId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getConversationGroup>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetConversationGroupConversationGroupsConversationGroupIdGetQueryResult =
  NonNullable<Awaited<ReturnType<typeof getConversationGroup>>>;
export type GetConversationGroupConversationGroupsConversationGroupIdGetQueryError =
  HTTPValidationError;

export function useGetConversationGroup<
  TData = Awaited<ReturnType<typeof getConversationGroup>>,
  TError = HTTPValidationError,
>(
  conversationGroupId: string,
  params:
    | undefined
    | GetConversationGroupConversationGroupsConversationGroupIdGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getConversationGroup>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConversationGroup>>,
          TError,
          Awaited<ReturnType<typeof getConversationGroup>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetConversationGroup<
  TData = Awaited<ReturnType<typeof getConversationGroup>>,
  TError = HTTPValidationError,
>(
  conversationGroupId: string,
  params?: GetConversationGroupConversationGroupsConversationGroupIdGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getConversationGroup>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConversationGroup>>,
          TError,
          Awaited<ReturnType<typeof getConversationGroup>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetConversationGroup<
  TData = Awaited<ReturnType<typeof getConversationGroup>>,
  TError = HTTPValidationError,
>(
  conversationGroupId: string,
  params?: GetConversationGroupConversationGroupsConversationGroupIdGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getConversationGroup>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Conversation Group
 */

export function useGetConversationGroup<
  TData = Awaited<ReturnType<typeof getConversationGroup>>,
  TError = HTTPValidationError,
>(
  conversationGroupId: string,
  params?: GetConversationGroupConversationGroupsConversationGroupIdGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getConversationGroup>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetConversationGroupQueryOptions(
    conversationGroupId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Begin the ID verification process.
 *
 * Creates a verification transaction with the underlying provider and returns
 * a verification ID that the client can use to track progress / initiate the
 * verification UI flow.
 * @summary Start Id Verification
 */
export const startIdVerification = (signal?: AbortSignal) => {
  return orvalClient<StartVerificationResponse>({
    url: `/id-verification/start`,
    method: "POST",
    signal,
  });
};

export const getStartIdVerificationMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof startIdVerification>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof startIdVerification>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["startIdVerification"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof startIdVerification>>,
    void
  > = () => {
    return startIdVerification();
  };

  return { mutationFn, ...mutationOptions };
};

export type StartIdVerificationIdVerificationStartPostMutationResult =
  NonNullable<Awaited<ReturnType<typeof startIdVerification>>>;

export type StartIdVerificationIdVerificationStartPostMutationError =
  HTTPValidationError;

/**
 * @summary Start Id Verification
 */
export const useStartIdVerification = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof startIdVerification>>,
      TError,
      void,
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof startIdVerification>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getStartIdVerificationMutationOptions(options),
    queryClient,
  );
};

/**
 * Resume an existing Persona inquiry and get a session token.
 *
 * This endpoint looks up the user's ID verification profile, extracts the
 * fallback_inquiry_id, and calls Persona's /inquiries/{id}/resume API to get
 * a session token that can be used with the Persona Web SDK.
 * @summary Resume Id Verification
 */
export const resumeIdVerification = (signal?: AbortSignal) => {
  return orvalClient<ResumeInquiryResponse>({
    url: `/id-verification/resume`,
    method: "POST",
    signal,
  });
};

export const getResumeIdVerificationMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resumeIdVerification>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof resumeIdVerification>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["resumeIdVerification"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof resumeIdVerification>>,
    void
  > = () => {
    return resumeIdVerification();
  };

  return { mutationFn, ...mutationOptions };
};

export type ResumeIdVerificationIdVerificationResumePostMutationResult =
  NonNullable<Awaited<ReturnType<typeof resumeIdVerification>>>;

export type ResumeIdVerificationIdVerificationResumePostMutationError =
  HTTPValidationError;

/**
 * @summary Resume Id Verification
 */
export const useResumeIdVerification = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof resumeIdVerification>>,
      TError,
      void,
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof resumeIdVerification>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getResumeIdVerificationMutationOptions(options),
    queryClient,
  );
};

/**
 * Webhook endpoint for Persona transaction status updates.
 *
 * Transactions overview: https://docs.withpersona.com/transactions
 * @summary Persona Transaction Status Webhook
 */
export const personaTransactionStatusWebhook = (signal?: AbortSignal) => {
  return orvalClient<void>({
    url: `/id-verification/persona/transaction-status`,
    method: "POST",
    signal,
  });
};

export const getPersonaTransactionStatusWebhookMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof personaTransactionStatusWebhook>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof personaTransactionStatusWebhook>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["personaTransactionStatusWebhook"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof personaTransactionStatusWebhook>>,
    void
  > = () => {
    return personaTransactionStatusWebhook();
  };

  return { mutationFn, ...mutationOptions };
};

export type PersonaTransactionStatusWebhookIdVerificationPersonaTransactionStatusPostMutationResult =
  NonNullable<Awaited<ReturnType<typeof personaTransactionStatusWebhook>>>;

export type PersonaTransactionStatusWebhookIdVerificationPersonaTransactionStatusPostMutationError =
  HTTPValidationError;

/**
 * @summary Persona Transaction Status Webhook
 */
export const usePersonaTransactionStatusWebhook = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof personaTransactionStatusWebhook>>,
      TError,
      void,
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof personaTransactionStatusWebhook>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPersonaTransactionStatusWebhookMutationOptions(options),
    queryClient,
  );
};

/**
 * Webhook endpoint for Persona inquiry status updates.
 *
 * We only act on `inquiry.approved` events: when a fallback (Gov ID) inquiry is
 * approved, we propagate that approval up to its parent transaction via Persona's
 * "Update a transaction" API. That transaction update then triggers a
 * transaction.status-updated webhook, which drives the rest of the verification flow.
 *
 * Inquiries overview: https://docs.withpersona.com/inquiries
 * @summary Persona Inquiry Status Webhook
 */
export const personaInquiryStatusWebhook = (signal?: AbortSignal) => {
  return orvalClient<void>({
    url: `/id-verification/persona/inquiry-status`,
    method: "POST",
    signal,
  });
};

export const getPersonaInquiryStatusWebhookMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof personaInquiryStatusWebhook>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof personaInquiryStatusWebhook>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["personaInquiryStatusWebhook"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof personaInquiryStatusWebhook>>,
    void
  > = () => {
    return personaInquiryStatusWebhook();
  };

  return { mutationFn, ...mutationOptions };
};

export type PersonaInquiryStatusWebhookIdVerificationPersonaInquiryStatusPostMutationResult =
  NonNullable<Awaited<ReturnType<typeof personaInquiryStatusWebhook>>>;

export type PersonaInquiryStatusWebhookIdVerificationPersonaInquiryStatusPostMutationError =
  HTTPValidationError;

/**
 * @summary Persona Inquiry Status Webhook
 */
export const usePersonaInquiryStatusWebhook = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof personaInquiryStatusWebhook>>,
      TError,
      void,
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof personaInquiryStatusWebhook>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPersonaInquiryStatusWebhookMutationOptions(options),
    queryClient,
  );
};

/**
 * What the user's insurance would leave them owing: whether their policy is valid, which services
 * are covered, how much they would owe, and which providers they can see.
 *
 * Starts the check itself when one is needed, so a caller only has to read this endpoint:
 *
 * - A recent stored result for the user's current insurance details is returned right away as
 *   `{"status": "completed", "result": {...}}`.
 * - Otherwise a check is started (or an already-running one is joined) and this returns
 *   `{"status": "in_progress"}`.
 * - A check that already finished without a reusable result returns `{"status": "completed", ...}`
 *   or `{"status": "failed", "error": "..."}`. A failed check is retried automatically on a later
 *   request, but not immediately -- each check costs a payer lookup.
 * @summary Get Patient Responsibility Status
 */
export const getPatientResponsibilityStatus = (
  params?: GetPatientResponsibilityStatusInsurancePatientResponsibilityGetParams,
  signal?: AbortSignal,
) => {
  return orvalClient<CheckPatientResponsibilityWorkflowStatus>({
    url: `/insurance/patient-responsibility`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetPatientResponsibilityStatusQueryKey = (
  params?: GetPatientResponsibilityStatusInsurancePatientResponsibilityGetParams,
) => {
  return [
    `/insurance/patient-responsibility`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetPatientResponsibilityStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof getPatientResponsibilityStatus>>,
  TError = HTTPValidationError,
>(
  params?: GetPatientResponsibilityStatusInsurancePatientResponsibilityGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPatientResponsibilityStatus>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetPatientResponsibilityStatusQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPatientResponsibilityStatus>>
  > = ({ signal }) => getPatientResponsibilityStatus(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPatientResponsibilityStatus>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPatientResponsibilityStatusInsurancePatientResponsibilityGetQueryResult =
  NonNullable<Awaited<ReturnType<typeof getPatientResponsibilityStatus>>>;
export type GetPatientResponsibilityStatusInsurancePatientResponsibilityGetQueryError =
  HTTPValidationError;

export function useGetPatientResponsibilityStatus<
  TData = Awaited<ReturnType<typeof getPatientResponsibilityStatus>>,
  TError = HTTPValidationError,
>(
  params:
    | undefined
    | GetPatientResponsibilityStatusInsurancePatientResponsibilityGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPatientResponsibilityStatus>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientResponsibilityStatus>>,
          TError,
          Awaited<ReturnType<typeof getPatientResponsibilityStatus>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPatientResponsibilityStatus<
  TData = Awaited<ReturnType<typeof getPatientResponsibilityStatus>>,
  TError = HTTPValidationError,
>(
  params?: GetPatientResponsibilityStatusInsurancePatientResponsibilityGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPatientResponsibilityStatus>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientResponsibilityStatus>>,
          TError,
          Awaited<ReturnType<typeof getPatientResponsibilityStatus>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPatientResponsibilityStatus<
  TData = Awaited<ReturnType<typeof getPatientResponsibilityStatus>>,
  TError = HTTPValidationError,
>(
  params?: GetPatientResponsibilityStatusInsurancePatientResponsibilityGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPatientResponsibilityStatus>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Patient Responsibility Status
 */

export function useGetPatientResponsibilityStatus<
  TData = Awaited<ReturnType<typeof getPatientResponsibilityStatus>>,
  TError = HTTPValidationError,
>(
  params?: GetPatientResponsibilityStatusInsurancePatientResponsibilityGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPatientResponsibilityStatus>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetPatientResponsibilityStatusQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Extract insurance fields from an uploaded insurance card image so the user can review and
 * confirm them. Does not persist anything — the caller saves the confirmed values via the
 * profile upsert endpoint.
 * @summary Extract Insurance Card
 */
export const extractInsuranceCard = (
  insuranceCardExtractionRequest: InsuranceCardExtractionRequest,
  signal?: AbortSignal,
) => {
  return orvalClient<InsuranceCardReaderOutput>({
    url: `/insurance/extract-card`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: insuranceCardExtractionRequest,
    signal,
  });
};

export const getExtractInsuranceCardMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof extractInsuranceCard>>,
    TError,
    { data: InsuranceCardExtractionRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof extractInsuranceCard>>,
  TError,
  { data: InsuranceCardExtractionRequest },
  TContext
> => {
  const mutationKey = ["extractInsuranceCard"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof extractInsuranceCard>>,
    { data: InsuranceCardExtractionRequest }
  > = (props) => {
    const { data } = props ?? {};

    return extractInsuranceCard(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExtractInsuranceCardInsuranceExtractCardPostMutationResult =
  NonNullable<Awaited<ReturnType<typeof extractInsuranceCard>>>;
export type ExtractInsuranceCardInsuranceExtractCardPostMutationBody =
  InsuranceCardExtractionRequest;
export type ExtractInsuranceCardInsuranceExtractCardPostMutationError =
  HTTPValidationError;

/**
 * @summary Extract Insurance Card
 */
export const useExtractInsuranceCard = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof extractInsuranceCard>>,
      TError,
      { data: InsuranceCardExtractionRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof extractInsuranceCard>>,
  TError,
  { data: InsuranceCardExtractionRequest },
  TContext
> => {
  return useMutation(
    getExtractInsuranceCardMutationOptions(options),
    queryClient,
  );
};

/**
 * Extract the name and MBI from an uploaded Original Medicare card so the user can review and
 * confirm them. Does not persist anything; the caller saves the confirmed values via the profile
 * upsert endpoint.
 *
 * A card that is not an Original Medicare card is a 200 with ``is_medicare_card`` false, not an
 * error: around half of beneficiaries are on Medicare Advantage and carry a private plan card, so
 * the caller needs to tell them which card we need rather than that something went wrong.
 * @summary Extract Medicare Card
 */
export const extractMedicareCard = (
  insuranceCardExtractionRequest: InsuranceCardExtractionRequest,
  signal?: AbortSignal,
) => {
  return orvalClient<MedicareCardReaderOutput>({
    url: `/insurance/extract-medicare-card`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: insuranceCardExtractionRequest,
    signal,
  });
};

export const getExtractMedicareCardMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof extractMedicareCard>>,
    TError,
    { data: InsuranceCardExtractionRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof extractMedicareCard>>,
  TError,
  { data: InsuranceCardExtractionRequest },
  TContext
> => {
  const mutationKey = ["extractMedicareCard"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof extractMedicareCard>>,
    { data: InsuranceCardExtractionRequest }
  > = (props) => {
    const { data } = props ?? {};

    return extractMedicareCard(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExtractMedicareCardInsuranceExtractMedicareCardPostMutationResult =
  NonNullable<Awaited<ReturnType<typeof extractMedicareCard>>>;
export type ExtractMedicareCardInsuranceExtractMedicareCardPostMutationBody =
  InsuranceCardExtractionRequest;
export type ExtractMedicareCardInsuranceExtractMedicareCardPostMutationError =
  HTTPValidationError;

/**
 * @summary Extract Medicare Card
 */
export const useExtractMedicareCard = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof extractMedicareCard>>,
      TError,
      { data: InsuranceCardExtractionRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof extractMedicareCard>>,
  TError,
  { data: InsuranceCardExtractionRequest },
  TContext
> => {
  return useMutation(
    getExtractMedicareCardMutationOptions(options),
    queryClient,
  );
};

/**
 * Soft eligibility check: is the user's insurance (state + payer) supported by Bridge with
 * credentialed providers available?
 *
 * A cheap, non-paid check (resolves immediately) meant to gate the insurance-pay path before the
 * hard patient-responsibility check.
 * @summary Check Insurance Eligibility
 */
export const checkInsuranceEligibility = (signal?: AbortSignal) => {
  return orvalClient<ProviderEligibilityResponse>({
    url: `/insurance/eligibility`,
    method: "GET",
    signal,
  });
};

export const getCheckInsuranceEligibilityQueryKey = () => {
  return [`/insurance/eligibility`] as const;
};

export const getCheckInsuranceEligibilityQueryOptions = <
  TData = Awaited<ReturnType<typeof checkInsuranceEligibility>>,
  TError = HTTPValidationError,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof checkInsuranceEligibility>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getCheckInsuranceEligibilityQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof checkInsuranceEligibility>>
  > = ({ signal }) => checkInsuranceEligibility(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof checkInsuranceEligibility>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type CheckInsuranceEligibilityInsuranceEligibilityGetQueryResult =
  NonNullable<Awaited<ReturnType<typeof checkInsuranceEligibility>>>;
export type CheckInsuranceEligibilityInsuranceEligibilityGetQueryError =
  HTTPValidationError;

export function useCheckInsuranceEligibility<
  TData = Awaited<ReturnType<typeof checkInsuranceEligibility>>,
  TError = HTTPValidationError,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof checkInsuranceEligibility>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof checkInsuranceEligibility>>,
          TError,
          Awaited<ReturnType<typeof checkInsuranceEligibility>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useCheckInsuranceEligibility<
  TData = Awaited<ReturnType<typeof checkInsuranceEligibility>>,
  TError = HTTPValidationError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof checkInsuranceEligibility>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof checkInsuranceEligibility>>,
          TError,
          Awaited<ReturnType<typeof checkInsuranceEligibility>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useCheckInsuranceEligibility<
  TData = Awaited<ReturnType<typeof checkInsuranceEligibility>>,
  TError = HTTPValidationError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof checkInsuranceEligibility>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Check Insurance Eligibility
 */

export function useCheckInsuranceEligibility<
  TData = Awaited<ReturnType<typeof checkInsuranceEligibility>>,
  TError = HTTPValidationError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof checkInsuranceEligibility>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getCheckInsuranceEligibilityQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Search Bridge payers by name so a user's insurance carrier can be matched to a Bridge payer id.
 *
 * Backs the carrier autocomplete in profile settings and the pre-clinic manual insurance step.
 * @summary Search Bridge Payers
 */
export const searchBridgePayers = (
  params: SearchBridgePayersInsuranceBridgePayersGetParams,
  signal?: AbortSignal,
) => {
  return orvalClient<BridgePayerSearchResult[]>({
    url: `/insurance/bridge-payers`,
    method: "GET",
    params,
    signal,
  });
};

export const getSearchBridgePayersQueryKey = (
  params?: SearchBridgePayersInsuranceBridgePayersGetParams,
) => {
  return [`/insurance/bridge-payers`, ...(params ? [params] : [])] as const;
};

export const getSearchBridgePayersQueryOptions = <
  TData = Awaited<ReturnType<typeof searchBridgePayers>>,
  TError = HTTPValidationError,
>(
  params: SearchBridgePayersInsuranceBridgePayersGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof searchBridgePayers>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getSearchBridgePayersQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof searchBridgePayers>>
  > = ({ signal }) => searchBridgePayers(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof searchBridgePayers>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type SearchBridgePayersInsuranceBridgePayersGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof searchBridgePayers>>
>;
export type SearchBridgePayersInsuranceBridgePayersGetQueryError =
  HTTPValidationError;

export function useSearchBridgePayers<
  TData = Awaited<ReturnType<typeof searchBridgePayers>>,
  TError = HTTPValidationError,
>(
  params: SearchBridgePayersInsuranceBridgePayersGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof searchBridgePayers>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchBridgePayers>>,
          TError,
          Awaited<ReturnType<typeof searchBridgePayers>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useSearchBridgePayers<
  TData = Awaited<ReturnType<typeof searchBridgePayers>>,
  TError = HTTPValidationError,
>(
  params: SearchBridgePayersInsuranceBridgePayersGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof searchBridgePayers>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchBridgePayers>>,
          TError,
          Awaited<ReturnType<typeof searchBridgePayers>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useSearchBridgePayers<
  TData = Awaited<ReturnType<typeof searchBridgePayers>>,
  TError = HTTPValidationError,
>(
  params: SearchBridgePayersInsuranceBridgePayersGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof searchBridgePayers>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Search Bridge Payers
 */

export function useSearchBridgePayers<
  TData = Awaited<ReturnType<typeof searchBridgePayers>>,
  TError = HTTPValidationError,
>(
  params: SearchBridgePayersInsuranceBridgePayersGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof searchBridgePayers>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getSearchBridgePayersQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get Affiliation Status
 */
export const getAffiliationStatus = (signal?: AbortSignal) => {
  return orvalClient<AffiliationStatusResponse>({
    url: `/affiliation/status`,
    method: "GET",
    signal,
  });
};

export const getGetAffiliationStatusQueryKey = () => {
  return [`/affiliation/status`] as const;
};

export const getGetAffiliationStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof getAffiliationStatus>>,
  TError = HTTPValidationError,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getAffiliationStatus>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAffiliationStatusQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAffiliationStatus>>
  > = ({ signal }) => getAffiliationStatus(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAffiliationStatus>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAffiliationStatusAffiliationStatusGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAffiliationStatus>>
>;
export type GetAffiliationStatusAffiliationStatusGetQueryError =
  HTTPValidationError;

export function useGetAffiliationStatus<
  TData = Awaited<ReturnType<typeof getAffiliationStatus>>,
  TError = HTTPValidationError,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAffiliationStatus>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAffiliationStatus>>,
          TError,
          Awaited<ReturnType<typeof getAffiliationStatus>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAffiliationStatus<
  TData = Awaited<ReturnType<typeof getAffiliationStatus>>,
  TError = HTTPValidationError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAffiliationStatus>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAffiliationStatus>>,
          TError,
          Awaited<ReturnType<typeof getAffiliationStatus>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAffiliationStatus<
  TData = Awaited<ReturnType<typeof getAffiliationStatus>>,
  TError = HTTPValidationError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAffiliationStatus>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Affiliation Status
 */

export function useGetAffiliationStatus<
  TData = Awaited<ReturnType<typeof getAffiliationStatus>>,
  TError = HTTPValidationError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAffiliationStatus>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetAffiliationStatusQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Get the subjective shareback memory for a specific conversation.
 * Returns the patient-edited version if it exists, otherwise returns the original.
 *
 * Sets ``refreshing`` when the stored summary is stale vs the patient's profile and a
 * regeneration is expected to replace it, so the client can keep waiting. See AI-1917.
 * @summary Get Subjective Shareback For Conversation
 */
export const getSubjectiveSharebackForConversation = (
  conversationId: string,
  signal?: AbortSignal,
) => {
  return orvalClient<SubjectiveSharebackResponse>({
    url: `/memory/subjective-shareback/${conversationId}`,
    method: "GET",
    signal,
  });
};

export const getGetSubjectiveSharebackForConversationQueryKey = (
  conversationId: string,
) => {
  return [`/memory/subjective-shareback/${conversationId}`] as const;
};

export const getGetSubjectiveSharebackForConversationQueryOptions = <
  TData = Awaited<ReturnType<typeof getSubjectiveSharebackForConversation>>,
  TError = HTTPValidationError,
>(
  conversationId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSubjectiveSharebackForConversation>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetSubjectiveSharebackForConversationQueryKey(conversationId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSubjectiveSharebackForConversation>>
  > = ({ signal }) =>
    getSubjectiveSharebackForConversation(conversationId, signal);

  return {
    queryKey,
    queryFn,
    enabled: conversationId !== null && conversationId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getSubjectiveSharebackForConversation>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetSubjectiveSharebackForConversationMemorySubjectiveSharebackConversationIdGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getSubjectiveSharebackForConversation>>
  >;
export type GetSubjectiveSharebackForConversationMemorySubjectiveSharebackConversationIdGetQueryError =
  HTTPValidationError;

export function useGetSubjectiveSharebackForConversation<
  TData = Awaited<ReturnType<typeof getSubjectiveSharebackForConversation>>,
  TError = HTTPValidationError,
>(
  conversationId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSubjectiveSharebackForConversation>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSubjectiveSharebackForConversation>>,
          TError,
          Awaited<ReturnType<typeof getSubjectiveSharebackForConversation>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSubjectiveSharebackForConversation<
  TData = Awaited<ReturnType<typeof getSubjectiveSharebackForConversation>>,
  TError = HTTPValidationError,
>(
  conversationId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSubjectiveSharebackForConversation>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSubjectiveSharebackForConversation>>,
          TError,
          Awaited<ReturnType<typeof getSubjectiveSharebackForConversation>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSubjectiveSharebackForConversation<
  TData = Awaited<ReturnType<typeof getSubjectiveSharebackForConversation>>,
  TError = HTTPValidationError,
>(
  conversationId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSubjectiveSharebackForConversation>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Subjective Shareback For Conversation
 */

export function useGetSubjectiveSharebackForConversation<
  TData = Awaited<ReturnType<typeof getSubjectiveSharebackForConversation>>,
  TError = HTTPValidationError,
>(
  conversationId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSubjectiveSharebackForConversation>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetSubjectiveSharebackForConversationQueryOptions(
    conversationId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Save a patient-edited version of the subjective shareback for a specific conversation.
 * This creates a new record with patient_edited=True, preserving the original.
 * @summary Update Subjective Shareback For Conversation
 */
export const updateSubjectiveSharebackForConversation = (
  conversationId: string,
  subjectiveSharebackUpdateRequest: SubjectiveSharebackUpdateRequest,
  signal?: AbortSignal,
) => {
  return orvalClient<MemoryResponse>({
    url: `/memory/subjective-shareback/${conversationId}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: subjectiveSharebackUpdateRequest,
    signal,
  });
};

export const getUpdateSubjectiveSharebackForConversationMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSubjectiveSharebackForConversation>>,
    TError,
    { conversationId: string; data: SubjectiveSharebackUpdateRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateSubjectiveSharebackForConversation>>,
  TError,
  { conversationId: string; data: SubjectiveSharebackUpdateRequest },
  TContext
> => {
  const mutationKey = ["updateSubjectiveSharebackForConversation"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateSubjectiveSharebackForConversation>>,
    { conversationId: string; data: SubjectiveSharebackUpdateRequest }
  > = (props) => {
    const { conversationId, data } = props ?? {};

    return updateSubjectiveSharebackForConversation(conversationId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateSubjectiveSharebackForConversationMemorySubjectiveSharebackConversationIdPutMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof updateSubjectiveSharebackForConversation>>
  >;
export type UpdateSubjectiveSharebackForConversationMemorySubjectiveSharebackConversationIdPutMutationBody =
  SubjectiveSharebackUpdateRequest;
export type UpdateSubjectiveSharebackForConversationMemorySubjectiveSharebackConversationIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Subjective Shareback For Conversation
 */
export const useUpdateSubjectiveSharebackForConversation = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateSubjectiveSharebackForConversation>>,
      TError,
      { conversationId: string; data: SubjectiveSharebackUpdateRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateSubjectiveSharebackForConversation>>,
  TError,
  { conversationId: string; data: SubjectiveSharebackUpdateRequest },
  TContext
> => {
  return useMutation(
    getUpdateSubjectiveSharebackForConversationMutationOptions(options),
    queryClient,
  );
};

/**
 * @summary Customer Io Webhook
 */
export const customerIoWebhook = (signal?: AbortSignal) => {
  return orvalClient<void>({
    url: `/notifications/customer-io-webhook`,
    method: "POST",
    signal,
  });
};

export const getCustomerIoWebhookMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof customerIoWebhook>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof customerIoWebhook>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["customerIoWebhook"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof customerIoWebhook>>,
    void
  > = () => {
    return customerIoWebhook();
  };

  return { mutationFn, ...mutationOptions };
};

export type CustomerIoWebhookNotificationsCustomerIoWebhookPostMutationResult =
  NonNullable<Awaited<ReturnType<typeof customerIoWebhook>>>;

export type CustomerIoWebhookNotificationsCustomerIoWebhookPostMutationError =
  HTTPValidationError;

/**
 * @summary Customer Io Webhook
 */
export const useCustomerIoWebhook = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof customerIoWebhook>>,
      TError,
      void,
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof customerIoWebhook>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getCustomerIoWebhookMutationOptions(options), queryClient);
};

/**
 * @summary Customer Io Incoming Sms
 */
export const customerIoIncomingSms = (signal?: AbortSignal) => {
  return orvalClient<void>({
    url: `/notifications/customer-io-incoming-sms`,
    method: "POST",
    signal,
  });
};

export const getCustomerIoIncomingSmsMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof customerIoIncomingSms>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof customerIoIncomingSms>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["customerIoIncomingSms"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof customerIoIncomingSms>>,
    void
  > = () => {
    return customerIoIncomingSms();
  };

  return { mutationFn, ...mutationOptions };
};

export type CustomerIoIncomingSmsNotificationsCustomerIoIncomingSmsPostMutationResult =
  NonNullable<Awaited<ReturnType<typeof customerIoIncomingSms>>>;

export type CustomerIoIncomingSmsNotificationsCustomerIoIncomingSmsPostMutationError =
  HTTPValidationError;

/**
 * @summary Customer Io Incoming Sms
 */
export const useCustomerIoIncomingSms = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof customerIoIncomingSms>>,
      TError,
      void,
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof customerIoIncomingSms>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getCustomerIoIncomingSmsMutationOptions(options),
    queryClient,
  );
};

/**
 * @summary Get Scheduled Notifications
 */
export const getScheduledNotifications = (signal?: AbortSignal) => {
  return orvalClient<ScheduledNotificationsResponse>({
    url: `/notifications/scheduled`,
    method: "GET",
    signal,
  });
};

export const getGetScheduledNotificationsQueryKey = () => {
  return [`/notifications/scheduled`] as const;
};

export const getGetScheduledNotificationsQueryOptions = <
  TData = Awaited<ReturnType<typeof getScheduledNotifications>>,
  TError = HTTPValidationError,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getScheduledNotifications>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetScheduledNotificationsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getScheduledNotifications>>
  > = ({ signal }) => getScheduledNotifications(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getScheduledNotifications>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetScheduledNotificationsNotificationsScheduledGetQueryResult =
  NonNullable<Awaited<ReturnType<typeof getScheduledNotifications>>>;
export type GetScheduledNotificationsNotificationsScheduledGetQueryError =
  HTTPValidationError;

export function useGetScheduledNotifications<
  TData = Awaited<ReturnType<typeof getScheduledNotifications>>,
  TError = HTTPValidationError,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getScheduledNotifications>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getScheduledNotifications>>,
          TError,
          Awaited<ReturnType<typeof getScheduledNotifications>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetScheduledNotifications<
  TData = Awaited<ReturnType<typeof getScheduledNotifications>>,
  TError = HTTPValidationError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getScheduledNotifications>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getScheduledNotifications>>,
          TError,
          Awaited<ReturnType<typeof getScheduledNotifications>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetScheduledNotifications<
  TData = Awaited<ReturnType<typeof getScheduledNotifications>>,
  TError = HTTPValidationError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getScheduledNotifications>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Scheduled Notifications
 */

export function useGetScheduledNotifications<
  TData = Awaited<ReturnType<typeof getScheduledNotifications>>,
  TError = HTTPValidationError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getScheduledNotifications>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetScheduledNotificationsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Cancel Scheduled Notification
 */
export const cancelScheduledNotification = (
  notificationId: string,
  signal?: AbortSignal,
) => {
  return orvalClient<void>({
    url: `/notifications/scheduled/${notificationId}`,
    method: "DELETE",
    signal,
  });
};

export const getCancelScheduledNotificationMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cancelScheduledNotification>>,
    TError,
    { notificationId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof cancelScheduledNotification>>,
  TError,
  { notificationId: string },
  TContext
> => {
  const mutationKey = ["cancelScheduledNotification"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof cancelScheduledNotification>>,
    { notificationId: string }
  > = (props) => {
    const { notificationId } = props ?? {};

    return cancelScheduledNotification(notificationId);
  };

  return { mutationFn, ...mutationOptions };
};

export type CancelScheduledNotificationNotificationsScheduledNotificationIdDeleteMutationResult =
  NonNullable<Awaited<ReturnType<typeof cancelScheduledNotification>>>;

export type CancelScheduledNotificationNotificationsScheduledNotificationIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Cancel Scheduled Notification
 */
export const useCancelScheduledNotification = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof cancelScheduledNotification>>,
      TError,
      { notificationId: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof cancelScheduledNotification>>,
  TError,
  { notificationId: string },
  TContext
> => {
  return useMutation(
    getCancelScheduledNotificationMutationOptions(options),
    queryClient,
  );
};

/**
 * @summary Expire Pending Notification
 */
export const expirePendingNotification = (
  pendingNotificationId: string,
  signal?: AbortSignal,
) => {
  return orvalClient<void>({
    url: `/notifications/pending/${pendingNotificationId}/expire`,
    method: "POST",
    signal,
  });
};

export const getExpirePendingNotificationMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof expirePendingNotification>>,
    TError,
    { pendingNotificationId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof expirePendingNotification>>,
  TError,
  { pendingNotificationId: string },
  TContext
> => {
  const mutationKey = ["expirePendingNotification"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof expirePendingNotification>>,
    { pendingNotificationId: string }
  > = (props) => {
    const { pendingNotificationId } = props ?? {};

    return expirePendingNotification(pendingNotificationId);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExpirePendingNotificationNotificationsPendingPendingNotificationIdExpirePostMutationResult =
  NonNullable<Awaited<ReturnType<typeof expirePendingNotification>>>;

export type ExpirePendingNotificationNotificationsPendingPendingNotificationIdExpirePostMutationError =
  HTTPValidationError;

/**
 * @summary Expire Pending Notification
 */
export const useExpirePendingNotification = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof expirePendingNotification>>,
      TError,
      { pendingNotificationId: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof expirePendingNotification>>,
  TError,
  { pendingNotificationId: string },
  TContext
> => {
  return useMutation(
    getExpirePendingNotificationMutationOptions(options),
    queryClient,
  );
};

/**
 * @summary Get Outbound Documents
 */
export const getOutboundDocuments = (signal?: AbortSignal) => {
  return orvalClient<OutboundDocumentResponse[]>({
    url: `/outbound-documents`,
    method: "GET",
    signal,
  });
};

export const getGetOutboundDocumentsQueryKey = () => {
  return [`/outbound-documents`] as const;
};

export const getGetOutboundDocumentsQueryOptions = <
  TData = Awaited<ReturnType<typeof getOutboundDocuments>>,
  TError = HTTPValidationError,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getOutboundDocuments>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOutboundDocumentsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getOutboundDocuments>>
  > = ({ signal }) => getOutboundDocuments(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getOutboundDocuments>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetOutboundDocumentsOutboundDocumentsGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOutboundDocuments>>
>;
export type GetOutboundDocumentsOutboundDocumentsGetQueryError =
  HTTPValidationError;

export function useGetOutboundDocuments<
  TData = Awaited<ReturnType<typeof getOutboundDocuments>>,
  TError = HTTPValidationError,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOutboundDocuments>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOutboundDocuments>>,
          TError,
          Awaited<ReturnType<typeof getOutboundDocuments>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetOutboundDocuments<
  TData = Awaited<ReturnType<typeof getOutboundDocuments>>,
  TError = HTTPValidationError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOutboundDocuments>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOutboundDocuments>>,
          TError,
          Awaited<ReturnType<typeof getOutboundDocuments>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetOutboundDocuments<
  TData = Awaited<ReturnType<typeof getOutboundDocuments>>,
  TError = HTTPValidationError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOutboundDocuments>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Outbound Documents
 */

export function useGetOutboundDocuments<
  TData = Awaited<ReturnType<typeof getOutboundDocuments>>,
  TError = HTTPValidationError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOutboundDocuments>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetOutboundDocumentsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Sinch Fax Completed Webhook
 */
export const sinchFaxCompletedWebhook = (
  sinchFaxCompletedWebhook: SinchFaxCompletedWebhook,
  signal?: AbortSignal,
) => {
  return orvalClient<void>({
    url: `/outbound-documents/sinch/fax-completed`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: sinchFaxCompletedWebhook,
    signal,
  });
};

export const getSinchFaxCompletedWebhookMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sinchFaxCompletedWebhook>>,
    TError,
    { data: SinchFaxCompletedWebhook },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sinchFaxCompletedWebhook>>,
  TError,
  { data: SinchFaxCompletedWebhook },
  TContext
> => {
  const mutationKey = ["sinchFaxCompletedWebhook"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sinchFaxCompletedWebhook>>,
    { data: SinchFaxCompletedWebhook }
  > = (props) => {
    const { data } = props ?? {};

    return sinchFaxCompletedWebhook(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type SinchFaxCompletedWebhookOutboundDocumentsSinchFaxCompletedPostMutationResult =
  NonNullable<Awaited<ReturnType<typeof sinchFaxCompletedWebhook>>>;
export type SinchFaxCompletedWebhookOutboundDocumentsSinchFaxCompletedPostMutationBody =
  SinchFaxCompletedWebhook;
export type SinchFaxCompletedWebhookOutboundDocumentsSinchFaxCompletedPostMutationError =
  HTTPValidationError;

/**
 * @summary Sinch Fax Completed Webhook
 */
export const useSinchFaxCompletedWebhook = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof sinchFaxCompletedWebhook>>,
      TError,
      { data: SinchFaxCompletedWebhook },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof sinchFaxCompletedWebhook>>,
  TError,
  { data: SinchFaxCompletedWebhook },
  TContext
> => {
  return useMutation(
    getSinchFaxCompletedWebhookMutationOptions(options),
    queryClient,
  );
};

/**
 * @summary Lob Letter Status Webhook
 */
export const lobLetterStatusWebhook = (signal?: AbortSignal) => {
  return orvalClient<void>({
    url: `/outbound-documents/lob/letter-status`,
    method: "POST",
    signal,
  });
};

export const getLobLetterStatusWebhookMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof lobLetterStatusWebhook>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof lobLetterStatusWebhook>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["lobLetterStatusWebhook"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof lobLetterStatusWebhook>>,
    void
  > = () => {
    return lobLetterStatusWebhook();
  };

  return { mutationFn, ...mutationOptions };
};

export type LobLetterStatusWebhookOutboundDocumentsLobLetterStatusPostMutationResult =
  NonNullable<Awaited<ReturnType<typeof lobLetterStatusWebhook>>>;

export type LobLetterStatusWebhookOutboundDocumentsLobLetterStatusPostMutationError =
  HTTPValidationError;

/**
 * @summary Lob Letter Status Webhook
 */
export const useLobLetterStatusWebhook = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof lobLetterStatusWebhook>>,
      TError,
      void,
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof lobLetterStatusWebhook>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getLobLetterStatusWebhookMutationOptions(options),
    queryClient,
  );
};

/**
 * @summary List User Programs
 */
export const listUserPrograms = (signal?: AbortSignal) => {
  return orvalClient<UserProgramResponse[]>({
    url: `/programs`,
    method: "GET",
    signal,
  });
};

export const getListUserProgramsQueryKey = () => {
  return [`/programs`] as const;
};

export const getListUserProgramsQueryOptions = <
  TData = Awaited<ReturnType<typeof listUserPrograms>>,
  TError = HTTPValidationError,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof listUserPrograms>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListUserProgramsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listUserPrograms>>
  > = ({ signal }) => listUserPrograms(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listUserPrograms>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListUserProgramsProgramsGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof listUserPrograms>>
>;
export type ListUserProgramsProgramsGetQueryError = HTTPValidationError;

export function useListUserPrograms<
  TData = Awaited<ReturnType<typeof listUserPrograms>>,
  TError = HTTPValidationError,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listUserPrograms>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listUserPrograms>>,
          TError,
          Awaited<ReturnType<typeof listUserPrograms>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListUserPrograms<
  TData = Awaited<ReturnType<typeof listUserPrograms>>,
  TError = HTTPValidationError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listUserPrograms>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listUserPrograms>>,
          TError,
          Awaited<ReturnType<typeof listUserPrograms>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListUserPrograms<
  TData = Awaited<ReturnType<typeof listUserPrograms>>,
  TError = HTTPValidationError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listUserPrograms>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List User Programs
 */

export function useListUserPrograms<
  TData = Awaited<ReturnType<typeof listUserPrograms>>,
  TError = HTTPValidationError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listUserPrograms>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListUserProgramsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get User Program
 */
export const getUserProgram = (program: ProgramID, signal?: AbortSignal) => {
  return orvalClient<UserProgramResponse>({
    url: `/programs/${program}`,
    method: "GET",
    signal,
  });
};

export const getGetUserProgramQueryKey = (program: ProgramID) => {
  return [`/programs/${program}`] as const;
};

export const getGetUserProgramQueryOptions = <
  TData = Awaited<ReturnType<typeof getUserProgram>>,
  TError = HTTPValidationError,
>(
  program: ProgramID,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUserProgram>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetUserProgramQueryKey(program);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserProgram>>> = ({
    signal,
  }) => getUserProgram(program, signal);

  return {
    queryKey,
    queryFn,
    enabled: program !== null && program !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getUserProgram>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetUserProgramProgramsProgramGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUserProgram>>
>;
export type GetUserProgramProgramsProgramGetQueryError = HTTPValidationError;

export function useGetUserProgram<
  TData = Awaited<ReturnType<typeof getUserProgram>>,
  TError = HTTPValidationError,
>(
  program: ProgramID,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUserProgram>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserProgram>>,
          TError,
          Awaited<ReturnType<typeof getUserProgram>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUserProgram<
  TData = Awaited<ReturnType<typeof getUserProgram>>,
  TError = HTTPValidationError,
>(
  program: ProgramID,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUserProgram>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserProgram>>,
          TError,
          Awaited<ReturnType<typeof getUserProgram>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUserProgram<
  TData = Awaited<ReturnType<typeof getUserProgram>>,
  TError = HTTPValidationError,
>(
  program: ProgramID,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUserProgram>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get User Program
 */

export function useGetUserProgram<
  TData = Awaited<ReturnType<typeof getUserProgram>>,
  TError = HTTPValidationError,
>(
  program: ProgramID,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUserProgram>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetUserProgramQueryOptions(program, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Update User Program Care Team
 */
export const updateUserProgramCareTeam = (
  program: ProgramID,
  careTeamResponse: CareTeamResponse,
  signal?: AbortSignal,
) => {
  return orvalClient<CareTeamResponse>({
    url: `/programs/${program}/care-team`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: careTeamResponse,
    signal,
  });
};

export const getUpdateUserProgramCareTeamMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateUserProgramCareTeam>>,
    TError,
    { program: ProgramID; data: CareTeamResponse },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateUserProgramCareTeam>>,
  TError,
  { program: ProgramID; data: CareTeamResponse },
  TContext
> => {
  const mutationKey = ["updateUserProgramCareTeam"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateUserProgramCareTeam>>,
    { program: ProgramID; data: CareTeamResponse }
  > = (props) => {
    const { program, data } = props ?? {};

    return updateUserProgramCareTeam(program, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateUserProgramCareTeamProgramsProgramCareTeamPutMutationResult =
  NonNullable<Awaited<ReturnType<typeof updateUserProgramCareTeam>>>;
export type UpdateUserProgramCareTeamProgramsProgramCareTeamPutMutationBody =
  CareTeamResponse;
export type UpdateUserProgramCareTeamProgramsProgramCareTeamPutMutationError =
  HTTPValidationError;

/**
 * @summary Update User Program Care Team
 */
export const useUpdateUserProgramCareTeam = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateUserProgramCareTeam>>,
      TError,
      { program: ProgramID; data: CareTeamResponse },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateUserProgramCareTeam>>,
  TError,
  { program: ProgramID; data: CareTeamResponse },
  TContext
> => {
  return useMutation(
    getUpdateUserProgramCareTeamMutationOptions(options),
    queryClient,
  );
};

/**
 * @summary Update User Program Status
 */
export const updateUserProgramStatus = (
  userId: string,
  updateUserProgramStatusRequest: UpdateUserProgramStatusRequest,
  signal?: AbortSignal,
) => {
  return orvalClient<void>({
    url: `/programs/user/${userId}/status`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: updateUserProgramStatusRequest,
    signal,
  });
};

export const getUpdateUserProgramStatusMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateUserProgramStatus>>,
    TError,
    { userId: string; data: UpdateUserProgramStatusRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateUserProgramStatus>>,
  TError,
  { userId: string; data: UpdateUserProgramStatusRequest },
  TContext
> => {
  const mutationKey = ["updateUserProgramStatus"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateUserProgramStatus>>,
    { userId: string; data: UpdateUserProgramStatusRequest }
  > = (props) => {
    const { userId, data } = props ?? {};

    return updateUserProgramStatus(userId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateUserProgramStatusProgramsUserUserIdStatusPostMutationResult =
  NonNullable<Awaited<ReturnType<typeof updateUserProgramStatus>>>;
export type UpdateUserProgramStatusProgramsUserUserIdStatusPostMutationBody =
  UpdateUserProgramStatusRequest;
export type UpdateUserProgramStatusProgramsUserUserIdStatusPostMutationError =
  HTTPValidationError;

/**
 * @summary Update User Program Status
 */
export const useUpdateUserProgramStatus = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateUserProgramStatus>>,
      TError,
      { userId: string; data: UpdateUserProgramStatusRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateUserProgramStatus>>,
  TError,
  { userId: string; data: UpdateUserProgramStatusRequest },
  TContext
> => {
  return useMutation(
    getUpdateUserProgramStatusMutationOptions(options),
    queryClient,
  );
};

/**
 * @summary Get Landing Suggestions
 */
export const getLandingSuggestions = (
  params?: GetLandingSuggestionsSuggestionsLandingGetParams,
  signal?: AbortSignal,
) => {
  return orvalClient<LandingSuggestionResponse>({
    url: `/suggestions/landing`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetLandingSuggestionsQueryKey = (
  params?: GetLandingSuggestionsSuggestionsLandingGetParams,
) => {
  return [`/suggestions/landing`, ...(params ? [params] : [])] as const;
};

export const getGetLandingSuggestionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getLandingSuggestions>>,
  TError = HTTPValidationError,
>(
  params?: GetLandingSuggestionsSuggestionsLandingGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getLandingSuggestions>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetLandingSuggestionsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getLandingSuggestions>>
  > = ({ signal }) => getLandingSuggestions(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getLandingSuggestions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetLandingSuggestionsSuggestionsLandingGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getLandingSuggestions>>
>;
export type GetLandingSuggestionsSuggestionsLandingGetQueryError =
  HTTPValidationError;

export function useGetLandingSuggestions<
  TData = Awaited<ReturnType<typeof getLandingSuggestions>>,
  TError = HTTPValidationError,
>(
  params: undefined | GetLandingSuggestionsSuggestionsLandingGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getLandingSuggestions>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLandingSuggestions>>,
          TError,
          Awaited<ReturnType<typeof getLandingSuggestions>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetLandingSuggestions<
  TData = Awaited<ReturnType<typeof getLandingSuggestions>>,
  TError = HTTPValidationError,
>(
  params?: GetLandingSuggestionsSuggestionsLandingGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getLandingSuggestions>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLandingSuggestions>>,
          TError,
          Awaited<ReturnType<typeof getLandingSuggestions>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetLandingSuggestions<
  TData = Awaited<ReturnType<typeof getLandingSuggestions>>,
  TError = HTTPValidationError,
>(
  params?: GetLandingSuggestionsSuggestionsLandingGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getLandingSuggestions>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Landing Suggestions
 */

export function useGetLandingSuggestions<
  TData = Awaited<ReturnType<typeof getLandingSuggestions>>,
  TError = HTTPValidationError,
>(
  params?: GetLandingSuggestionsSuggestionsLandingGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getLandingSuggestions>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetLandingSuggestionsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Create an anonymous user session.
 *
 * NOTE: This endpoint is unauthenticated, but we check for a valid anonymous auth token from
 *     a previous session to avoid creating a new one unnecessarily.
 * @summary Create Anonymous User
 */
export const createAnonymousUser = (signal?: AbortSignal) => {
  return orvalClient<AnonymousUserResponse>({
    url: `/user/anonymous`,
    method: "POST",
    signal,
  });
};

export const getCreateAnonymousUserMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAnonymousUser>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createAnonymousUser>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["createAnonymousUser"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createAnonymousUser>>,
    void
  > = () => {
    return createAnonymousUser();
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateAnonymousUserUserAnonymousPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof createAnonymousUser>>
>;

export type CreateAnonymousUserUserAnonymousPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Anonymous User
 */
export const useCreateAnonymousUser = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createAnonymousUser>>,
      TError,
      void,
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createAnonymousUser>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getCreateAnonymousUserMutationOptions(options),
    queryClient,
  );
};

/**
 * Refreshes an anonymous user's tokens
 * @summary Refresh An Auth Token
 */
export const refreshAnAuthToken = (signal?: AbortSignal) => {
  return orvalClient<void>({
    url: `/user/anonymous/refresh`,
    method: "POST",
    signal,
  });
};

export const getRefreshAnAuthTokenMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof refreshAnAuthToken>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof refreshAnAuthToken>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["refreshAnAuthToken"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof refreshAnAuthToken>>,
    void
  > = () => {
    return refreshAnAuthToken();
  };

  return { mutationFn, ...mutationOptions };
};

export type RefreshAnAuthTokenUserAnonymousRefreshPostMutationResult =
  NonNullable<Awaited<ReturnType<typeof refreshAnAuthToken>>>;

export type RefreshAnAuthTokenUserAnonymousRefreshPostMutationError =
  HTTPValidationError;

/**
 * @summary Refresh An Auth Token
 */
export const useRefreshAnAuthToken = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof refreshAnAuthToken>>,
      TError,
      void,
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof refreshAnAuthToken>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getRefreshAnAuthTokenMutationOptions(options),
    queryClient,
  );
};

/**
 * Called after sign up to perform the following actions:
 *
 * - Set the user's role
 * - Migrate anonymous user's convo to the newly-onboarded user
 * - Create a blank user profile
 * - Send an initial SMS to the user
 * @summary Complete Onboarding
 */
export const completeOnboarding = (
  completeOnboardingRequestNull?: CompleteOnboardingRequest | null,
  signal?: AbortSignal,
) => {
  return orvalClient<void>({
    url: `/user/complete-onboarding`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: completeOnboardingRequestNull,
    signal,
  });
};

export const getCompleteOnboardingMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof completeOnboarding>>,
    TError,
    { data?: CompleteOnboardingRequest | null },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof completeOnboarding>>,
  TError,
  { data?: CompleteOnboardingRequest | null },
  TContext
> => {
  const mutationKey = ["completeOnboarding"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof completeOnboarding>>,
    { data?: CompleteOnboardingRequest | null }
  > = (props) => {
    const { data } = props ?? {};

    return completeOnboarding(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CompleteOnboardingUserCompleteOnboardingPostMutationResult =
  NonNullable<Awaited<ReturnType<typeof completeOnboarding>>>;
export type CompleteOnboardingUserCompleteOnboardingPostMutationBody =
  | CompleteOnboardingRequest
  | null
  | undefined;
export type CompleteOnboardingUserCompleteOnboardingPostMutationError =
  HTTPValidationError;

/**
 * @summary Complete Onboarding
 */
export const useCompleteOnboarding = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof completeOnboarding>>,
      TError,
      { data?: CompleteOnboardingRequest | null },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof completeOnboarding>>,
  TError,
  { data?: CompleteOnboardingRequest | null },
  TContext
> => {
  return useMutation(
    getCompleteOnboardingMutationOptions(options),
    queryClient,
  );
};

/**
 * Called after sign in to migrate anonymous user's conversation to the registered user
 * @summary Complete Signin
 */
export const completeSignin = (
  completeSigninRequestNull?: CompleteSigninRequest | null,
  signal?: AbortSignal,
) => {
  return orvalClient<void>({
    url: `/user/complete-signin`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: completeSigninRequestNull,
    signal,
  });
};

export const getCompleteSigninMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof completeSignin>>,
    TError,
    { data?: CompleteSigninRequest | null },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof completeSignin>>,
  TError,
  { data?: CompleteSigninRequest | null },
  TContext
> => {
  const mutationKey = ["completeSignin"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof completeSignin>>,
    { data?: CompleteSigninRequest | null }
  > = (props) => {
    const { data } = props ?? {};

    return completeSignin(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CompleteSigninUserCompleteSigninPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof completeSignin>>
>;
export type CompleteSigninUserCompleteSigninPostMutationBody =
  | CompleteSigninRequest
  | null
  | undefined;
export type CompleteSigninUserCompleteSigninPostMutationError =
  HTTPValidationError;

/**
 * @summary Complete Signin
 */
export const useCompleteSignin = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof completeSignin>>,
      TError,
      { data?: CompleteSigninRequest | null },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof completeSignin>>,
  TError,
  { data?: CompleteSigninRequest | null },
  TContext
> => {
  return useMutation(getCompleteSigninMutationOptions(options), queryClient);
};

/**
 * Link the signed-in CHAI user to their Curai Classic account.
 *
 * The user submits a short-lived `code` proving ownership of the Classic account. We verify it
 * via the gateway and trigger the cross-account data merge.
 * @summary Link Curai Classic Account
 */
export const linkCuraiClassicAccount = (
  linkClassicAccountRequest: LinkClassicAccountRequest,
  signal?: AbortSignal,
) => {
  return orvalClient<LinkClassicAccountResponse>({
    url: `/user/link-classic-account`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: linkClassicAccountRequest,
    signal,
  });
};

export const getLinkCuraiClassicAccountMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof linkCuraiClassicAccount>>,
    TError,
    { data: LinkClassicAccountRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof linkCuraiClassicAccount>>,
  TError,
  { data: LinkClassicAccountRequest },
  TContext
> => {
  const mutationKey = ["linkCuraiClassicAccount"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof linkCuraiClassicAccount>>,
    { data: LinkClassicAccountRequest }
  > = (props) => {
    const { data } = props ?? {};

    return linkCuraiClassicAccount(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type LinkCuraiClassicAccountUserLinkClassicAccountPostMutationResult =
  NonNullable<Awaited<ReturnType<typeof linkCuraiClassicAccount>>>;
export type LinkCuraiClassicAccountUserLinkClassicAccountPostMutationBody =
  LinkClassicAccountRequest;
export type LinkCuraiClassicAccountUserLinkClassicAccountPostMutationError =
  HTTPValidationError;

/**
 * @summary Link Curai Classic Account
 */
export const useLinkCuraiClassicAccount = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof linkCuraiClassicAccount>>,
      TError,
      { data: LinkClassicAccountRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof linkCuraiClassicAccount>>,
  TError,
  { data: LinkClassicAccountRequest },
  TContext
> => {
  return useMutation(
    getLinkCuraiClassicAccountMutationOptions(options),
    queryClient,
  );
};

/**
 * Report the signed-in CHAI user's account-merge progress.
 *
 * Proxies clinic's patient-keyed link-status lookup (via the gateway partner
 * path), keyed by the user's Clerk id. The merge runs asynchronously after
 * link-classic-account, so the app polls this to move from "in progress" to
 * "merged"/"failed". A user who never started a merge comes back as
 * {"status": "none"}, which the app treats as nothing to show.
 * @summary Get Account Merge Status
 */
export const getAccountMergeStatus = (signal?: AbortSignal) => {
  return orvalClient<MergeStatusResponse>({
    url: `/user/merge-status`,
    method: "GET",
    signal,
  });
};

export const getGetAccountMergeStatusQueryKey = () => {
  return [`/user/merge-status`] as const;
};

export const getGetAccountMergeStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof getAccountMergeStatus>>,
  TError = HTTPValidationError,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getAccountMergeStatus>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAccountMergeStatusQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAccountMergeStatus>>
  > = ({ signal }) => getAccountMergeStatus(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAccountMergeStatus>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAccountMergeStatusUserMergeStatusGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAccountMergeStatus>>
>;
export type GetAccountMergeStatusUserMergeStatusGetQueryError =
  HTTPValidationError;

export function useGetAccountMergeStatus<
  TData = Awaited<ReturnType<typeof getAccountMergeStatus>>,
  TError = HTTPValidationError,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAccountMergeStatus>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAccountMergeStatus>>,
          TError,
          Awaited<ReturnType<typeof getAccountMergeStatus>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAccountMergeStatus<
  TData = Awaited<ReturnType<typeof getAccountMergeStatus>>,
  TError = HTTPValidationError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAccountMergeStatus>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAccountMergeStatus>>,
          TError,
          Awaited<ReturnType<typeof getAccountMergeStatus>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAccountMergeStatus<
  TData = Awaited<ReturnType<typeof getAccountMergeStatus>>,
  TError = HTTPValidationError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAccountMergeStatus>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Account Merge Status
 */

export function useGetAccountMergeStatus<
  TData = Awaited<ReturnType<typeof getAccountMergeStatus>>,
  TError = HTTPValidationError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAccountMergeStatus>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetAccountMergeStatusQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get User Profile
 */
export const getUserProfile = (signal?: AbortSignal) => {
  return orvalClient<UserProfileResponse | UserProfileMissingResponse>({
    url: `/user/profile/`,
    method: "GET",
    signal,
  });
};

export const getGetUserProfileQueryKey = () => {
  return [`/user/profile/`] as const;
};

export const getGetUserProfileQueryOptions = <
  TData = Awaited<ReturnType<typeof getUserProfile>>,
  TError = HTTPValidationError,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getUserProfile>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetUserProfileQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserProfile>>> = ({
    signal,
  }) => getUserProfile(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUserProfile>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetUserProfileUserProfileGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUserProfile>>
>;
export type GetUserProfileUserProfileGetQueryError = HTTPValidationError;

export function useGetUserProfile<
  TData = Awaited<ReturnType<typeof getUserProfile>>,
  TError = HTTPValidationError,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUserProfile>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserProfile>>,
          TError,
          Awaited<ReturnType<typeof getUserProfile>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUserProfile<
  TData = Awaited<ReturnType<typeof getUserProfile>>,
  TError = HTTPValidationError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUserProfile>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserProfile>>,
          TError,
          Awaited<ReturnType<typeof getUserProfile>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUserProfile<
  TData = Awaited<ReturnType<typeof getUserProfile>>,
  TError = HTTPValidationError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUserProfile>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get User Profile
 */

export function useGetUserProfile<
  TData = Awaited<ReturnType<typeof getUserProfile>>,
  TError = HTTPValidationError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUserProfile>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetUserProfileQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Upsert User Profile
 */
export const upsertUserProfile = (
  userProfileRequest: UserProfileRequest,
  signal?: AbortSignal,
) => {
  return orvalClient<UserProfileResponse>({
    url: `/user/profile/`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: userProfileRequest,
    signal,
  });
};

export const getUpsertUserProfileMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof upsertUserProfile>>,
    TError,
    { data: UserProfileRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof upsertUserProfile>>,
  TError,
  { data: UserProfileRequest },
  TContext
> => {
  const mutationKey = ["upsertUserProfile"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof upsertUserProfile>>,
    { data: UserProfileRequest }
  > = (props) => {
    const { data } = props ?? {};

    return upsertUserProfile(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpsertUserProfileUserProfilePutMutationResult = NonNullable<
  Awaited<ReturnType<typeof upsertUserProfile>>
>;
export type UpsertUserProfileUserProfilePutMutationBody = UserProfileRequest;
export type UpsertUserProfileUserProfilePutMutationError = HTTPValidationError;

/**
 * @summary Upsert User Profile
 */
export const useUpsertUserProfile = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof upsertUserProfile>>,
      TError,
      { data: UserProfileRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof upsertUserProfile>>,
  TError,
  { data: UserProfileRequest },
  TContext
> => {
  return useMutation(getUpsertUserProfileMutationOptions(options), queryClient);
};

/**
 * Returns is_user_age_prohibited=True/False if user has a profile with age < 18.
 * @summary Get Age Verification Status
 */
export const getAgeVerificationStatus = (signal?: AbortSignal) => {
  return orvalClient<AgeVerificationStatusResponse>({
    url: `/user/profile/age-verification-status`,
    method: "GET",
    signal,
  });
};

export const getGetAgeVerificationStatusQueryKey = () => {
  return [`/user/profile/age-verification-status`] as const;
};

export const getGetAgeVerificationStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof getAgeVerificationStatus>>,
  TError = HTTPValidationError,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getAgeVerificationStatus>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAgeVerificationStatusQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAgeVerificationStatus>>
  > = ({ signal }) => getAgeVerificationStatus(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAgeVerificationStatus>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAgeVerificationStatusUserProfileAgeVerificationStatusGetQueryResult =
  NonNullable<Awaited<ReturnType<typeof getAgeVerificationStatus>>>;
export type GetAgeVerificationStatusUserProfileAgeVerificationStatusGetQueryError =
  HTTPValidationError;

export function useGetAgeVerificationStatus<
  TData = Awaited<ReturnType<typeof getAgeVerificationStatus>>,
  TError = HTTPValidationError,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAgeVerificationStatus>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAgeVerificationStatus>>,
          TError,
          Awaited<ReturnType<typeof getAgeVerificationStatus>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAgeVerificationStatus<
  TData = Awaited<ReturnType<typeof getAgeVerificationStatus>>,
  TError = HTTPValidationError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAgeVerificationStatus>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAgeVerificationStatus>>,
          TError,
          Awaited<ReturnType<typeof getAgeVerificationStatus>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAgeVerificationStatus<
  TData = Awaited<ReturnType<typeof getAgeVerificationStatus>>,
  TError = HTTPValidationError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAgeVerificationStatus>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Age Verification Status
 */

export function useGetAgeVerificationStatus<
  TData = Awaited<ReturnType<typeof getAgeVerificationStatus>>,
  TError = HTTPValidationError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAgeVerificationStatus>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetAgeVerificationStatusQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Set multiple consents atomically for the authenticated user.
 *
 * This endpoint allows setting all five consent types (telehealth_informed_consent,
 * terms_of_use_and_privacy, surescripts, hie, and data_sharing) in a single atomic
 * operation. Either all consents are set successfully, or none are set.
 * Note: HIE consent cannot be revoked while enrolled in an ACCESS program.
 * @summary Set Multiple Consents
 */
export const setMultipleConsents = (
  consentRequest: ConsentRequest,
  signal?: AbortSignal,
) => {
  return orvalClient<unknown>({
    url: `/user/profile/consents`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: consentRequest,
    signal,
  });
};

export const getSetMultipleConsentsMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setMultipleConsents>>,
    TError,
    { data: ConsentRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof setMultipleConsents>>,
  TError,
  { data: ConsentRequest },
  TContext
> => {
  const mutationKey = ["setMultipleConsents"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setMultipleConsents>>,
    { data: ConsentRequest }
  > = (props) => {
    const { data } = props ?? {};

    return setMultipleConsents(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type SetMultipleConsentsUserProfileConsentsPutMutationResult =
  NonNullable<Awaited<ReturnType<typeof setMultipleConsents>>>;
export type SetMultipleConsentsUserProfileConsentsPutMutationBody =
  ConsentRequest;
export type SetMultipleConsentsUserProfileConsentsPutMutationError =
  HTTPValidationError;

/**
 * @summary Set Multiple Consents
 */
export const useSetMultipleConsents = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof setMultipleConsents>>,
      TError,
      { data: ConsentRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof setMultipleConsents>>,
  TError,
  { data: ConsentRequest },
  TContext
> => {
  return useMutation(
    getSetMultipleConsentsMutationOptions(options),
    queryClient,
  );
};

/**
 * @summary Update Vitals
 */
export const updateVitals = (
  vitalsRequest: VitalsRequest,
  signal?: AbortSignal,
) => {
  return orvalClient<void>({
    url: `/user/profile/vitals`,
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    data: vitalsRequest,
    signal,
  });
};

export const getUpdateVitalsMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateVitals>>,
    TError,
    { data: VitalsRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateVitals>>,
  TError,
  { data: VitalsRequest },
  TContext
> => {
  const mutationKey = ["updateVitals"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateVitals>>,
    { data: VitalsRequest }
  > = (props) => {
    const { data } = props ?? {};

    return updateVitals(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateVitalsUserProfileVitalsPatchMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateVitals>>
>;
export type UpdateVitalsUserProfileVitalsPatchMutationBody = VitalsRequest;
export type UpdateVitalsUserProfileVitalsPatchMutationError =
  HTTPValidationError;

/**
 * @summary Update Vitals
 */
export const useUpdateVitals = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateVitals>>,
      TError,
      { data: VitalsRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateVitals>>,
  TError,
  { data: VitalsRequest },
  TContext
> => {
  return useMutation(getUpdateVitalsMutationOptions(options), queryClient);
};

/**
 * @summary Update Notification Preferences
 */
export const updateNotificationPreferences = (
  notificationPreferencesRequest: NotificationPreferencesRequest,
  signal?: AbortSignal,
) => {
  return orvalClient<unknown>({
    url: `/user/profile/notification-preferences`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: notificationPreferencesRequest,
    signal,
  });
};

export const getUpdateNotificationPreferencesMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateNotificationPreferences>>,
    TError,
    { data: NotificationPreferencesRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateNotificationPreferences>>,
  TError,
  { data: NotificationPreferencesRequest },
  TContext
> => {
  const mutationKey = ["updateNotificationPreferences"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateNotificationPreferences>>,
    { data: NotificationPreferencesRequest }
  > = (props) => {
    const { data } = props ?? {};

    return updateNotificationPreferences(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateNotificationPreferencesUserProfileNotificationPreferencesPutMutationResult =
  NonNullable<Awaited<ReturnType<typeof updateNotificationPreferences>>>;
export type UpdateNotificationPreferencesUserProfileNotificationPreferencesPutMutationBody =
  NotificationPreferencesRequest;
export type UpdateNotificationPreferencesUserProfileNotificationPreferencesPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Notification Preferences
 */
export const useUpdateNotificationPreferences = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateNotificationPreferences>>,
      TError,
      { data: NotificationPreferencesRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateNotificationPreferences>>,
  TError,
  { data: NotificationPreferencesRequest },
  TContext
> => {
  return useMutation(
    getUpdateNotificationPreferencesMutationOptions(options),
    queryClient,
  );
};

/**
 * Validate that a zipcode belongs to the provided state.
 * @summary Validate Zip Code
 */
export const validateZipCode = (
  zipcodeValidationRequest: ZipcodeValidationRequest,
  signal?: AbortSignal,
) => {
  return orvalClient<ZipcodeValidationResponse>({
    url: `/user/profile/validate-zip-code`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: zipcodeValidationRequest,
    signal,
  });
};

export const getValidateZipCodeMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof validateZipCode>>,
    TError,
    { data: ZipcodeValidationRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof validateZipCode>>,
  TError,
  { data: ZipcodeValidationRequest },
  TContext
> => {
  const mutationKey = ["validateZipCode"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof validateZipCode>>,
    { data: ZipcodeValidationRequest }
  > = (props) => {
    const { data } = props ?? {};

    return validateZipCode(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ValidateZIPCodeUserProfileValidateZipCodePostMutationResult =
  NonNullable<Awaited<ReturnType<typeof validateZipCode>>>;
export type ValidateZIPCodeUserProfileValidateZipCodePostMutationBody =
  ZipcodeValidationRequest;
export type ValidateZIPCodeUserProfileValidateZipCodePostMutationError =
  HTTPValidationError;

/**
 * @summary Validate Zip Code
 */
export const useValidateZipCode = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof validateZipCode>>,
      TError,
      { data: ZipcodeValidationRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof validateZipCode>>,
  TError,
  { data: ZipcodeValidationRequest },
  TContext
> => {
  return useMutation(getValidateZipCodeMutationOptions(options), queryClient);
};

/**
 * @summary Get Or Create User Progression
 */
export const getOrCreateUserProgression = (
  profileBuilderProgressionRequestRxAgentProgressionRequestDefaultVisitProgressionRequestAIDoctorRxRenewalProgressionRequestAIDoctorDiagnosisProgressionRequestPartnerPostRegistrationProgressionRequestPreAsyncProgressionRequestAccessEnrollmentProgressionRequestPaywallVisitProgressionRequestPaywallAsyncVisitProgressionRequest:
    | ProfileBuilderProgressionRequest
    | RxAgentProgressionRequest
    | DefaultVisitProgressionRequest
    | AIDoctorRxRenewalProgressionRequest
    | AIDoctorDiagnosisProgressionRequest
    | PartnerPostRegistrationProgressionRequest
    | PreAsyncProgressionRequest
    | AccessEnrollmentProgressionRequest
    | PaywallVisitProgressionRequest
    | PaywallAsyncVisitProgressionRequest,
  signal?: AbortSignal,
) => {
  return orvalClient<UserProgressionStateModel>({
    url: `/user/progression/`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: profileBuilderProgressionRequestRxAgentProgressionRequestDefaultVisitProgressionRequestAIDoctorRxRenewalProgressionRequestAIDoctorDiagnosisProgressionRequestPartnerPostRegistrationProgressionRequestPreAsyncProgressionRequestAccessEnrollmentProgressionRequestPaywallVisitProgressionRequestPaywallAsyncVisitProgressionRequest,
    signal,
  });
};

export const getGetOrCreateUserProgressionMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getOrCreateUserProgression>>,
    TError,
    {
      data:
        | ProfileBuilderProgressionRequest
        | RxAgentProgressionRequest
        | DefaultVisitProgressionRequest
        | AIDoctorRxRenewalProgressionRequest
        | AIDoctorDiagnosisProgressionRequest
        | PartnerPostRegistrationProgressionRequest
        | PreAsyncProgressionRequest
        | AccessEnrollmentProgressionRequest
        | PaywallVisitProgressionRequest
        | PaywallAsyncVisitProgressionRequest;
    },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getOrCreateUserProgression>>,
  TError,
  {
    data:
      | ProfileBuilderProgressionRequest
      | RxAgentProgressionRequest
      | DefaultVisitProgressionRequest
      | AIDoctorRxRenewalProgressionRequest
      | AIDoctorDiagnosisProgressionRequest
      | PartnerPostRegistrationProgressionRequest
      | PreAsyncProgressionRequest
      | AccessEnrollmentProgressionRequest
      | PaywallVisitProgressionRequest
      | PaywallAsyncVisitProgressionRequest;
  },
  TContext
> => {
  const mutationKey = ["getOrCreateUserProgression"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getOrCreateUserProgression>>,
    {
      data:
        | ProfileBuilderProgressionRequest
        | RxAgentProgressionRequest
        | DefaultVisitProgressionRequest
        | AIDoctorRxRenewalProgressionRequest
        | AIDoctorDiagnosisProgressionRequest
        | PartnerPostRegistrationProgressionRequest
        | PreAsyncProgressionRequest
        | AccessEnrollmentProgressionRequest
        | PaywallVisitProgressionRequest
        | PaywallAsyncVisitProgressionRequest;
    }
  > = (props) => {
    const { data } = props ?? {};

    return getOrCreateUserProgression(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetOrCreateUserProgressionUserProgressionPostMutationResult =
  NonNullable<Awaited<ReturnType<typeof getOrCreateUserProgression>>>;
export type GetOrCreateUserProgressionUserProgressionPostMutationBody =
  | ProfileBuilderProgressionRequest
  | RxAgentProgressionRequest
  | DefaultVisitProgressionRequest
  | AIDoctorRxRenewalProgressionRequest
  | AIDoctorDiagnosisProgressionRequest
  | PartnerPostRegistrationProgressionRequest
  | PreAsyncProgressionRequest
  | AccessEnrollmentProgressionRequest
  | PaywallVisitProgressionRequest
  | PaywallAsyncVisitProgressionRequest;
export type GetOrCreateUserProgressionUserProgressionPostMutationError =
  HTTPValidationError;

/**
 * @summary Get Or Create User Progression
 */
export const useGetOrCreateUserProgression = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof getOrCreateUserProgression>>,
      TError,
      {
        data:
          | ProfileBuilderProgressionRequest
          | RxAgentProgressionRequest
          | DefaultVisitProgressionRequest
          | AIDoctorRxRenewalProgressionRequest
          | AIDoctorDiagnosisProgressionRequest
          | PartnerPostRegistrationProgressionRequest
          | PreAsyncProgressionRequest
          | AccessEnrollmentProgressionRequest
          | PaywallVisitProgressionRequest
          | PaywallAsyncVisitProgressionRequest;
      },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof getOrCreateUserProgression>>,
  TError,
  {
    data:
      | ProfileBuilderProgressionRequest
      | RxAgentProgressionRequest
      | DefaultVisitProgressionRequest
      | AIDoctorRxRenewalProgressionRequest
      | AIDoctorDiagnosisProgressionRequest
      | PartnerPostRegistrationProgressionRequest
      | PreAsyncProgressionRequest
      | AccessEnrollmentProgressionRequest
      | PaywallVisitProgressionRequest
      | PaywallAsyncVisitProgressionRequest;
  },
  TContext
> => {
  return useMutation(
    getGetOrCreateUserProgressionMutationOptions(options),
    queryClient,
  );
};

/**
 * Return the visit modalities + pricing available for a progression flow.
 *
 * Powers the FE payment-selection step and the entry offer card; pricing/name come from the
 * EntitlementProduct catalog. A clinic request narrows the async paywall to its one modality, taken
 * from the progression when user_progression_id has one, else clinic_request_id. The A/V requirement
 * is resolved from the registered user's profile state so the offering reflects the modalities they
 * can actually pick; user_progression_id reuses the value the progression already cached.
 *
 * Prices follow a registered user's affiliation, as checkout does; partner_intent previews them
 * for an anonymous user.
 * @summary Get Visit Options For A Flow
 */
export const getVisitOptionsForAFlow = (
  flowName: string,
  params?: GetVisitOptionsForAFlowUserProgressionFlowsFlowNameVisitOptionsGetParams,
  signal?: AbortSignal,
) => {
  return orvalClient<VisitOptionsResponse>({
    url: `/user/progression/flows/${flowName}/visit-options`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetVisitOptionsForAFlowQueryKey = (
  flowName: string,
  params?: GetVisitOptionsForAFlowUserProgressionFlowsFlowNameVisitOptionsGetParams,
) => {
  return [
    `/user/progression/flows/${flowName}/visit-options`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetVisitOptionsForAFlowQueryOptions = <
  TData = Awaited<ReturnType<typeof getVisitOptionsForAFlow>>,
  TError = HTTPValidationError,
>(
  flowName: string,
  params?: GetVisitOptionsForAFlowUserProgressionFlowsFlowNameVisitOptionsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getVisitOptionsForAFlow>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetVisitOptionsForAFlowQueryKey(flowName, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getVisitOptionsForAFlow>>
  > = ({ signal }) => getVisitOptionsForAFlow(flowName, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: flowName !== null && flowName !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getVisitOptionsForAFlow>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetVisitOptionsForAFlowUserProgressionFlowsFlowNameVisitOptionsGetQueryResult =
  NonNullable<Awaited<ReturnType<typeof getVisitOptionsForAFlow>>>;
export type GetVisitOptionsForAFlowUserProgressionFlowsFlowNameVisitOptionsGetQueryError =
  HTTPValidationError;

export function useGetVisitOptionsForAFlow<
  TData = Awaited<ReturnType<typeof getVisitOptionsForAFlow>>,
  TError = HTTPValidationError,
>(
  flowName: string,
  params:
    | undefined
    | GetVisitOptionsForAFlowUserProgressionFlowsFlowNameVisitOptionsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getVisitOptionsForAFlow>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVisitOptionsForAFlow>>,
          TError,
          Awaited<ReturnType<typeof getVisitOptionsForAFlow>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetVisitOptionsForAFlow<
  TData = Awaited<ReturnType<typeof getVisitOptionsForAFlow>>,
  TError = HTTPValidationError,
>(
  flowName: string,
  params?: GetVisitOptionsForAFlowUserProgressionFlowsFlowNameVisitOptionsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getVisitOptionsForAFlow>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVisitOptionsForAFlow>>,
          TError,
          Awaited<ReturnType<typeof getVisitOptionsForAFlow>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetVisitOptionsForAFlow<
  TData = Awaited<ReturnType<typeof getVisitOptionsForAFlow>>,
  TError = HTTPValidationError,
>(
  flowName: string,
  params?: GetVisitOptionsForAFlowUserProgressionFlowsFlowNameVisitOptionsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getVisitOptionsForAFlow>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Visit Options For A Flow
 */

export function useGetVisitOptionsForAFlow<
  TData = Awaited<ReturnType<typeof getVisitOptionsForAFlow>>,
  TError = HTTPValidationError,
>(
  flowName: string,
  params?: GetVisitOptionsForAFlowUserProgressionFlowsFlowNameVisitOptionsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getVisitOptionsForAFlow>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetVisitOptionsForAFlowQueryOptions(
    flowName,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get User Progression By Id
 */
export const getUserProgressionById = (
  progressionId: string,
  signal?: AbortSignal,
) => {
  return orvalClient<UserProgressionStateModel>({
    url: `/user/progression/${progressionId}`,
    method: "GET",
    signal,
  });
};

export const getGetUserProgressionByIdQueryKey = (progressionId: string) => {
  return [`/user/progression/${progressionId}`] as const;
};

export const getGetUserProgressionByIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getUserProgressionById>>,
  TError = HTTPValidationError,
>(
  progressionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserProgressionById>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetUserProgressionByIdQueryKey(progressionId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getUserProgressionById>>
  > = ({ signal }) => getUserProgressionById(progressionId, signal);

  return {
    queryKey,
    queryFn,
    enabled: progressionId !== null && progressionId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getUserProgressionById>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetUserProgressionByIDUserProgressionProgressionIdGetQueryResult =
  NonNullable<Awaited<ReturnType<typeof getUserProgressionById>>>;
export type GetUserProgressionByIDUserProgressionProgressionIdGetQueryError =
  HTTPValidationError;

export function useGetUserProgressionById<
  TData = Awaited<ReturnType<typeof getUserProgressionById>>,
  TError = HTTPValidationError,
>(
  progressionId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserProgressionById>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserProgressionById>>,
          TError,
          Awaited<ReturnType<typeof getUserProgressionById>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUserProgressionById<
  TData = Awaited<ReturnType<typeof getUserProgressionById>>,
  TError = HTTPValidationError,
>(
  progressionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserProgressionById>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserProgressionById>>,
          TError,
          Awaited<ReturnType<typeof getUserProgressionById>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUserProgressionById<
  TData = Awaited<ReturnType<typeof getUserProgressionById>>,
  TError = HTTPValidationError,
>(
  progressionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserProgressionById>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get User Progression By Id
 */

export function useGetUserProgressionById<
  TData = Awaited<ReturnType<typeof getUserProgressionById>>,
  TError = HTTPValidationError,
>(
  progressionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserProgressionById>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetUserProgressionByIdQueryOptions(
    progressionId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List Outstanding Progression Questionnaires
 */
export const listOutstandingProgressionQuestionnaires = (
  progressionId: string,
  signal?: AbortSignal,
) => {
  return orvalClient<QuestionnaireDefinition[]>({
    url: `/user/progression/${progressionId}/questionnaires`,
    method: "GET",
    signal,
  });
};

export const getListOutstandingProgressionQuestionnairesQueryKey = (
  progressionId: string,
) => {
  return [`/user/progression/${progressionId}/questionnaires`] as const;
};

export const getListOutstandingProgressionQuestionnairesQueryOptions = <
  TData = Awaited<ReturnType<typeof listOutstandingProgressionQuestionnaires>>,
  TError = HTTPValidationError,
>(
  progressionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listOutstandingProgressionQuestionnaires>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListOutstandingProgressionQuestionnairesQueryKey(progressionId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listOutstandingProgressionQuestionnaires>>
  > = ({ signal }) =>
    listOutstandingProgressionQuestionnaires(progressionId, signal);

  return {
    queryKey,
    queryFn,
    enabled: progressionId !== null && progressionId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listOutstandingProgressionQuestionnaires>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListOutstandingProgressionQuestionnairesUserProgressionProgressionIdQuestionnairesGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof listOutstandingProgressionQuestionnaires>>
  >;
export type ListOutstandingProgressionQuestionnairesUserProgressionProgressionIdQuestionnairesGetQueryError =
  HTTPValidationError;

export function useListOutstandingProgressionQuestionnaires<
  TData = Awaited<ReturnType<typeof listOutstandingProgressionQuestionnaires>>,
  TError = HTTPValidationError,
>(
  progressionId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listOutstandingProgressionQuestionnaires>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listOutstandingProgressionQuestionnaires>>,
          TError,
          Awaited<ReturnType<typeof listOutstandingProgressionQuestionnaires>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListOutstandingProgressionQuestionnaires<
  TData = Awaited<ReturnType<typeof listOutstandingProgressionQuestionnaires>>,
  TError = HTTPValidationError,
>(
  progressionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listOutstandingProgressionQuestionnaires>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listOutstandingProgressionQuestionnaires>>,
          TError,
          Awaited<ReturnType<typeof listOutstandingProgressionQuestionnaires>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListOutstandingProgressionQuestionnaires<
  TData = Awaited<ReturnType<typeof listOutstandingProgressionQuestionnaires>>,
  TError = HTTPValidationError,
>(
  progressionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listOutstandingProgressionQuestionnaires>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List Outstanding Progression Questionnaires
 */

export function useListOutstandingProgressionQuestionnaires<
  TData = Awaited<ReturnType<typeof listOutstandingProgressionQuestionnaires>>,
  TError = HTTPValidationError,
>(
  progressionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listOutstandingProgressionQuestionnaires>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListOutstandingProgressionQuestionnairesQueryOptions(
    progressionId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Submit Progression Questionnaire Response
 */
export const submitProgressionQuestionnaireResponse = (
  progressionId: string,
  questionnaireId: string,
  questionnaireResponseSubmissionRequest: QuestionnaireResponseSubmissionRequest,
  signal?: AbortSignal,
) => {
  return orvalClient<QuestionnaireResponseSubmissionResponse>({
    url: `/user/progression/${progressionId}/questionnaires/${questionnaireId}/responses`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: questionnaireResponseSubmissionRequest,
    signal,
  });
};

export const getSubmitProgressionQuestionnaireResponseMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof submitProgressionQuestionnaireResponse>>,
    TError,
    {
      progressionId: string;
      questionnaireId: string;
      data: QuestionnaireResponseSubmissionRequest;
    },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof submitProgressionQuestionnaireResponse>>,
  TError,
  {
    progressionId: string;
    questionnaireId: string;
    data: QuestionnaireResponseSubmissionRequest;
  },
  TContext
> => {
  const mutationKey = ["submitProgressionQuestionnaireResponse"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof submitProgressionQuestionnaireResponse>>,
    {
      progressionId: string;
      questionnaireId: string;
      data: QuestionnaireResponseSubmissionRequest;
    }
  > = (props) => {
    const { progressionId, questionnaireId, data } = props ?? {};

    return submitProgressionQuestionnaireResponse(
      progressionId,
      questionnaireId,
      data,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type SubmitProgressionQuestionnaireResponseUserProgressionProgressionIdQuestionnairesQuestionnaireIdResponsesPostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof submitProgressionQuestionnaireResponse>>
  >;
export type SubmitProgressionQuestionnaireResponseUserProgressionProgressionIdQuestionnairesQuestionnaireIdResponsesPostMutationBody =
  QuestionnaireResponseSubmissionRequest;
export type SubmitProgressionQuestionnaireResponseUserProgressionProgressionIdQuestionnairesQuestionnaireIdResponsesPostMutationError =
  HTTPValidationError;

/**
 * @summary Submit Progression Questionnaire Response
 */
export const useSubmitProgressionQuestionnaireResponse = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof submitProgressionQuestionnaireResponse>>,
      TError,
      {
        progressionId: string;
        questionnaireId: string;
        data: QuestionnaireResponseSubmissionRequest;
      },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof submitProgressionQuestionnaireResponse>>,
  TError,
  {
    progressionId: string;
    questionnaireId: string;
    data: QuestionnaireResponseSubmissionRequest;
  },
  TContext
> => {
  return useMutation(
    getSubmitProgressionQuestionnaireResponseMutationOptions(options),
    queryClient,
  );
};

/**
 * @summary Advance User Progression To Next Step
 */
export const advanceUserProgressionToNextStep = (
  progressionId: string,
  advanceProgressionRequest: AdvanceProgressionRequest,
  signal?: AbortSignal,
) => {
  return orvalClient<UserProgressionStateModel>({
    url: `/user/progression/${progressionId}/next`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: advanceProgressionRequest,
    signal,
  });
};

export const getAdvanceUserProgressionToNextStepMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof advanceUserProgressionToNextStep>>,
    TError,
    { progressionId: string; data: AdvanceProgressionRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof advanceUserProgressionToNextStep>>,
  TError,
  { progressionId: string; data: AdvanceProgressionRequest },
  TContext
> => {
  const mutationKey = ["advanceUserProgressionToNextStep"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof advanceUserProgressionToNextStep>>,
    { progressionId: string; data: AdvanceProgressionRequest }
  > = (props) => {
    const { progressionId, data } = props ?? {};

    return advanceUserProgressionToNextStep(progressionId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdvanceUserProgressionToNextStepUserProgressionProgressionIdNextPostMutationResult =
  NonNullable<Awaited<ReturnType<typeof advanceUserProgressionToNextStep>>>;
export type AdvanceUserProgressionToNextStepUserProgressionProgressionIdNextPostMutationBody =
  AdvanceProgressionRequest;
export type AdvanceUserProgressionToNextStepUserProgressionProgressionIdNextPostMutationError =
  HTTPValidationError;

/**
 * @summary Advance User Progression To Next Step
 */
export const useAdvanceUserProgressionToNextStep = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof advanceUserProgressionToNextStep>>,
      TError,
      { progressionId: string; data: AdvanceProgressionRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof advanceUserProgressionToNextStep>>,
  TError,
  { progressionId: string; data: AdvanceProgressionRequest },
  TContext
> => {
  return useMutation(
    getAdvanceUserProgressionToNextStepMutationOptions(options),
    queryClient,
  );
};

/**
 * @summary Go Back In User Progression
 */
export const goBackInUserProgression = (
  progressionId: string,
  backProgressionRequest: BackProgressionRequest,
  signal?: AbortSignal,
) => {
  return orvalClient<UserProgressionStateModel>({
    url: `/user/progression/${progressionId}/back`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: backProgressionRequest,
    signal,
  });
};

export const getGoBackInUserProgressionMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof goBackInUserProgression>>,
    TError,
    { progressionId: string; data: BackProgressionRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof goBackInUserProgression>>,
  TError,
  { progressionId: string; data: BackProgressionRequest },
  TContext
> => {
  const mutationKey = ["goBackInUserProgression"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof goBackInUserProgression>>,
    { progressionId: string; data: BackProgressionRequest }
  > = (props) => {
    const { progressionId, data } = props ?? {};

    return goBackInUserProgression(progressionId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type GoBackInUserProgressionUserProgressionProgressionIdBackPostMutationResult =
  NonNullable<Awaited<ReturnType<typeof goBackInUserProgression>>>;
export type GoBackInUserProgressionUserProgressionProgressionIdBackPostMutationBody =
  BackProgressionRequest;
export type GoBackInUserProgressionUserProgressionProgressionIdBackPostMutationError =
  HTTPValidationError;

/**
 * @summary Go Back In User Progression
 */
export const useGoBackInUserProgression = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof goBackInUserProgression>>,
      TError,
      { progressionId: string; data: BackProgressionRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof goBackInUserProgression>>,
  TError,
  { progressionId: string; data: BackProgressionRequest },
  TContext
> => {
  return useMutation(
    getGoBackInUserProgressionMutationOptions(options),
    queryClient,
  );
};

/**
 * End a progression the user has opted out of, so nothing resumes or reopens it.
 *
 * Used by steps that can be declined outright (e.g. the ACCESS program consent) rather than
 * backed out of.
 * @summary Archive User Progression
 */
export const archiveUserProgression = (
  progressionId: string,
  signal?: AbortSignal,
) => {
  return orvalClient<UserProgressionStateModel>({
    url: `/user/progression/${progressionId}/archive`,
    method: "POST",
    signal,
  });
};

export const getArchiveUserProgressionMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof archiveUserProgression>>,
    TError,
    { progressionId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof archiveUserProgression>>,
  TError,
  { progressionId: string },
  TContext
> => {
  const mutationKey = ["archiveUserProgression"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof archiveUserProgression>>,
    { progressionId: string }
  > = (props) => {
    const { progressionId } = props ?? {};

    return archiveUserProgression(progressionId);
  };

  return { mutationFn, ...mutationOptions };
};

export type ArchiveUserProgressionUserProgressionProgressionIdArchivePostMutationResult =
  NonNullable<Awaited<ReturnType<typeof archiveUserProgression>>>;

export type ArchiveUserProgressionUserProgressionProgressionIdArchivePostMutationError =
  HTTPValidationError;

/**
 * @summary Archive User Progression
 */
export const useArchiveUserProgression = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof archiveUserProgression>>,
      TError,
      { progressionId: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof archiveUserProgression>>,
  TError,
  { progressionId: string },
  TContext
> => {
  return useMutation(
    getArchiveUserProgressionMutationOptions(options),
    queryClient,
  );
};

/**
 * @summary Go To Payment Selection
 */
export const goToPaymentSelection = (
  progressionId: string,
  signal?: AbortSignal,
) => {
  return orvalClient<UserProgressionStateModel>({
    url: `/user/progression/${progressionId}/payment-selection`,
    method: "POST",
    signal,
  });
};

export const getGoToPaymentSelectionMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof goToPaymentSelection>>,
    TError,
    { progressionId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof goToPaymentSelection>>,
  TError,
  { progressionId: string },
  TContext
> => {
  const mutationKey = ["goToPaymentSelection"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof goToPaymentSelection>>,
    { progressionId: string }
  > = (props) => {
    const { progressionId } = props ?? {};

    return goToPaymentSelection(progressionId);
  };

  return { mutationFn, ...mutationOptions };
};

export type GoToPaymentSelectionUserProgressionProgressionIdPaymentSelectionPostMutationResult =
  NonNullable<Awaited<ReturnType<typeof goToPaymentSelection>>>;

export type GoToPaymentSelectionUserProgressionProgressionIdPaymentSelectionPostMutationError =
  HTTPValidationError;

/**
 * @summary Go To Payment Selection
 */
export const useGoToPaymentSelection = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof goToPaymentSelection>>,
      TError,
      { progressionId: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof goToPaymentSelection>>,
  TError,
  { progressionId: string },
  TContext
> => {
  return useMutation(
    getGoToPaymentSelectionMutationOptions(options),
    queryClient,
  );
};

/**
 * Return where the FE should send the user to pay for this progression.
 *
 * Today that's a Stripe Checkout Session URL. A still-open session referenced by the
 * progression is reused rather than recreated, so a user can't generate unbounded sessions.
 * @summary Construct Payment Destination
 */
export const constructPaymentDestination = (
  progressionId: string,
  paymentDestinationRequest: PaymentDestinationRequest,
  signal?: AbortSignal,
) => {
  return orvalClient<PaymentDestinationResponse>({
    url: `/user/progression/${progressionId}/payment-destination`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: paymentDestinationRequest,
    signal,
  });
};

export const getConstructPaymentDestinationMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof constructPaymentDestination>>,
    TError,
    { progressionId: string; data: PaymentDestinationRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof constructPaymentDestination>>,
  TError,
  { progressionId: string; data: PaymentDestinationRequest },
  TContext
> => {
  const mutationKey = ["constructPaymentDestination"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof constructPaymentDestination>>,
    { progressionId: string; data: PaymentDestinationRequest }
  > = (props) => {
    const { progressionId, data } = props ?? {};

    return constructPaymentDestination(progressionId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ConstructPaymentDestinationUserProgressionProgressionIdPaymentDestinationPostMutationResult =
  NonNullable<Awaited<ReturnType<typeof constructPaymentDestination>>>;
export type ConstructPaymentDestinationUserProgressionProgressionIdPaymentDestinationPostMutationBody =
  PaymentDestinationRequest;
export type ConstructPaymentDestinationUserProgressionProgressionIdPaymentDestinationPostMutationError =
  HTTPValidationError;

/**
 * @summary Construct Payment Destination
 */
export const useConstructPaymentDestination = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof constructPaymentDestination>>,
      TError,
      { progressionId: string; data: PaymentDestinationRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof constructPaymentDestination>>,
  TError,
  { progressionId: string; data: PaymentDestinationRequest },
  TContext
> => {
  return useMutation(
    getConstructPaymentDestinationMutationOptions(options),
    queryClient,
  );
};

/**
 * Verify a returning Stripe checkout, grant the entitlement, and return the progression.
 *
 * This is a proactive optimization: we grant as soon as the user lands back here from Stripe so
 * they aren't blocked by webhook latency. The ``checkout.session.completed`` webhook remains the
 * ultimate source of truth for Stripe entitlement state; both converge on the same grant. The
 * FE auto-advances to visit escalation once this succeeds (FIDO-607).
 *
 * Args:
 *     progression_id: The progression the checkout was started for.
 *     payload: The Stripe session id from the redirect.
 *     user: The authenticated user.
 *
 * Returns:
 *     The current progression state, for the FE to advance from.
 * @summary Handle Checkout Success
 */
export const handleCheckoutSuccess = (
  progressionId: string,
  checkoutSuccessRequest: CheckoutSuccessRequest,
  signal?: AbortSignal,
) => {
  return orvalClient<CheckoutSuccessResponse>({
    url: `/user/progression/${progressionId}/checkout-success`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: checkoutSuccessRequest,
    signal,
  });
};

export const getHandleCheckoutSuccessMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof handleCheckoutSuccess>>,
    TError,
    { progressionId: string; data: CheckoutSuccessRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof handleCheckoutSuccess>>,
  TError,
  { progressionId: string; data: CheckoutSuccessRequest },
  TContext
> => {
  const mutationKey = ["handleCheckoutSuccess"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof handleCheckoutSuccess>>,
    { progressionId: string; data: CheckoutSuccessRequest }
  > = (props) => {
    const { progressionId, data } = props ?? {};

    return handleCheckoutSuccess(progressionId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type HandleCheckoutSuccessUserProgressionProgressionIdCheckoutSuccessPostMutationResult =
  NonNullable<Awaited<ReturnType<typeof handleCheckoutSuccess>>>;
export type HandleCheckoutSuccessUserProgressionProgressionIdCheckoutSuccessPostMutationBody =
  CheckoutSuccessRequest;
export type HandleCheckoutSuccessUserProgressionProgressionIdCheckoutSuccessPostMutationError =
  HTTPValidationError;

/**
 * @summary Handle Checkout Success
 */
export const useHandleCheckoutSuccess = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof handleCheckoutSuccess>>,
      TError,
      { progressionId: string; data: CheckoutSuccessRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof handleCheckoutSuccess>>,
  TError,
  { progressionId: string; data: CheckoutSuccessRequest },
  TContext
> => {
  return useMutation(
    getHandleCheckoutSuccessMutationOptions(options),
    queryClient,
  );
};

/**
 * Return the caller's current entitlement state, reduced from their event ledger.
 * @summary Get User Entitlements
 */
export const getUserEntitlements = (signal?: AbortSignal) => {
  return orvalClient<EntitlementState>({
    url: `/user/entitlements/`,
    method: "GET",
    signal,
  });
};

export const getGetUserEntitlementsQueryKey = () => {
  return [`/user/entitlements/`] as const;
};

export const getGetUserEntitlementsQueryOptions = <
  TData = Awaited<ReturnType<typeof getUserEntitlements>>,
  TError = HTTPValidationError,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getUserEntitlements>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetUserEntitlementsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getUserEntitlements>>
  > = ({ signal }) => getUserEntitlements(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUserEntitlements>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetUserEntitlementsUserEntitlementsGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUserEntitlements>>
>;
export type GetUserEntitlementsUserEntitlementsGetQueryError =
  HTTPValidationError;

export function useGetUserEntitlements<
  TData = Awaited<ReturnType<typeof getUserEntitlements>>,
  TError = HTTPValidationError,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserEntitlements>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserEntitlements>>,
          TError,
          Awaited<ReturnType<typeof getUserEntitlements>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUserEntitlements<
  TData = Awaited<ReturnType<typeof getUserEntitlements>>,
  TError = HTTPValidationError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserEntitlements>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserEntitlements>>,
          TError,
          Awaited<ReturnType<typeof getUserEntitlements>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUserEntitlements<
  TData = Awaited<ReturnType<typeof getUserEntitlements>>,
  TError = HTTPValidationError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserEntitlements>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get User Entitlements
 */

export function useGetUserEntitlements<
  TData = Awaited<ReturnType<typeof getUserEntitlements>>,
  TError = HTTPValidationError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserEntitlements>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetUserEntitlementsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Get curai conversations and clinical outreach conversations for a Nori user.
 * @summary Get Clinical Data Elements
 */
export const getClinicalDataElements = (signal?: AbortSignal) => {
  return orvalClient<ClinicalElementsResponse>({
    url: `/data-privacy/clinical`,
    method: "GET",
    signal,
  });
};

export const getGetClinicalDataElementsQueryKey = () => {
  return [`/data-privacy/clinical`] as const;
};

export const getGetClinicalDataElementsQueryOptions = <
  TData = Awaited<ReturnType<typeof getClinicalDataElements>>,
  TError = HTTPValidationError,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getClinicalDataElements>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetClinicalDataElementsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getClinicalDataElements>>
  > = ({ signal }) => getClinicalDataElements(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getClinicalDataElements>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetClinicalDataElementsDataPrivacyClinicalGetQueryResult =
  NonNullable<Awaited<ReturnType<typeof getClinicalDataElements>>>;
export type GetClinicalDataElementsDataPrivacyClinicalGetQueryError =
  HTTPValidationError;

export function useGetClinicalDataElements<
  TData = Awaited<ReturnType<typeof getClinicalDataElements>>,
  TError = HTTPValidationError,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClinicalDataElements>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClinicalDataElements>>,
          TError,
          Awaited<ReturnType<typeof getClinicalDataElements>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetClinicalDataElements<
  TData = Awaited<ReturnType<typeof getClinicalDataElements>>,
  TError = HTTPValidationError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClinicalDataElements>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClinicalDataElements>>,
          TError,
          Awaited<ReturnType<typeof getClinicalDataElements>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetClinicalDataElements<
  TData = Awaited<ReturnType<typeof getClinicalDataElements>>,
  TError = HTTPValidationError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClinicalDataElements>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Clinical Data Elements
 */

export function useGetClinicalDataElements<
  TData = Awaited<ReturnType<typeof getClinicalDataElements>>,
  TError = HTTPValidationError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClinicalDataElements>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetClinicalDataElementsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Archive curai conversations, delete all associated events, delete outreach conversations and their associated events,
 * and archive clinic request events associated with nori conversations
 * @summary Delete Clinical Data Elements
 */
export const deleteClinicalDataElements = (
  deleteClinicalDataElementsRequest: DeleteClinicalDataElementsRequest,
  signal?: AbortSignal,
) => {
  return orvalClient<void>({
    url: `/data-privacy/clinical`,
    method: "DELETE",
    headers: { "Content-Type": "application/json" },
    data: deleteClinicalDataElementsRequest,
    signal,
  });
};

export const getDeleteClinicalDataElementsMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteClinicalDataElements>>,
    TError,
    { data: DeleteClinicalDataElementsRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteClinicalDataElements>>,
  TError,
  { data: DeleteClinicalDataElementsRequest },
  TContext
> => {
  const mutationKey = ["deleteClinicalDataElements"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteClinicalDataElements>>,
    { data: DeleteClinicalDataElementsRequest }
  > = (props) => {
    const { data } = props ?? {};

    return deleteClinicalDataElements(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteClinicalDataElementsDataPrivacyClinicalDeleteMutationResult =
  NonNullable<Awaited<ReturnType<typeof deleteClinicalDataElements>>>;
export type DeleteClinicalDataElementsDataPrivacyClinicalDeleteMutationBody =
  DeleteClinicalDataElementsRequest;
export type DeleteClinicalDataElementsDataPrivacyClinicalDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Clinical Data Elements
 */
export const useDeleteClinicalDataElements = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteClinicalDataElements>>,
      TError,
      { data: DeleteClinicalDataElementsRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteClinicalDataElements>>,
  TError,
  { data: DeleteClinicalDataElementsRequest },
  TContext
> => {
  return useMutation(
    getDeleteClinicalDataElementsMutationOptions(options),
    queryClient,
  );
};

/**
 * @summary Get Insurance Carriers
 */
export const getInsuranceCarriers = (
  params: GetInsuranceCarriersZocdocInsuranceCarriersGetParams,
  signal?: AbortSignal,
) => {
  return orvalClient<ZocdocInsuranceCarrier[]>({
    url: `/zocdoc/insurance/carriers`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetInsuranceCarriersQueryKey = (
  params?: GetInsuranceCarriersZocdocInsuranceCarriersGetParams,
) => {
  return [`/zocdoc/insurance/carriers`, ...(params ? [params] : [])] as const;
};

export const getGetInsuranceCarriersQueryOptions = <
  TData = Awaited<ReturnType<typeof getInsuranceCarriers>>,
  TError = HTTPValidationError,
>(
  params: GetInsuranceCarriersZocdocInsuranceCarriersGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getInsuranceCarriers>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetInsuranceCarriersQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getInsuranceCarriers>>
  > = ({ signal }) => getInsuranceCarriers(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getInsuranceCarriers>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetInsuranceCarriersZocdocInsuranceCarriersGetQueryResult =
  NonNullable<Awaited<ReturnType<typeof getInsuranceCarriers>>>;
export type GetInsuranceCarriersZocdocInsuranceCarriersGetQueryError =
  HTTPValidationError;

export function useGetInsuranceCarriers<
  TData = Awaited<ReturnType<typeof getInsuranceCarriers>>,
  TError = HTTPValidationError,
>(
  params: GetInsuranceCarriersZocdocInsuranceCarriersGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getInsuranceCarriers>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInsuranceCarriers>>,
          TError,
          Awaited<ReturnType<typeof getInsuranceCarriers>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetInsuranceCarriers<
  TData = Awaited<ReturnType<typeof getInsuranceCarriers>>,
  TError = HTTPValidationError,
>(
  params: GetInsuranceCarriersZocdocInsuranceCarriersGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getInsuranceCarriers>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInsuranceCarriers>>,
          TError,
          Awaited<ReturnType<typeof getInsuranceCarriers>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetInsuranceCarriers<
  TData = Awaited<ReturnType<typeof getInsuranceCarriers>>,
  TError = HTTPValidationError,
>(
  params: GetInsuranceCarriersZocdocInsuranceCarriersGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getInsuranceCarriers>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Insurance Carriers
 */

export function useGetInsuranceCarriers<
  TData = Awaited<ReturnType<typeof getInsuranceCarriers>>,
  TError = HTTPValidationError,
>(
  params: GetInsuranceCarriersZocdocInsuranceCarriersGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getInsuranceCarriers>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetInsuranceCarriersQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get Insurance Plans
 */
export const getInsurancePlans = (
  params: GetInsurancePlansZocdocInsurancePlansGetParams,
  signal?: AbortSignal,
) => {
  return orvalClient<ZocdocInsurancePlansPage>({
    url: `/zocdoc/insurance/plans`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetInsurancePlansInfiniteQueryKey = (
  params?: GetInsurancePlansZocdocInsurancePlansGetParams,
) => {
  return [
    "infinite",
    `/zocdoc/insurance/plans`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetInsurancePlansQueryKey = (
  params?: GetInsurancePlansZocdocInsurancePlansGetParams,
) => {
  return [`/zocdoc/insurance/plans`, ...(params ? [params] : [])] as const;
};

export const getGetInsurancePlansInfiniteQueryOptions = <
  TData = InfiniteData<
    Awaited<ReturnType<typeof getInsurancePlans>>,
    GetInsurancePlansZocdocInsurancePlansGetParams["page"]
  >,
  TError = HTTPValidationError,
>(
  params: GetInsurancePlansZocdocInsurancePlansGetParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getInsurancePlans>>,
        TError,
        TData,
        QueryKey,
        GetInsurancePlansZocdocInsurancePlansGetParams["page"]
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetInsurancePlansInfiniteQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getInsurancePlans>>,
    QueryKey,
    GetInsurancePlansZocdocInsurancePlansGetParams["page"]
  > = ({ signal, pageParam }) =>
    getInsurancePlans(
      { ...params, page: pageParam ?? params?.["page"] },
      signal,
    );

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getInsurancePlans>>,
    TError,
    TData,
    QueryKey,
    GetInsurancePlansZocdocInsurancePlansGetParams["page"]
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetInsurancePlansZocdocInsurancePlansGetInfiniteQueryResult =
  NonNullable<Awaited<ReturnType<typeof getInsurancePlans>>>;
export type GetInsurancePlansZocdocInsurancePlansGetInfiniteQueryError =
  HTTPValidationError;

export function useGetInsurancePlansInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getInsurancePlans>>,
    GetInsurancePlansZocdocInsurancePlansGetParams["page"]
  >,
  TError = HTTPValidationError,
>(
  params: GetInsurancePlansZocdocInsurancePlansGetParams,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getInsurancePlans>>,
        TError,
        TData,
        QueryKey,
        GetInsurancePlansZocdocInsurancePlansGetParams["page"]
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInsurancePlans>>,
          TError,
          Awaited<ReturnType<typeof getInsurancePlans>>,
          QueryKey
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetInsurancePlansInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getInsurancePlans>>,
    GetInsurancePlansZocdocInsurancePlansGetParams["page"]
  >,
  TError = HTTPValidationError,
>(
  params: GetInsurancePlansZocdocInsurancePlansGetParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getInsurancePlans>>,
        TError,
        TData,
        QueryKey,
        GetInsurancePlansZocdocInsurancePlansGetParams["page"]
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInsurancePlans>>,
          TError,
          Awaited<ReturnType<typeof getInsurancePlans>>,
          QueryKey
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetInsurancePlansInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getInsurancePlans>>,
    GetInsurancePlansZocdocInsurancePlansGetParams["page"]
  >,
  TError = HTTPValidationError,
>(
  params: GetInsurancePlansZocdocInsurancePlansGetParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getInsurancePlans>>,
        TError,
        TData,
        QueryKey,
        GetInsurancePlansZocdocInsurancePlansGetParams["page"]
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Insurance Plans
 */

export function useGetInsurancePlansInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getInsurancePlans>>,
    GetInsurancePlansZocdocInsurancePlansGetParams["page"]
  >,
  TError = HTTPValidationError,
>(
  params: GetInsurancePlansZocdocInsurancePlansGetParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getInsurancePlans>>,
        TError,
        TData,
        QueryKey,
        GetInsurancePlansZocdocInsurancePlansGetParams["page"]
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetInsurancePlansInfiniteQueryOptions(
    params,
    options,
  );

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetInsurancePlansQueryOptions = <
  TData = Awaited<ReturnType<typeof getInsurancePlans>>,
  TError = HTTPValidationError,
>(
  params: GetInsurancePlansZocdocInsurancePlansGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getInsurancePlans>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetInsurancePlansQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getInsurancePlans>>
  > = ({ signal }) => getInsurancePlans(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getInsurancePlans>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetInsurancePlansZocdocInsurancePlansGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getInsurancePlans>>
>;
export type GetInsurancePlansZocdocInsurancePlansGetQueryError =
  HTTPValidationError;

export function useGetInsurancePlans<
  TData = Awaited<ReturnType<typeof getInsurancePlans>>,
  TError = HTTPValidationError,
>(
  params: GetInsurancePlansZocdocInsurancePlansGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getInsurancePlans>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInsurancePlans>>,
          TError,
          Awaited<ReturnType<typeof getInsurancePlans>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetInsurancePlans<
  TData = Awaited<ReturnType<typeof getInsurancePlans>>,
  TError = HTTPValidationError,
>(
  params: GetInsurancePlansZocdocInsurancePlansGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getInsurancePlans>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInsurancePlans>>,
          TError,
          Awaited<ReturnType<typeof getInsurancePlans>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetInsurancePlans<
  TData = Awaited<ReturnType<typeof getInsurancePlans>>,
  TError = HTTPValidationError,
>(
  params: GetInsurancePlansZocdocInsurancePlansGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getInsurancePlans>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Insurance Plans
 */

export function useGetInsurancePlans<
  TData = Awaited<ReturnType<typeof getInsurancePlans>>,
  TError = HTTPValidationError,
>(
  params: GetInsurancePlansZocdocInsurancePlansGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getInsurancePlans>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetInsurancePlansQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get Providers
 */
export const getProviders = (
  params: GetProvidersZocdocProvidersGetParams,
  signal?: AbortSignal,
) => {
  return orvalClient<ZocdocProviderResult[]>({
    url: `/zocdoc/providers`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetProvidersQueryKey = (
  params?: GetProvidersZocdocProvidersGetParams,
) => {
  return [`/zocdoc/providers`, ...(params ? [params] : [])] as const;
};

export const getGetProvidersQueryOptions = <
  TData = Awaited<ReturnType<typeof getProviders>>,
  TError = HTTPValidationError,
>(
  params: GetProvidersZocdocProvidersGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProviders>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetProvidersQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProviders>>> = ({
    signal,
  }) => getProviders(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getProviders>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetProvidersZocdocProvidersGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getProviders>>
>;
export type GetProvidersZocdocProvidersGetQueryError = HTTPValidationError;

export function useGetProviders<
  TData = Awaited<ReturnType<typeof getProviders>>,
  TError = HTTPValidationError,
>(
  params: GetProvidersZocdocProvidersGetParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProviders>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProviders>>,
          TError,
          Awaited<ReturnType<typeof getProviders>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetProviders<
  TData = Awaited<ReturnType<typeof getProviders>>,
  TError = HTTPValidationError,
>(
  params: GetProvidersZocdocProvidersGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProviders>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProviders>>,
          TError,
          Awaited<ReturnType<typeof getProviders>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetProviders<
  TData = Awaited<ReturnType<typeof getProviders>>,
  TError = HTTPValidationError,
>(
  params: GetProvidersZocdocProvidersGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProviders>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Providers
 */

export function useGetProviders<
  TData = Awaited<ReturnType<typeof getProviders>>,
  TError = HTTPValidationError,
>(
  params: GetProvidersZocdocProvidersGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProviders>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetProvidersQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get Availability
 */
export const getAvailability = (
  params: GetAvailabilityZocdocAvailabilityGetParams,
  signal?: AbortSignal,
) => {
  return orvalClient<ZocdocAvailabilityResult>({
    url: `/zocdoc/availability`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetAvailabilityQueryKey = (
  params?: GetAvailabilityZocdocAvailabilityGetParams,
) => {
  return [`/zocdoc/availability`, ...(params ? [params] : [])] as const;
};

export const getGetAvailabilityQueryOptions = <
  TData = Awaited<ReturnType<typeof getAvailability>>,
  TError = HTTPValidationError,
>(
  params: GetAvailabilityZocdocAvailabilityGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAvailability>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAvailabilityQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAvailability>>> = ({
    signal,
  }) => getAvailability(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAvailability>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAvailabilityZocdocAvailabilityGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAvailability>>
>;
export type GetAvailabilityZocdocAvailabilityGetQueryError =
  HTTPValidationError;

export function useGetAvailability<
  TData = Awaited<ReturnType<typeof getAvailability>>,
  TError = HTTPValidationError,
>(
  params: GetAvailabilityZocdocAvailabilityGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAvailability>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAvailability>>,
          TError,
          Awaited<ReturnType<typeof getAvailability>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAvailability<
  TData = Awaited<ReturnType<typeof getAvailability>>,
  TError = HTTPValidationError,
>(
  params: GetAvailabilityZocdocAvailabilityGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAvailability>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAvailability>>,
          TError,
          Awaited<ReturnType<typeof getAvailability>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAvailability<
  TData = Awaited<ReturnType<typeof getAvailability>>,
  TError = HTTPValidationError,
>(
  params: GetAvailabilityZocdocAvailabilityGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAvailability>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Availability
 */

export function useGetAvailability<
  TData = Awaited<ReturnType<typeof getAvailability>>,
  TError = HTTPValidationError,
>(
  params: GetAvailabilityZocdocAvailabilityGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAvailability>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetAvailabilityQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get Provider Reviews
 */
export const getProviderReviews = (
  providerId: string,
  signal?: AbortSignal,
) => {
  return orvalClient<ZocdocProviderReviews>({
    url: `/zocdoc/providers/${providerId}/reviews`,
    method: "GET",
    signal,
  });
};

export const getGetProviderReviewsQueryKey = (providerId: string) => {
  return [`/zocdoc/providers/${providerId}/reviews`] as const;
};

export const getGetProviderReviewsQueryOptions = <
  TData = Awaited<ReturnType<typeof getProviderReviews>>,
  TError = HTTPValidationError,
>(
  providerId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getProviderReviews>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetProviderReviewsQueryKey(providerId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getProviderReviews>>
  > = ({ signal }) => getProviderReviews(providerId, signal);

  return {
    queryKey,
    queryFn,
    enabled: providerId !== null && providerId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getProviderReviews>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetProviderReviewsZocdocProvidersProviderIdReviewsGetQueryResult =
  NonNullable<Awaited<ReturnType<typeof getProviderReviews>>>;
export type GetProviderReviewsZocdocProvidersProviderIdReviewsGetQueryError =
  HTTPValidationError;

export function useGetProviderReviews<
  TData = Awaited<ReturnType<typeof getProviderReviews>>,
  TError = HTTPValidationError,
>(
  providerId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getProviderReviews>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProviderReviews>>,
          TError,
          Awaited<ReturnType<typeof getProviderReviews>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetProviderReviews<
  TData = Awaited<ReturnType<typeof getProviderReviews>>,
  TError = HTTPValidationError,
>(
  providerId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getProviderReviews>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProviderReviews>>,
          TError,
          Awaited<ReturnType<typeof getProviderReviews>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetProviderReviews<
  TData = Awaited<ReturnType<typeof getProviderReviews>>,
  TError = HTTPValidationError,
>(
  providerId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getProviderReviews>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Provider Reviews
 */

export function useGetProviderReviews<
  TData = Awaited<ReturnType<typeof getProviderReviews>>,
  TError = HTTPValidationError,
>(
  providerId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getProviderReviews>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetProviderReviewsQueryOptions(providerId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Primarily used so FrontendSideEffectPayload is exposed in OpenAPI and can be converted to Typescript using Orval
 * @summary Get Frontend Side Effect
 */
export const getFrontendSideEffect = (signal?: AbortSignal) => {
  return orvalClient<FrontendSideEffectEvent>({
    url: `/dev/frontend-side-effect`,
    method: "GET",
    signal,
  });
};

export const getGetFrontendSideEffectQueryKey = () => {
  return [`/dev/frontend-side-effect`] as const;
};

export const getGetFrontendSideEffectQueryOptions = <
  TData = Awaited<ReturnType<typeof getFrontendSideEffect>>,
  TError = HTTPValidationError,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getFrontendSideEffect>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetFrontendSideEffectQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getFrontendSideEffect>>
  > = ({ signal }) => getFrontendSideEffect(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getFrontendSideEffect>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetFrontendSideEffectDevFrontendSideEffectGetQueryResult =
  NonNullable<Awaited<ReturnType<typeof getFrontendSideEffect>>>;
export type GetFrontendSideEffectDevFrontendSideEffectGetQueryError =
  HTTPValidationError;

export function useGetFrontendSideEffect<
  TData = Awaited<ReturnType<typeof getFrontendSideEffect>>,
  TError = HTTPValidationError,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getFrontendSideEffect>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFrontendSideEffect>>,
          TError,
          Awaited<ReturnType<typeof getFrontendSideEffect>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetFrontendSideEffect<
  TData = Awaited<ReturnType<typeof getFrontendSideEffect>>,
  TError = HTTPValidationError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getFrontendSideEffect>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFrontendSideEffect>>,
          TError,
          Awaited<ReturnType<typeof getFrontendSideEffect>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetFrontendSideEffect<
  TData = Awaited<ReturnType<typeof getFrontendSideEffect>>,
  TError = HTTPValidationError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getFrontendSideEffect>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Frontend Side Effect
 */

export function useGetFrontendSideEffect<
  TData = Awaited<ReturnType<typeof getFrontendSideEffect>>,
  TError = HTTPValidationError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getFrontendSideEffect>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetFrontendSideEffectQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Create ClinicRequest, CLINIC_REQUEST Event, Memory (subjective shareback),
 * RX_ELIGIBILITY Event, and populate user profile so you can test submitting
 * an async RX visit via POST /clinic/visit/async-request.
 * @summary Stage Async Rx Clinic Request Flow
 */
export const stageAsyncRxClinicRequestFlow = (
  noriConversationId: string,
  signal?: AbortSignal,
) => {
  return orvalClient<unknown>({
    url: `/manual-test/async-rx/${noriConversationId}`,
    method: "POST",
    signal,
  });
};

export const getStageAsyncRxClinicRequestFlowMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof stageAsyncRxClinicRequestFlow>>,
    TError,
    { noriConversationId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof stageAsyncRxClinicRequestFlow>>,
  TError,
  { noriConversationId: string },
  TContext
> => {
  const mutationKey = ["stageAsyncRxClinicRequestFlow"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof stageAsyncRxClinicRequestFlow>>,
    { noriConversationId: string }
  > = (props) => {
    const { noriConversationId } = props ?? {};

    return stageAsyncRxClinicRequestFlow(noriConversationId);
  };

  return { mutationFn, ...mutationOptions };
};

export type StageAsyncRXClinicRequestFlowManualTestAsyncRxNoriConversationIdPostMutationResult =
  NonNullable<Awaited<ReturnType<typeof stageAsyncRxClinicRequestFlow>>>;

export type StageAsyncRXClinicRequestFlowManualTestAsyncRxNoriConversationIdPostMutationError =
  HTTPValidationError;

/**
 * @summary Stage Async Rx Clinic Request Flow
 */
export const useStageAsyncRxClinicRequestFlow = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof stageAsyncRxClinicRequestFlow>>,
      TError,
      { noriConversationId: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof stageAsyncRxClinicRequestFlow>>,
  TError,
  { noriConversationId: string },
  TContext
> => {
  return useMutation(
    getStageAsyncRxClinicRequestFlowMutationOptions(options),
    queryClient,
  );
};

/**
 * Create a VISIT CLINIC_REQUEST event that opens the paywall visit user progression.
 * This is a local/dev-only scaffold for working on the payments progression
 * before it is wired into a production flow.
 *
 * Requires a catalog already synced from Stripe (just sync-entitlement-products --execute).
 * @summary Stage Paywall Visit User Progression Flow
 */
export const stagePaywallVisitUserProgressionFlow = (
  noriConversationId: string,
  signal?: AbortSignal,
) => {
  return orvalClient<unknown>({
    url: `/manual-test/paywall-visit/${noriConversationId}`,
    method: "POST",
    signal,
  });
};

export const getStagePaywallVisitUserProgressionFlowMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof stagePaywallVisitUserProgressionFlow>>,
    TError,
    { noriConversationId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof stagePaywallVisitUserProgressionFlow>>,
  TError,
  { noriConversationId: string },
  TContext
> => {
  const mutationKey = ["stagePaywallVisitUserProgressionFlow"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof stagePaywallVisitUserProgressionFlow>>,
    { noriConversationId: string }
  > = (props) => {
    const { noriConversationId } = props ?? {};

    return stagePaywallVisitUserProgressionFlow(noriConversationId);
  };

  return { mutationFn, ...mutationOptions };
};

export type StagePaywallVisitUserProgressionFlowManualTestPaywallVisitNoriConversationIdPostMutationResult =
  NonNullable<Awaited<ReturnType<typeof stagePaywallVisitUserProgressionFlow>>>;

export type StagePaywallVisitUserProgressionFlowManualTestPaywallVisitNoriConversationIdPostMutationError =
  HTTPValidationError;

/**
 * @summary Stage Paywall Visit User Progression Flow
 */
export const useStagePaywallVisitUserProgressionFlow = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof stagePaywallVisitUserProgressionFlow>>,
      TError,
      { noriConversationId: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof stagePaywallVisitUserProgressionFlow>>,
  TError,
  { noriConversationId: string },
  TContext
> => {
  return useMutation(
    getStagePaywallVisitUserProgressionFlowMutationOptions(options),
    queryClient,
  );
};

/**
 * Create all events needed to test an async DX clinic visit:
 * @summary Stage Async Dx Clinic Request Flow
 */
export const stageAsyncDxClinicRequestFlow = (
  noriConversationId: string,
  signal?: AbortSignal,
) => {
  return orvalClient<unknown>({
    url: `/manual-test/async-dx/${noriConversationId}`,
    method: "POST",
    signal,
  });
};

export const getStageAsyncDxClinicRequestFlowMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof stageAsyncDxClinicRequestFlow>>,
    TError,
    { noriConversationId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof stageAsyncDxClinicRequestFlow>>,
  TError,
  { noriConversationId: string },
  TContext
> => {
  const mutationKey = ["stageAsyncDxClinicRequestFlow"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof stageAsyncDxClinicRequestFlow>>,
    { noriConversationId: string }
  > = (props) => {
    const { noriConversationId } = props ?? {};

    return stageAsyncDxClinicRequestFlow(noriConversationId);
  };

  return { mutationFn, ...mutationOptions };
};

export type StageAsyncDXClinicRequestFlowManualTestAsyncDxNoriConversationIdPostMutationResult =
  NonNullable<Awaited<ReturnType<typeof stageAsyncDxClinicRequestFlow>>>;

export type StageAsyncDXClinicRequestFlowManualTestAsyncDxNoriConversationIdPostMutationError =
  HTTPValidationError;

/**
 * @summary Stage Async Dx Clinic Request Flow
 */
export const useStageAsyncDxClinicRequestFlow = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof stageAsyncDxClinicRequestFlow>>,
      TError,
      { noriConversationId: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof stageAsyncDxClinicRequestFlow>>,
  TError,
  { noriConversationId: string },
  TContext
> => {
  return useMutation(
    getStageAsyncDxClinicRequestFlowMutationOptions(options),
    queryClient,
  );
};

/**
 * Create ClinicRequest, CLINIC_REQUEST Event, Memory (subjective shareback),
 * RX_ELIGIBILITY Event, RX_RENEWAL_SELECTED_MEDICATION Event,
 * and populate user profile so you can test submitting an rx renewal visit.
 * @summary Stage Rx Renewal Clinic Request Flow
 */
export const stageRxRenewalClinicRequestFlow = (
  noriConversationId: string,
  signal?: AbortSignal,
) => {
  return orvalClient<unknown>({
    url: `/manual-test/rx-renewal/${noriConversationId}`,
    method: "POST",
    signal,
  });
};

export const getStageRxRenewalClinicRequestFlowMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof stageRxRenewalClinicRequestFlow>>,
    TError,
    { noriConversationId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof stageRxRenewalClinicRequestFlow>>,
  TError,
  { noriConversationId: string },
  TContext
> => {
  const mutationKey = ["stageRxRenewalClinicRequestFlow"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof stageRxRenewalClinicRequestFlow>>,
    { noriConversationId: string }
  > = (props) => {
    const { noriConversationId } = props ?? {};

    return stageRxRenewalClinicRequestFlow(noriConversationId);
  };

  return { mutationFn, ...mutationOptions };
};

export type StageRxRenewalClinicRequestFlowManualTestRxRenewalNoriConversationIdPostMutationResult =
  NonNullable<Awaited<ReturnType<typeof stageRxRenewalClinicRequestFlow>>>;

export type StageRxRenewalClinicRequestFlowManualTestRxRenewalNoriConversationIdPostMutationError =
  HTTPValidationError;

/**
 * @summary Stage Rx Renewal Clinic Request Flow
 */
export const useStageRxRenewalClinicRequestFlow = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof stageRxRenewalClinicRequestFlow>>,
      TError,
      { noriConversationId: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof stageRxRenewalClinicRequestFlow>>,
  TError,
  { noriConversationId: string },
  TContext
> => {
  return useMutation(
    getStageRxRenewalClinicRequestFlowMutationOptions(options),
    queryClient,
  );
};

/**
 * Put a UserProgram in PENDING_CLINIC_APPROVAL and run enroll, firing the $align workflow.
 *
 * Stands in for the visit-close approval that will drive enrollment in production.
 * @summary Test Access Enroll
 */
export const testAccessEnroll = (program: ProgramID, signal?: AbortSignal) => {
  return orvalClient<void>({
    url: `/manual-test/access/enroll/${program}`,
    method: "POST",
    signal,
  });
};

export const getTestAccessEnrollMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof testAccessEnroll>>,
    TError,
    { program: ProgramID },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof testAccessEnroll>>,
  TError,
  { program: ProgramID },
  TContext
> => {
  const mutationKey = ["testAccessEnroll"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof testAccessEnroll>>,
    { program: ProgramID }
  > = (props) => {
    const { program } = props ?? {};

    return testAccessEnroll(program);
  };

  return { mutationFn, ...mutationOptions };
};

export type TestACCESSEnrollManualTestAccessEnrollProgramPostMutationResult =
  NonNullable<Awaited<ReturnType<typeof testAccessEnroll>>>;

export type TestACCESSEnrollManualTestAccessEnrollProgramPostMutationError =
  HTTPValidationError;

/**
 * @summary Test Access Enroll
 */
export const useTestAccessEnroll = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof testAccessEnroll>>,
      TError,
      { program: ProgramID },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof testAccessEnroll>>,
  TError,
  { program: ProgramID },
  TContext
> => {
  return useMutation(getTestAccessEnrollMutationOptions(options), queryClient);
};

/**
 * Stage an async clinic request (RX / DX / renewal) whose card opens the
 * ``paywall_async_visit`` progression — payment selection + Stripe checkout before the async
 * submit. Local/dev-only scaffold for the async side of the payments flow.
 *
 * ``async_type`` is chosen here because it's set by clinical context in prod, not the end
 * user; it rides on ``ClinicRequest.type`` and threads to ``encounter_type`` at submit, which
 * fixes the async product the paywall sells. VISIT is excluded (it renders the sync branch).
 * @summary Stage Paywall Async Visit User Progression Flow
 */
export const stagePaywallAsyncVisitUserProgressionFlow = (
  noriConversationId: string,
  params?: StagePaywallAsyncVisitUserProgressionFlowManualTestPaywallAsyncVisitNoriConversationIdPostParams,
  signal?: AbortSignal,
) => {
  return orvalClient<unknown>({
    url: `/manual-test/paywall-async-visit/${noriConversationId}`,
    method: "POST",
    params,
    signal,
  });
};

export const getStagePaywallAsyncVisitUserProgressionFlowMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof stagePaywallAsyncVisitUserProgressionFlow>>,
    TError,
    {
      noriConversationId: string;
      params?: StagePaywallAsyncVisitUserProgressionFlowManualTestPaywallAsyncVisitNoriConversationIdPostParams;
    },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof stagePaywallAsyncVisitUserProgressionFlow>>,
  TError,
  {
    noriConversationId: string;
    params?: StagePaywallAsyncVisitUserProgressionFlowManualTestPaywallAsyncVisitNoriConversationIdPostParams;
  },
  TContext
> => {
  const mutationKey = ["stagePaywallAsyncVisitUserProgressionFlow"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof stagePaywallAsyncVisitUserProgressionFlow>>,
    {
      noriConversationId: string;
      params?: StagePaywallAsyncVisitUserProgressionFlowManualTestPaywallAsyncVisitNoriConversationIdPostParams;
    }
  > = (props) => {
    const { noriConversationId, params } = props ?? {};

    return stagePaywallAsyncVisitUserProgressionFlow(
      noriConversationId,
      params,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type StagePaywallAsyncVisitUserProgressionFlowManualTestPaywallAsyncVisitNoriConversationIdPostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof stagePaywallAsyncVisitUserProgressionFlow>>
  >;

export type StagePaywallAsyncVisitUserProgressionFlowManualTestPaywallAsyncVisitNoriConversationIdPostMutationError =
  HTTPValidationError;

/**
 * @summary Stage Paywall Async Visit User Progression Flow
 */
export const useStagePaywallAsyncVisitUserProgressionFlow = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof stagePaywallAsyncVisitUserProgressionFlow>>,
      TError,
      {
        noriConversationId: string;
        params?: StagePaywallAsyncVisitUserProgressionFlowManualTestPaywallAsyncVisitNoriConversationIdPostParams;
      },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof stagePaywallAsyncVisitUserProgressionFlow>>,
  TError,
  {
    noriConversationId: string;
    params?: StagePaywallAsyncVisitUserProgressionFlowManualTestPaywallAsyncVisitNoriConversationIdPostParams;
  },
  TContext
> => {
  return useMutation(
    getStagePaywallAsyncVisitUserProgressionFlowMutationOptions(options),
    queryClient,
  );
};

/**
 * Get the current time-travel offset for the authenticated user.
 * @summary Get Time Travel Offset
 */
export const getTimeTravelOffset = (signal?: AbortSignal) => {
  return orvalClient<TimeTravelResponse>({
    url: `/manual-test/time-travel`,
    method: "GET",
    signal,
  });
};

export const getGetTimeTravelOffsetQueryKey = () => {
  return [`/manual-test/time-travel`] as const;
};

export const getGetTimeTravelOffsetQueryOptions = <
  TData = Awaited<ReturnType<typeof getTimeTravelOffset>>,
  TError = HTTPValidationError,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getTimeTravelOffset>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTimeTravelOffsetQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTimeTravelOffset>>
  > = ({ signal }) => getTimeTravelOffset(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTimeTravelOffset>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetTimeTravelOffsetManualTestTimeTravelGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTimeTravelOffset>>
>;
export type GetTimeTravelOffsetManualTestTimeTravelGetQueryError =
  HTTPValidationError;

export function useGetTimeTravelOffset<
  TData = Awaited<ReturnType<typeof getTimeTravelOffset>>,
  TError = HTTPValidationError,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTimeTravelOffset>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTimeTravelOffset>>,
          TError,
          Awaited<ReturnType<typeof getTimeTravelOffset>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTimeTravelOffset<
  TData = Awaited<ReturnType<typeof getTimeTravelOffset>>,
  TError = HTTPValidationError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTimeTravelOffset>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTimeTravelOffset>>,
          TError,
          Awaited<ReturnType<typeof getTimeTravelOffset>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTimeTravelOffset<
  TData = Awaited<ReturnType<typeof getTimeTravelOffset>>,
  TError = HTTPValidationError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTimeTravelOffset>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Time Travel Offset
 */

export function useGetTimeTravelOffset<
  TData = Awaited<ReturnType<typeof getTimeTravelOffset>>,
  TError = HTTPValidationError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTimeTravelOffset>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetTimeTravelOffsetQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Clear the time-travel offset for the authenticated user.
 * @summary Clear Time Travel Offset
 */
export const clearTimeTravelOffset = (signal?: AbortSignal) => {
  return orvalClient<TimeTravelResponse>({
    url: `/manual-test/time-travel`,
    method: "DELETE",
    signal,
  });
};

export const getClearTimeTravelOffsetMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof clearTimeTravelOffset>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof clearTimeTravelOffset>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["clearTimeTravelOffset"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof clearTimeTravelOffset>>,
    void
  > = () => {
    return clearTimeTravelOffset();
  };

  return { mutationFn, ...mutationOptions };
};

export type ClearTimeTravelOffsetManualTestTimeTravelDeleteMutationResult =
  NonNullable<Awaited<ReturnType<typeof clearTimeTravelOffset>>>;

export type ClearTimeTravelOffsetManualTestTimeTravelDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Clear Time Travel Offset
 */
export const useClearTimeTravelOffset = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof clearTimeTravelOffset>>,
      TError,
      void,
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof clearTimeTravelOffset>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getClearTimeTravelOffsetMutationOptions(options),
    queryClient,
  );
};

/**
 * Set time offset and signal active post chat temporal workflows to fire immediately.
 * Expires pending notifications whose send_at is before the simulated now.
 * @summary Fast Forward Time Travel
 */
export const fastForwardTimeTravel = (
  timeTravelFastForwardRequest: TimeTravelFastForwardRequest,
  signal?: AbortSignal,
) => {
  return orvalClient<TimeTravelFastForwardResponse>({
    url: `/manual-test/time-travel`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: timeTravelFastForwardRequest,
    signal,
  });
};

export const getFastForwardTimeTravelMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof fastForwardTimeTravel>>,
    TError,
    { data: TimeTravelFastForwardRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof fastForwardTimeTravel>>,
  TError,
  { data: TimeTravelFastForwardRequest },
  TContext
> => {
  const mutationKey = ["fastForwardTimeTravel"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof fastForwardTimeTravel>>,
    { data: TimeTravelFastForwardRequest }
  > = (props) => {
    const { data } = props ?? {};

    return fastForwardTimeTravel(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type FastForwardTimeTravelManualTestTimeTravelPostMutationResult =
  NonNullable<Awaited<ReturnType<typeof fastForwardTimeTravel>>>;
export type FastForwardTimeTravelManualTestTimeTravelPostMutationBody =
  TimeTravelFastForwardRequest;
export type FastForwardTimeTravelManualTestTimeTravelPostMutationError =
  HTTPValidationError;

/**
 * @summary Fast Forward Time Travel
 */
export const useFastForwardTimeTravel = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof fastForwardTimeTravel>>,
      TError,
      { data: TimeTravelFastForwardRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof fastForwardTimeTravel>>,
  TError,
  { data: TimeTravelFastForwardRequest },
  TContext
> => {
  return useMutation(
    getFastForwardTimeTravelMutationOptions(options),
    queryClient,
  );
};

/**
 * Dev view of the user's SMS thread: their inbound texts (USER events from
 * their SMS conversation) merged with every outbound SMS notification we sent,
 * ordered oldest-first as a single conversation.
 * @summary Get Sms Timeline
 */
export const getSmsTimeline = (signal?: AbortSignal) => {
  return orvalClient<SmsTimelineResponse>({
    url: `/manual-test/sms-timeline`,
    method: "GET",
    signal,
  });
};

export const getGetSmsTimelineQueryKey = () => {
  return [`/manual-test/sms-timeline`] as const;
};

export const getGetSmsTimelineQueryOptions = <
  TData = Awaited<ReturnType<typeof getSmsTimeline>>,
  TError = HTTPValidationError,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getSmsTimeline>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSmsTimelineQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSmsTimeline>>> = ({
    signal,
  }) => getSmsTimeline(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSmsTimeline>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetSMSTimelineManualTestSmsTimelineGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSmsTimeline>>
>;
export type GetSMSTimelineManualTestSmsTimelineGetQueryError =
  HTTPValidationError;

export function useGetSmsTimeline<
  TData = Awaited<ReturnType<typeof getSmsTimeline>>,
  TError = HTTPValidationError,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSmsTimeline>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSmsTimeline>>,
          TError,
          Awaited<ReturnType<typeof getSmsTimeline>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSmsTimeline<
  TData = Awaited<ReturnType<typeof getSmsTimeline>>,
  TError = HTTPValidationError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSmsTimeline>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSmsTimeline>>,
          TError,
          Awaited<ReturnType<typeof getSmsTimeline>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSmsTimeline<
  TData = Awaited<ReturnType<typeof getSmsTimeline>>,
  TError = HTTPValidationError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSmsTimeline>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Sms Timeline
 */

export function useGetSmsTimeline<
  TData = Awaited<ReturnType<typeof getSmsTimeline>>,
  TError = HTTPValidationError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSmsTimeline>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetSmsTimelineQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Inject a message as if the user texted in, routing it through the real
 * inbound SMS path (ProcessSMSMessageWorkflow). Unlike the webhook, this skips
 * the STOP/START keyword and should_process_sms_reply gating so a dev message
 * always processes. The reply is produced asynchronously by the workflow.
 * @summary Send Sms Message
 */
export const sendSmsMessage = (
  smsTimelineSendRequest: SmsTimelineSendRequest,
  signal?: AbortSignal,
) => {
  return orvalClient<unknown>({
    url: `/manual-test/sms-message`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: smsTimelineSendRequest,
    signal,
  });
};

export const getSendSmsMessageMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendSmsMessage>>,
    TError,
    { data: SmsTimelineSendRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sendSmsMessage>>,
  TError,
  { data: SmsTimelineSendRequest },
  TContext
> => {
  const mutationKey = ["sendSmsMessage"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sendSmsMessage>>,
    { data: SmsTimelineSendRequest }
  > = (props) => {
    const { data } = props ?? {};

    return sendSmsMessage(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type SendSMSMessageManualTestSmsMessagePostMutationResult = NonNullable<
  Awaited<ReturnType<typeof sendSmsMessage>>
>;
export type SendSMSMessageManualTestSmsMessagePostMutationBody =
  SmsTimelineSendRequest;
export type SendSMSMessageManualTestSmsMessagePostMutationError =
  HTTPValidationError;

/**
 * @summary Send Sms Message
 */
export const useSendSmsMessage = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof sendSmsMessage>>,
      TError,
      { data: SmsTimelineSendRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof sendSmsMessage>>,
  TError,
  { data: SmsTimelineSendRequest },
  TContext
> => {
  return useMutation(getSendSmsMessageMutationOptions(options), queryClient);
};
